var utils = require('./tripletrax.utils.js');
var ajax = require('./tripletrax.ajax.js');
var nestable = require('./tripletrax.nestable.js');
var access = require('./tripletrax.access.js');
var patients = require('./tripletrax.patients.js');
var views = require('./tripletrax.views.js');
var changes = require('./tripletrax.changes.js');
var initialize = require('./tripletrax.initialize.js');
var mails = require('./tripletrax.mails.js');
var integrities = require('./tripletrax.integrities.js');

function validatorMethods() {

    $.validator.prototype.resetForm = function () {
        if ($.fn.resetForm) {
            $(this.currentForm).resetForm();
        }
        $(this.currentForm)[0].reset();
        this.submitted = {};
        this.lastElement = null;
        this.prepareForm();
        this.hideErrors();
        var elements = this.elements().removeData("previousValue").removeAttr("aria-invalid");
        if (this.settings.unhighlight) {
            for (var i = 0; elements[i]; i++) {
                this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, this.settings.validClass);
            }
        }
    }

    $.validator.addMethod(
        "minNonAlpha",
        function (value, element, param) {

            var count = 0;
            var array = value.split("");
            jQuery.each(array, function (i, val) {
                if (!/^[a-zA-Z]+$/.test(val)) {
                    count++;
                }
            });
            return this.optional(element) || count >= param;
        },
        Lang.get('tripletrax.field_non_alpha', { "min": "{0}" })
    );

    $.validator.addMethod(
        "validText",
        function (value, element, param) {
            var valid = true;

            var pattern = new RegExp("^[" + param + "]+$");
            var array = value.split("");
            jQuery.each(array, function (i, val) {
                if (pattern.test(val)) {
                    valid = false;
                    return;
                }
            });

            pattern = null;
            return this.optional(element) || valid;
        },
        Lang.get('tripletrax.no_valid_text', { "characters": "{0}" })
    );

    $.validator.addMethod(
        "validUsername",
        function (value, element) {

            if (/^[-_\.]+$/.test(value)) {
                return false;
            }

            return this.optional(element) || /^[a-zA-Z0-9-_\.]+$/.test(value);
        },
        Lang.get('tripletrax.no_valid_username')
    );

    $.validator.addMethod(
        "uniqueUsername",
        function (value, element) {
            var attrAction = element.getAttribute('data-action');
            if (utils.isUndefined(attrAction)) {
                return false;
            }

            var data = null;
            var attrOrigValue = element.getAttribute('data-orig-value');
            if (!utils.isUndefined(attrOrigValue)) {
                data = "origValue=" + encodeURIComponent(attrOrigValue);
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: attrAction + "/" + encodeURIComponent(value),
                data: data
            });
        },
        Lang.get('tripletrax.username_exists')
    );

    $.validator.addMethod(
        "uniqueFacilityname",
        function (value, element) {
            var attrAction = element.getAttribute('data-action');
            if (utils.isUndefined(attrAction)) {
                return false;
            }

            var data = null;
            var attrOrigValue = element.getAttribute('data-orig-value');
            if (!utils.isUndefined(attrOrigValue)) {
                data = "origValue=" + encodeURIComponent(attrOrigValue);
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: attrAction + "/n_" + encodeURIComponent(value),
                data: data
            });
        },
        Lang.get('tripletrax.facilityname_exists')
    );

    $.validator.addMethod(
        "uniqueFacilityid",
        function (value, element) {
            var attrAction = element.getAttribute('data-action');
            if (utils.isUndefined(attrAction)) {
                return false;
            }

            var data = null;
            var attrOrigValue = element.getAttribute('data-orig-value');
            if (!utils.isUndefined(attrOrigValue)) {
                data = "origValue=" + encodeURIComponent(attrOrigValue);
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: attrAction + "/i_" + encodeURIComponent(value),
                data: data
            });
        },
        Lang.get('tripletrax.facilityid_exists')
    );

    $.validator.addMethod(
        "uniqueRolename",
        function (value, element) {
            var attrAction = element.getAttribute('data-action');
            if (utils.isUndefined(attrAction)) {
                return false;
            }

            var data = null;
            var attrOrigValue = element.getAttribute('data-orig-value');
            if (!utils.isUndefined(attrOrigValue)) {
                data = "origValue=" + encodeURIComponent(attrOrigValue);
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: attrAction + "/" + encodeURIComponent(value),
                data: data
            });
        },
        Lang.get('tripletrax.rolename_exists')
    );

    $.validator.addMethod(
        "atLeastOneRole",
        function (value, element) {
            var valid = false;
            $("input:checked", $(element).parents('.tt-content-datatable').find('.tt-datatable-dialog').dataTable().fnGetNodes()).each(function () {
                valid = true;
                return false;
            });

            return valid;
        },
        Lang.get('tripletrax.at_least_one_role_selected')
    );

    $.validator.addMethod(
        "existingFacility",
        function (value, element) {
            var valid = true;

            if ($('#content-detail').find('.tt-content-datatable').find('.tt-selected-id').val() === "") {
                var select2 = $(element).parents('.tt-content-dialog').find('.tt-select2').select2('data')[0];
                jQuery.each($('#table_users_roles').dataTable().fnGetData(), function (i, val) {
                    if (val[0] === select2.id) {
                        valid = false;
                        return false;
                    }
                });
            }

            return valid;
        },
        Lang.get('tripletrax.facility_exists')
    );

    $.validator.addMethod(
        "uniqueModel",
        function (value, element) {
            var attrAction = element.getAttribute('data-action');
            if (utils.isUndefined(attrAction)) {
                return false;
            }

            var data = null;
            var attrOrigValue = element.getAttribute('data-orig-value');
            if (!utils.isUndefined(attrOrigValue)) {
                data = "origValue=" + encodeURIComponent(attrOrigValue);
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: attrAction + "/m_" + encodeURIComponent(value),
                data: data
            });
        },
        Lang.get('tripletrax.model_exists')
    );

    $.validator.addMethod(
        "uniqueAgreementDescription",
        function (value, element) {
            var attrAction = element.getAttribute('data-action');
            if (utils.isUndefined(attrAction)) {
                return false;
            }

            var data = null;
            var attrOrigValue = element.getAttribute('data-orig-value');
            if (!utils.isUndefined(attrOrigValue)) {
                data = "origValue=" + encodeURIComponent(attrOrigValue);
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: attrAction + "/" + encodeURIComponent(value),
                data: data
            });
        },
        Lang.get('tripletrax.agreement_description_exists')
    );

    var validAgreementDataCollectionTypes = '';
    $.validator.addMethod(
        "agreementDataCollectionTypeOnlyInOneValidAgreement",
        function (value, element, param) {
            var valid = true;
            validAgreementDataCollectionTypes = '';

            var validTill = $(element).parents('form').find('.tt-agreement-valid-till').val();
            if (!utils.isUndefined(validTill) && validTill !== "") {
                return true;
            }

            var id = $(element).parents('form').find('.tt-selected-id').val();
            var dataCollectionTypes = $(element).select2('data');

            if (utils.isUndefined(dataCollectionTypes) || dataCollectionTypes.length <= 0) {
                return true;
            }

            jQuery.each($('#table_agreement_types').dataTable().fnGetData(), function (i, val) {
                if (String(val[0]) !== id && val[4] === null) {
                    var currentDataCollectionTypes = val[5].split('|');
                    jQuery.each(dataCollectionTypes, function (j, dataCollectionType) {
                       if (jQuery.inArray(dataCollectionType.id, currentDataCollectionTypes) > -1) {
                           if (validAgreementDataCollectionTypes !== "") {
                               validAgreementDataCollectionTypes += ", ";
                           }
                           validAgreementDataCollectionTypes += "\"" + dataCollectionType.text + "\"";

                           valid = false;
                       }
                    });
                }
            });

            return valid;
        },
        function() { return Lang.get('tripletrax.agreement_models_only_in_one_valid_agreement', { "data_collection_types": validAgreementDataCollectionTypes }); }
    );

    $.validator.addMethod(
        "uniqueMonitoring",
        function (value, element) {
            var attrAction = element.getAttribute('data-action');
            if (utils.isUndefined(attrAction)) {
                return false;
            }

            var data = null;
            var attrOrigValue = element.getAttribute('data-orig-value');
            if (!utils.isUndefined(attrOrigValue)) {
                data = "origValue=" + encodeURIComponent(attrOrigValue);
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: attrAction + "/" + encodeURIComponent(value),
                data: data
            });
        },
        Lang.get('tripletrax.monitoring_exists')
    );

    $.validator.addMethod(
        "uniqueAbbreviation",
        function (value, element) {
            var attrAction = element.getAttribute('data-action');
            if (utils.isUndefined(attrAction)) {
                return false;
            }

            var data = null;
            var attrOrigValue = element.getAttribute('data-orig-value');
            if (!utils.isUndefined(attrOrigValue)) {
                data = "origValue=" + encodeURIComponent(attrOrigValue);
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: attrAction + "/a_" + encodeURIComponent(value),
                data: data
            });
        },
        Lang.get('tripletrax.abbreviation_exists')
    );

    $.validator.addMethod(
        "existingAgreement",
        function (value, element, param) {
            var valid = true;
            var date_from = $(element).parents('.tt-content-dialog').find(param[0]).data('picker').getDate();
            var id = $(element).parents('.tt-content-dialog').find('.tt-selected-id').val();

            var select2 = $(element).parents('.tt-content-dialog').find('.tt-select2').select2('data')[0];
            jQuery.each($('#table_patient_agreement').dataTable().fnGetData(), function (i, val) {
                if (String(val.id) !== id && val.agreement_id === utils.stringToNumber(select2.id) && (val.end_date === null || utils.stringToDate(val.end_date) > date_from)) {
                    valid = false;
                    return false;
                }
            });

            return valid;
        },
        Lang.get('tripletrax.agreement_exists')
    );

    $.validator.addMethod(
        "validDateRange",
        function (value, element, param) {
            var searchClass = 'form';
            if (param.length > 2) {
            	searchClass = param[2];
			}

            var dateFrom = null;
            if ($(element).parents(searchClass).find(param[0]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
                dateFrom = $(element).parents(searchClass).find(param[0]).data('picker').getDate();
            }
            var dateTill = null;
            if ($(element).parents(searchClass).find(param[1]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
                dateTill = $(element).parents(searchClass).find(param[1]).data('picker').getDate();
            }

            if (!utils.isUndefined(dateFrom) && !utils.isUndefined(dateTill) && dateFrom > dateTill)
            {
                return false;
            }

            return true;
        },
        Lang.get('tripletrax.invalid_date_range')
    );

	$.validator.addMethod(
		"validAggregationExaminationDateRange",
		function (value, element, param) {
			var searchClass = 'form';

			var dateFrom = null;
			if ($(element).parents(searchClass).find(param[0]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
				dateFrom = $(element).parents(searchClass).find(param[0]).data('picker').getDate();
			}

			var dateExamination = null;
			if ($(element).parents(searchClass).find(param[1]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
				dateExamination = $(element).parents(searchClass).find(param[1]).data('picker').getDate();
			}

			var dateTill = null;
			if ($(element).parents(searchClass).find(param[2]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
				dateTill = $(element).parents(searchClass).find(param[2]).data('picker').getDate();
			}

			if (!utils.isUndefined(dateFrom) && !utils.isUndefined(dateTill) && !utils.isUndefined(dateExamination) && (dateExamination < dateFrom || dateExamination > dateTill))
			{
				return false;
			}

			return true;
		},
		Lang.get('tripletrax.invalid_aggregation_execution_examination_value')
	);

    $.validator.addMethod(
        "maxDate",
        function (value, element, param) {

            var date = $(element).data('picker').getDate();

            if (!utils.isUndefined(date) && date > param) {
                return false;
            }

            return true;
        },
        'TODO'
    );

    var dependingModel = '';
    $.validator.addMethod(
        "validDateDependingModels",
        function (value, element, param) {
            var valid = true;
            dependingModel = '';

            var select2 = $(element).parents('.tt-content-dialog').find('.tt-select2').select2('data')[0];

            if (utils.isUndefined(select2)) {
                return true;
            }

            if (select2.depending_models === '' || select2.depending_models === '-1' || select2.models.indexOf('|') >= 0) {
                return true;
            }

            var existingModels = getExistingPatientAgreements();
            var modelHierarchy = [];
            var currentModel = null;
            $.each($.parseJSON($('#all_models').val()), function (i, val) {
                if (val.id == select2.models) {
                    currentModel = val;
                }
            });
            checkPatientAgreementExistingRecursive(currentModel, $.parseJSON($('#all_models').val()), existingModels, modelHierarchy);
            if (modelHierarchy.length <= 0) {
                return true;
            }
            // console.log(modelHierarchy);

            var dateFrom = $(element).data('picker').getDate();

            valid = true;
            jQuery.each(modelHierarchy, function (i, model) {
                jQuery.each($('#table_patient_agreement').dataTable().fnGetData(), function (j, val) {
                    if (val.data_collection_types === model && (val.agreement == 0 || val.agreement == 2) && (utils.isUndefined(val.end_date) || val.end_date === '')) {
                        if (utils.stringToDate(val.begin_date) > dateFrom) {
                            if (dependingModel !== '') {
                                dependingModel += '/';
                            }
                            dependingModel += val.model;
                            valid = false;
                        }
                    }
                });
            });

            return valid;
        },
        function() { return Lang.get('tripletrax.depending_agreement_exists', { "model": dependingModel }); }
    );

    var otherDependingModel = '';
    $.validator.addMethod(
        "validDateOtherDependingModels",
        function (value, element, param) {
            var valid = true;
            otherDependingModel = '';

            var select2 = $(element).parents('.tt-content-dialog').find('.tt-select2').select2('data')[0];
            if (utils.isUndefined(select2) || select2.other_depending_models === '') {
                return true;
            }

            var dateFrom = $(element).data('picker').getDate();

            valid = false;
            jQuery.each(select2.other_depending_models.split('|'), function (i, model) {

                var foundDependingModelDependingModels = '';
                jQuery.each($.parseJSON($('#all_models').val()), function (j, dependingModel) {
                    if (dependingModel.id == model) {
                        foundDependingModelDependingModels = dependingModel.depending_models;
                    }
                });

                var dependingDateFrom = '';
                jQuery.each($('#table_patient_agreement').dataTable().fnGetData(), function (j, val) {
                    if (String(val.data_collection_types) === model && (val.agreement == 0 || val.agreement == 2) && (utils.isUndefined(val.end_date) || val.end_date === '')) {
                        dependingDateFrom = utils.stringToDate(val.begin_date);
                        otherDependingModel = val.model;
                    }
                });

                if (dependingDateFrom !== '') {
                    jQuery.each(foundDependingModelDependingModels.split('|'), function (i, model1) {
                        jQuery.each($('#table_patient_agreement').dataTable().fnGetData(), function (j, val) {
                            if (String(val.data_collection_types) === model1 && String(val.data_collection_types) != select2.models && (val.agreement == 0 || val.agreement == 2) && (utils.isUndefined(val.end_date) || val.end_date === '') && utils.stringToDate(val.begin_date) < dependingDateFrom) {
                                valid = true;
                            }
                        });
                    });
                } else {
                    valid = true;
                }

                if (!valid && dateFrom > dependingDateFrom) {
                    return false;
                } else {
                    valid = true;
                }
            });

            return valid;
        },
        function() { return Lang.get('tripletrax.other_depending_agreement_exists', { "model": otherDependingModel }); }
    );

	$.validator.addMethod(
        "validDateDependingExamDateFormat",
        function (value, element, param) {
            var valid = true;
            var searchClass = 'form';

            var dateFrom = null;
            if ($(element).parents(searchClass).find(param[0]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
                dateFrom = $(element).parents(searchClass).find(param[0]).data('picker').getDate();
			}

            var dateTill = null;
            if ($(element).parents(searchClass).find(param[1]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
                dateTill = $(element).parents(searchClass).find(param[1]).data('picker').getDate();
			}

            var examDateFormats = null;
            if ($(element).parents(searchClass).find(param[2]).val() !== '') {
				examDateFormats = $.parseJSON($(element).parents(searchClass).find(param[2]).val());
            }

			var targetModel = null;
			if ($(element).parents(searchClass).find(param[3]).val() !== '') {
				targetModel = $(element).parents(searchClass).find(param[3]).val();
			}
			if (!utils.isUndefined(dateFrom) && !utils.isUndefined(dateTill) && !utils.isUndefined(examDateFormats) && !utils.isUndefined(targetModel)) {
				for (var id in examDateFormats) {

					if (id === parseInt(targetModel)) {
						if (examDateFormats[id] !== 'date_time' && examDateFormats[id] !== 'date') {

							// TODO: Überprüfung
							if (examDateFormats[id] === 'year') {
                                // Überprüfung des Zeitraums für ein Jahr
							} else if (examDateFormats[id] === 'quarter_year') {
								// Überprüfung des Zeitraums für  Quartal und Jahr
							} else if (examDateFormats[id] === 'month_year') {
								// Überprüfung des Zeitraums für ein Monat und Jahr
							}
						}
					}
				}
			} else {
				valid = false;
			}
            return valid;
        },
        Lang.get('tripletrax.depending_aggregation_execution_exam_date_format')

    );

    $.validator.addMethod(
        "existingExamination",
        function (value, element, param) {

            var date = $(element).parents('.tt-content-dialog').find('.datepicker').data('picker').getDate();

            if (!utils.isUndefined(date) && date > param) {
                return true;
            }

            var attrAction = element.getAttribute('data-action');
            if (utils.isUndefined(attrAction)) {
                return false;
            }

            var examination_id = '0';
            if ($('#table_patient_examination_create_form').find('.tt-selected-id').val() !== '') {
                examination_id = $(element).parents('.tt-content-dialog').find('.tt-selected-id').val();
            }

            var examDate = getExaminationDateFromForm(element);
            attrAction += "/" + examination_id + "/model/" + views.getModelId() + "/patient/" + views.getPatientId() + "/check/" + examDate;

            return $.validator.methods.remote.call(this, examDate, element, {
                url: attrAction
            });
        },
        Lang.get('tripletrax.examination_exists')
    );

    $.validator.addMethod(
        "existingMasterView",
        function (value, element) {
            var valid = true;

            var select2 = $(element).parents('.tt-content-dialog').find('.tt-select2').select2('data')[0];
            jQuery.each($('#table_data_collection_type_master_views').dataTable().fnGetData(), function (i, val) {
                if (val[2] === select2.id) {
                    valid = false;
                    return false;
                }
            });

            return valid;
        },
        Lang.get('tripletrax.master_view_exists')
    );

    $.validator.addMethod(
        "existingMasterViewMatchFields",
        function (value, element) {

            var existingIds = '';
            // Stammdatenansichten
            jQuery.each($('#table_data_collection_type_master_views').dataTable().fnGetData(), function (i, val) {
                if (existingIds !== '') {
                    existingIds += ',';
                }
                existingIds += val[2];
            });
            // Verlaufsansichten - Register
            jQuery.each($('#table_data_collection_type_course_views_register').dataTable().fnGetData(), function (i, val) {
                if (existingIds !== '') {
                    existingIds += ',';
                }
                existingIds += val[2];
            });
			// Fragebögen
			jQuery.each($('#table_data_collection_type_questionnaires').dataTable().fnGetData(), function (i, val) {
				if (existingIds !== '') {
					existingIds += ',';
				}
				existingIds += val[2];
			});
            // Verlaufsansichten - Studie
            jQuery.each($('#dd_course_views').nestable('serialize'), function (i, val) {
                if (existingIds !== '') {
                    existingIds += ',';
                }
                existingIds += String(val.viewId);
            });

            if (existingIds === '') {
                return true;
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: "admin/datacollectiontype/match/check/" + $(element).parents('.tt-content-dialog').find('.tt-select2').select2('data')[0].id,
                data: "&existingIds=" + existingIds
            });
        },
        Lang.get('tripletrax.master_view_match_fields_exist')
    );

    $.validator.addMethod(
        "atLeastOneMasterView",
        function (value, element) {
            var valid = false;

            if ($('#table_data_collection_type_master_views').dataTable().fnGetData().length) {
                valid = true;
            }

            return valid;
        },
        Lang.get('tripletrax.at_least_one_master_view')
    );

    $.validator.addMethod(
        "atLeastOneMonitoringDisplayField",
        function (value, element) {
            var valid = false;

            jQuery.each($('#monitoring_display_fields_table').find('.dd3-content'), function (i, val) {
                if (!$(val).data('isDeleted')) {
                    valid = true;
                }
            });

            return valid;
        },
        Lang.get('tripletrax.at_least_one_monitoring_display_field')
    );

    $.validator.addMethod(
        "existingCourseViewRegister",
        function (value, element) {
            var valid = true;

            var select2 = $(element).parents('.tt-content-dialog').find('.tt-select2').select2('data')[0];
            jQuery.each($('#table_data_collection_type_course_views_register').dataTable().fnGetData(), function (i, val) {
                if (val[2] === select2.id) {
                    valid = false;
                    return false;
                }
            });

            return valid;
        },
        Lang.get('tripletrax.course_view_exists')
    );

	$.validator.addMethod(
		"existingQuestionnaire",
		function (value, element) {
			var valid = true;

			var select2 = $(element).parents('.tt-content-dialog').find('.tt-select2').select2('data')[0];
			jQuery.each($('#table_data_collection_type_questionnaires').dataTable().fnGetData(), function (i, val) {
				if (val[2] === select2.id) {
					valid = false;
					return false;
				}
			});

			return valid;
		},
		Lang.get('tripletrax.questionnaire_exists')
	);

	$.validator.addMethod(
		"existingQuestionnaireProject",
		function (value, element) {
			var valid = true;

			var select2 = $(element).parents('.tt-content-dialog').find('.tt-select2').select2('data')[0];
			jQuery.each($('#table_data_collection_type_questionnaire_projects').dataTable().fnGetData(), function (i, val) {
				if (val[2] === select2.id) {
					valid = false;
					return false;
				}
			});

			return valid;
		},
		Lang.get('tripletrax.questionnaire_project_exists')
	);

    $.validator.addMethod(
        "existingMonitoringDisplayField",
        function (value, element) {
            var valid = true;

            var select2 = $(element).parents('.tt-content-dialog').find('.tt-select2').select2('data')[0];

            jQuery.each($('#monitoring_display_fields_table').find('.dd3-content'), function (i, val) {
                if ($(val).data('id') === select2.id && !$(val).data('isDeleted')) {
                    valid = false;
                }
            });

            return valid;
        },
        Lang.get('tripletrax.monitoring_display_field_exists')
    );

	$.validator.addMethod(
		"atLeastOneMonitoringRestriction",
		function (value, element) {
			var valid = false;

			jQuery.each($('#monitoring_restrictions_table').find('.dd3-content'), function (i, val) {
				if (!$(val).data('isDeleted')) {
					valid = true;
				}
			});

			return valid;
		},
		Lang.get('tripletrax.at_least_one_monitoring_restriction')
	);

    $.validator.addMethod(
        "existingMonitoringRestriction",
        function (value, element) {
            var valid = true;

            var selectedId = $(element).parents('.tt-content-dialog').find('[name="selected_id"]').val();

            jQuery.each($('#monitoring_restrictions_table').find('.dd3-content'), function (i, val) {
                if ((selectedId === '' || $(val).data('id') !== utils.stringToNumber(selectedId)) && !$(val).data('isDeleted') && $(val).data('description') === value) {
                    valid = false;
                }
            });

            return valid;
        },
        Lang.get('tripletrax.monitoring_restriction_exists')
    );

    var message = '';
    $.validator.addMethod(
        "validMonitoringRestrictionLogic",
        function (value, element) {
            var valid = true;

            var openParenthesis = 0;
            var closedParenthesis = 0;
            var before = 0; // 0: Parameter, 1: and, or, 2: (, 3: )

            jQuery.each($('#monitoring_restrictions_table').find('.dd3-content:not(.tt-deleted-monitoring-nestable)'), function (i, val) {
                if (i === 0) {
                    if (($(val).data('viewName') === 'and' || $(val).data('viewName') === 'or' || $(val).data('viewName') === 'right_parenthesis') && $(val).data('description') === 'Operator') {
                        // Zeile # muss einen Parameter oder eine öffnende Klammer enthalten!
                        message = Lang.get('tripletrax.monitoring_restriction_logic_error_1', {'line': (i + 1).toString()});
                        valid = false;
                        return false;
                    }
                } else {
                    if (i === $('#monitoring_restrictions_table').find('.dd3-content:not(.tt-deleted-monitoring-nestable)').length - 1) {
                        if (($(val).data('viewName') === 'and' || $(val).data('viewName') === 'and_concurrent' || $(val).data('viewName') === 'or' || $(val).data('viewName') === 'left_parenthesis') && $(val).data('description') === 'Operator') {
                            // Zeile # muss einen Parameter oder eine schließende Klammer enthalten!
                            message = Lang.get('tripletrax.monitoring_restriction_logic_error_2', {'line': (i + 1).toString()});
                            valid = false;
                            return false;
                        }
                    }

                    switch (before) {
                        case 1: // AND, OR --> Parameter oder (
                        case 2: // ( --> Parameter oder (
                            if (($(val).data('viewName') === 'and' || $(val).data('viewName') === 'and_concurrent' || $(val).data('viewName') === 'or' || $(val).data('viewName') === 'right_parenthesis') && $(val).data('description') === 'Operator') {
                                // Zeile # muss einen Parameter oder eine öffnende Klammer enthalten!
                                message = Lang.get('tripletrax.monitoring_restriction_logic_error_1', {'line': (i + 1).toString()});
                                valid = false;
                                return false;
                            }
                            break;
                        case 3: // ) --> AND, OR oder )
                        default: // Parameter --> AND, OR oder )
                            if (!(($(val).data('viewName') === 'and' || $(val).data('viewName') === 'and_concurrent' || $(val).data('viewName') === 'or' || $(val).data('viewName') === 'right_parenthesis') && $(val).data('description') === 'Operator')) {
                                if (openParenthesis - closedParenthesis === 0) {
                                    // Zeile # muss ein "Und" oder ein "Oder" enthalten!
                                    message = Lang.get('tripletrax.monitoring_restriction_logic_error_3', {'line': (i + 1).toString()});
                                    valid = false;
                                    return false;
                                } else {
                                    // Zeile # muss ein "Und", ein "Oder" oder eine schließende Klammer enthalten!
                                    message = Lang.get('tripletrax.monitoring_restriction_logic_error_4', {'line': (i + 1).toString()});
                                    valid = false;
                                    return false;
                                }
                            }
                            break;
                    }
                }

                if (($(val).data('viewName') === 'and' || $(val).data('viewName') === 'and_concurrent' || $(val).data('viewName') === 'or' || $(val).data('viewName') === 'right_parenthesis' || $(val).data('viewName') === 'left_parenthesis') && $(val).data('description') === 'Operator') {
                    switch ($(val).data('viewName')) {
                        case 'or':
                            before = 1;
                            break;
                        case 'left_parenthesis':
                            openParenthesis += 1;
                            before = 2;
                            break;
                        case 'right_parenthesis':
                            closedParenthesis += 1;
                            before = 3;
                            break;
                        case 'and':
                            before = 1;
                            break;
                        case 'and_concurrent':
                            before = 1;
                            break;
                    }
                } else {
                    before = 0;
                }
            });

            if (valid && openParenthesis !== closedParenthesis) {
                var error = openParenthesis - closedParenthesis;
                if (error < 0) {
                    // Es fehlen noch # geöffnete Klammern!
                    message = Lang.get('tripletrax.monitoring_restriction_logic_error_5', {'count': (-1 * error).toString()});
                    valid = false;
                    return false;
                } else {
                    // Es fehlen noch # geschlossene Klammern!
                    message = Lang.get('tripletrax.monitoring_restriction_logic_error_6', {'count': error.toString()});
                    valid = false;
                    return false;
                }
            }

            return valid;
        },
        function() { return message; }
    );

    $.validator.addMethod(
        "existingCourseViewStudy",
        function (value, element) {
            var valid = true;

            var select2 = $(element).parents('.tt-content-dialog').find('.tt-select2').select2('data')[0];
            jQuery.each($('#dd_course_views').nestable('serialize'), function (i, val) {
                if (String(val.viewId) === select2.id) {
                    valid = false;
                    return false;
                }
            });

            return valid;
        },
        Lang.get('tripletrax.course_view_exists')
    );

    $.validator.addMethod(
        "existingCourseViewMatchFields",
        function (value, element) {

            var existingIds = '';
            // Stammdatenansichten
            jQuery.each($('#table_data_collection_type_master_views').dataTable().fnGetData(), function (i, val) {
                if (existingIds !== '') {
                    existingIds += ',';
                }
                existingIds += val[2];
            });
            // Verlaufsansichten - Register
            jQuery.each($('#table_data_collection_type_course_views_register').dataTable().fnGetData(), function (i, val) {
                if (existingIds !== '') {
                    existingIds += ',';
                }
                existingIds += val[2];
            });
			// Fragögen
			jQuery.each($('#table_data_collection_type_questionnaires').dataTable().fnGetData(), function (i, val) {
				if (existingIds !== '') {
					existingIds += ',';
				}
				existingIds += val[2];
			});
            // Verlaufsansichten - Studie
            jQuery.each($('#dd_course_views').nestable('serialize'), function (i, val) {
                if (existingIds !== '') {
                    existingIds += ',';
                }
                existingIds += String(val.viewId);
            });

            if (existingIds === '') {
                return true;
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: "admin/datacollectiontype/match/check/" + $(element).parents('.tt-content-dialog').find('.tt-select2').select2('data')[0].id,
                data: "&existingIds=" + existingIds
            });
        },
        Lang.get('tripletrax.course_view_match_fields_exist')
    );

    $.validator.addMethod(
        "requireFromGroup",
        function (value, element, param) {
            var valid = false;
            var searchClass = '.tt-content-dialog';
            if (param.length > 2) {
				searchClass = param[2];
			}

            var elements = $(element).parents(searchClass).find(param[1]);

            var counter = 0;
            jQuery.each(elements, function (i, val) {
                if ($(val).is('.tt-validation-checkbox') || $(val).is('.tt-validation-radio')) {
                    if ($(val)[0].checked) {
                        counter++;
                    }
                } else if ($(val).is('.tt-select2')) {
                    if (!utils.isUndefined($(val).select2('val')) && ($(val).select2('val').length > 1 || ($(val).select2('val').length === 1 && $(val).select2('val')[0] !== ''))) {
                        counter++;
                    }
                } else if ($(val).is('.datepicker')) {
                    if (utils.isFormatValue(utils.getValueFromInputWithDropDownField($(val))) || $(val).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
                        counter++;
                    }
                } else {
                    if ($(val).val() !== '') {
                        counter++;
                    }
                }
            });

            if (counter >= param[0]) {
                valid = true;
            }

            return valid;
        },
        Lang.get('tripletrax.element_from_group_is_required')
    );

    $.validator.addMethod(
        "requireFromGroupWhenElementFilled",
        function (value, element, param) {

            var valid = true;

            var elements = $(element).parents('.tt-content-dialog,.tt-content-detail').find(param[0]);

            if ($(elements[0]).hasClass('tt-validation-checkbox') || $(elements[0]).hasClass('tt-validation-radio')) {
                if ($(elements[0])[0].checked && (value === '' || utils.isUndefined(value))) {
                    valid = false;
                }
            } else if ($(elements[0]).hasClass('tt-select2')) {
                if ($(elements[0]).hasClass('select2-hidden-accessible') && !utils.isUndefined($(elements[0]).select2('val')) && ($(elements[0]).select2('val').length > 1 || ($(elements[0]).select2('val').length === 1 && $(elements[0]).select2('val')[0] !== '')) && (value === '' || utils.isUndefined(value))) {
                    valid = false;
                }
            } else if ($(elements[0]).hasClass('datepicker')) {
                if ((utils.isFormatValue(utils.getValueFromInputWithDropDownField($(elements[0]))) || $(elements[0]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') && (value === '' || utils.isUndefined(value))) {
                    valid = false;
                }
            } else {
                if ($(elements[0]).val() !== '' && (value === '' || utils.isUndefined(value))) {
                    valid = false;
                }
            }

            if (!valid) {
                valid = false;
                var elements = $(element).parents('.tt-content-dialog,.tt-content-detail').find(param[2]);

                var counter = 0;
                jQuery.each(elements, function (i, val) {
                    if ($(val).is('.tt-validation-checkbox') || $(val).is('.tt-validation-radio')) {
                        if ($(val)[0].checked) {
                            counter++;
                        }
                    } else if ($(val).is('.tt-select2')) {
                        if (!utils.isUndefined($(elements[0]).val()) && ($(val).val().length > 1 || ($(val).val().length === 1 && $(val).val() !== ''))) {
                            counter++;
                        }
                    } else if ($(val).is('.datepicker')) {
                        if (utils.isFormatValue(utils.getValueFromInputWithDropDownField($(val))) || $(val).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
                            counter++;
                        }
                    } else {
                        if ($(val).val() !== '') {
                            counter++;
                        }
                    }
                });

                if (counter >= param[1]) {
                    valid = true;
                }
            }

            return valid;
        },
        Lang.get('tripletrax.element_from_group_is_required')
    );

	$.validator.addMethod(
		"requiredLanguage",
		function (value, element) {

			var valid = true;
			var questionnaireId = element.getAttribute('id');
			var elements = $('.tt-select-' + questionnaireId);

			jQuery.each(elements, function (i, val) {
				if ($(elements[i]).hasClass('tt-validation-checkbox')) {
					if ($(elements[i])[0].checked) {
						if (value !== '') {
								valid = true;
						} else {
							valid = false;
						}
					}
				}
			});

			return valid;
		},
		Lang.get('tripletrax.select_language')
    );


	$.validator.addMethod(
        "requiredWhenElementFilled",
        function (value, element, param) {
            var valid = true;
			var searchClass = '.tt-content-dialog,.tt-content-detail';
			if (param.length > 2) {
				searchClass = param[2];
			}

            var elements = $(element).parents(searchClass).find(param[0]);
            var elementValue = '';
            if (param.length > 1) {
                elementValue = param[1];
            }

            if ($(elements[0]).hasClass('tt-validation-checkbox') || $(elements[0]).hasClass('tt-validation-radio')) {
                if ($(elements[0])[0].checked && (value === '' || utils.isUndefined(value))) {
                    valid = false;
                }
            } else if ($(elements[0]).hasClass('tt-select2')) {
                if ($(elements[0]).hasClass('select2-hidden-accessible') && !utils.isUndefined($(elements[0]).select2('val')) && ($(elements[0]).select2('val').length > 1 || ($(elements[0]).select2('val').length === 1 && $(elements[0]).select2('val')[0] !== ''))
                    && (elementValue === '' || elementValue === $(elements[0]).select2('val')) && (value === '' || utils.isUndefined(value))) {
                    valid = false;
                }
            } else if ($(elements[0]).hasClass('datepicker')) {
                if ((utils.isFormatValue(utils.getValueFromInputWithDropDownField($(elements[0]))) || $(elements[0]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') && (value === '' || utils.isUndefined(value))) {
                    valid = false;
                }
            } else {
                if ($(elements[0]).val() !== '' && (elementValue === '' || elementValue === $(elements[0]).val()) && (value === '' || utils.isUndefined(value))) {
                    valid = false;
                }
            }

            return valid;
        },
        'TODO'
    );

    $.validator.addMethod(
        "aggregationFieldConversionsRequiredWhenPeriodValueOrRowValue",
        function (value, element, param) {
            var valid = true;

            var aggregationValue = $(element).parents('form').find('[name="aggregation"]').val();

            if ((aggregationValue === 'row_value' || aggregationValue === 'period_value') && (value === '' || utils.isUndefined(value))) {
                valid = false;
            }

            return valid;
        },
        Lang.get('tripletrax.required_aggregation_period_field_conversions')
    );

    $.validator.addMethod(
        "uniqueControlTypeValue",
        function (value, element, param) {
            var valid = true;

            var id = $(element).parents('form').find('[name="selected_id"]').val();
            var contentElement = $(element).parents('.modal-content').find('[data-id="' + id + '"]');

            var values = $(element).parents('.modal-content').find('[name="list_values"]').val().split('|');


            if (jQuery.inArray(value, values) > -1) {
                valid = false;

                if (!utils.isUndefined(contentElement) && String(contentElement.data('value')) === value) {
                    valid = true;
                }
            }

            return valid;
        },
        Lang.get('tripletrax.control_type_value_exists')
    );

    $.validator.addMethod(
        "uniqueValueInDatabase",
        function (value, element, param) {
            var valid = true;

            var id = $(element).parents('form').find('[name="selected_id"]').val();
            var contentElement = $(element).parents('.modal-content').find('[data-id="' + id + '"]');

            var values = $(element).parents('.modal-content').find('[name="list_values_in_database"]').val().split('|');


            if (jQuery.inArray(value, values) > -1) {
                valid = false;

                if (!utils.isUndefined(contentElement) && String(contentElement.data('value-in-database')) === value) {
                    valid = true;
                }
            }

            return valid;
        },
        Lang.get('tripletrax.control_type_value_in_database_exists')
    );

	$.validator.addMethod(
		"uniqueAggregationValue",
		function (value, element, param) {
			var valid = true;

			var id = $(element).parents('form').find('[name="selected_id"]').val();
			var contentElement = $(element).parents('.modal-content').find('[data-id="' + id + '"]');

			var values = $(element).parents('.modal-content').find('[name="list_aggregation_values"]').val().split('|');


			if (value !== '' && jQuery.inArray(value, values) > -1) {
				valid = false;

				if (!utils.isUndefined(contentElement) && String(contentElement.data('aggregation-value')) === value) {
					valid = true;
				}
			}

			return valid;
		},
		Lang.get('tripletrax.aggregation_value_exists')
	);

    $.validator.addMethod(
        "existingNewUnit",
        function (value, element) {
            var valid = true;

            if (element.id !== 'new_unit') {
                return true;
            }

            var input = $(element).val();
            jQuery.each($('#table_data_views_units').dataTable().fnGetData(), function (i, val) {
                if (val[2] === input) {
                    valid = false;
                    return false;
                }
            });

            return valid;
        },
        Lang.get('tripletrax.unit_exists')
    );

    $.validator.addMethod(
        "existingUnit",
        function (value, element) {
            var valid = true;

            if (element.id !== 'unit') {
                return true;
            }

            var input = $(element).val();
            jQuery.each($('#table_data_views_units').dataTable().fnGetData(), function (i, val) {
                if (val[2] === input && String(i) !== $(element).parents('.tt-content-dialog').find('.tt-selected-pos').val()) {
                    valid = false;
                    return false;
                }
            });

            return valid;
        },
        Lang.get('tripletrax.unit_exists')
    );

    $.validator.addMethod(
        "validControlTypeDatabaseValue",
        function (value, element) {

            if (/^[-_]+$/.test(value)) {
                return false;
            }

            return this.optional(element) || /^[a-zA-Z0-9-_]+$/.test(value);
        },
        Lang.get('tripletrax.invalid_control_type_database_value')
    );

    $.validator.addMethod(
        "validDocumentName",
        function (value, element) {

            if (/--/.test(value)) {
                return false;
            }

            return true;
        },
        Lang.get('tripletrax.invalid_description')
    );

    $.validator.addMethod(
        "uniqueDataViewName",
        function (value, element) {
            var allNameFields = $(element).parents('form').find('[data-name="all_name_fields"]').val().toLowerCase().split('|');

            if ($.inArray(value.toLowerCase(), allNameFields) >= 0) {
                return false;
            }

            var nameValue = $(element).parents('form').find('[name="name"]').val().toLowerCase();
            var nameAdditionalfield1Value = '';
            if ($(element).parents('form').find('[name="name_additionalfield_1"]').length) {
                nameAdditionalfield1Value = $(element).parents('form').find('[name="name_additionalfield_1"]').val().toLowerCase();
            }
            var nameAdditionalfield2Value = '';
            if ($(element).parents('form').find('[name="name_additionalfield_2"]').length) {
                nameAdditionalfield2Value = $(element).parents('form').find('[name="name_additionalfield_2"]').val().toLowerCase();
            }

            var name = element.getAttribute('name');
            if (name === 'name') {
                if ((nameAdditionalfield1Value !== '' && value.toLowerCase() === nameAdditionalfield1Value) || (nameAdditionalfield2Value !== '' && value.toLowerCase() === nameAdditionalfield2Value)) {
                    return false;
                }
            } else if (name === 'name_additionalfield_1') {
                if (value.toLowerCase() === nameValue || (nameAdditionalfield2Value !== '' && value.toLowerCase() === nameAdditionalfield2Value)) {
                    return false;
                }
            } else if (name === 'name_additionalfield_2') {
                if (value.toLowerCase() === nameValue || (nameAdditionalfield1Value !== '' && value.toLowerCase() === nameAdditionalfield1Value)) {
                    return false;
                }
            }

            return true;
        },
        Lang.get('tripletrax.dataviewname_exists')
    );

    $.validator.addMethod(
        "validDataViewName",
        function (value, element) {

            if (/^[_]+$/.test(value)) {
                return false;
            }

            return this.optional(element)
                || (/^[a-zA-Z0-9_]+$/.test(value)
                && value.indexOf("_format") < 0
                && value.indexOf("_table") < 0
                && value.indexOf("_rowid") < 0
                && value.indexOf("_updated_at") < 0
                && value.indexOf("_confirmed") < 0
				&& value.indexOf("_spalte_") < 0
                && value !== 'patient_id'
                && value !== 'facility_id'
                && value !== 'examination_id'
                && value !== 'id'
                && value !== 'last_user'
                && value !== 'created_user'
                && value !== 'created_facility'
                && value !== 'origin_flag'
                && value !== 'created_origin_flag'
                && value !== 'created_at'
                && value !== 'updated_at'
                && value !== 'deleted_at');
        },
        Lang.get('tripletrax.invalid_dataview_name')
    );

    $.validator.addMethod(
        "validFolderName",
        function (value, element) {

            if (value === '') {
                return true;
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: "doc/mail/folder/check/" + value
            });
        },
        Lang.get('tripletrax.invalid_folder_name')
    );

    $.validator.addMethod(
        "uniqueTableNameAndTableType",
        function (value, element) {

            var parentId = $('#content-detail').find('[name="parent_data_view_id_if_item_is_in_accordion_or_list"]').val();
            if (parentId === '') {
                parentId = $('#content-detail').find('[name="parent_id"]').val();
            }
            var tableType = $('[name="table_type"]').val();
            var tableName = $('[name="table"]').val();

            if (tableType === '' || tableName === '' || parentId === '') {
                return true;
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: "admin/dataview/check/parentid/" + parentId + "/tabletype/" + tableType + "/table/" + tableName
            });
        },
        Lang.get('tripletrax.unique_table_name_and_table_type')
    );

    $.validator.addMethod(
        "uniqueColumnNameInTable",
        function (value, element) {

            var id = $('[name="data_view_id"]').val();
            var tableName = $('[name="table"]').val();
            var columnName = value;

            if (id === '' || tableName === '' || columnName === '') {
                return true;
            }

            var columnValue = $(element).parents('form').find('[name="column"]').val().toLowerCase();
            var columnAdditionalfield1Value = '';
            if ($(element).parents('form').find('[name="column_additionalfield_1"]').length) {
                columnAdditionalfield1Value = $(element).parents('form').find('[name="column_additionalfield_1"]').val().toLowerCase();
            }
            var columnAdditionalfield2Value = '';
            if ($(element).parents('form').find('[name="column_additionalfield_2"]').length) {
                columnAdditionalfield2Value = $(element).parents('form').find('[name="column_additionalfield_2"]').val().toLowerCase();
            }

            var name = element.getAttribute('name');
            var valid = true;
            if (name === 'column') {
                if ((columnAdditionalfield1Value !== '' && value.toLowerCase() === columnAdditionalfield1Value) || (columnAdditionalfield2Value !== '' && value.toLowerCase() === columnAdditionalfield2Value)) {
                    valid = false;
                }
            } else if (name === 'column_additionalfield_1') {
                if (value.toLowerCase() === columnValue || (columnAdditionalfield2Value !== '' && value.toLowerCase() === columnAdditionalfield2Value)) {
                    valid = false;
                }
            } else if (name === 'column_additionalfield_2') {
                if (value.toLowerCase() === columnValue || (columnAdditionalfield1Value !== '' && value.toLowerCase() === columnAdditionalfield1Value)) {
                    valid = false;
                }
            }

            if (valid) {
                return $.validator.methods.remote.call(this, value, element, {
                    url: "admin/dataview/check/id/" + id + "/table/" + tableName + "/column/" + columnName
                });
            } else {
                return false;
            }
        },
        Lang.get('tripletrax.unique_column_in_table')
    );

    $.validator.addMethod(
        "uniqueMatchField",
        function (value, element) {

            var id = $('[name="data_view_id"]').val();
            var match = value;
            var position = $('[name="position"]').val();

            if (id === '' || match === '' || position === '') {
                return true;
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: "admin/dataview/check/id/" + id + "/match/" + match + "/position/" + position + "/current_view/0"
            });
        },
        Lang.get('tripletrax.unique_match_field')
    );

    $.validator.addMethod(
        "existingControlTypeValues",
        function (value, element) {

            var controlTypeValueExisting = false;
            var nameAppendix = element.name.replace('control_type', '');

            if ($(element).parents('form').find('[name="edit_control_type' + nameAppendix + '"]').length) {
                var controlTypes = $.parseJSON($(element).parents('form').find('[name="edit_control_type' + nameAppendix + '"]').val());
                jQuery.each(controlTypes, function (i, val) {
                    if (!val.isDeleted) {
                        controlTypeValueExisting = true;
                    }
                });
            }

            return controlTypeValueExisting;
        },
        Lang.get('tripletrax.required_control_type_values')
    );

    $.validator.addMethod(
        "existingNewIntegrity",
        function (value, element) {
            var valid = true;

            if (!($(element).hasClass('integrity-description') && $(element).parents('form')[0].id === 'table_data_views_integrities_create_form')
                && !($(element).hasClass('integrity-description') && $(element).parents('form')[0].id === 'table_data_views_retrictions_create_form')
                && !($(element).hasClass('integrity-description') && $(element).parents('form')[0].id === 'table_collection_type_integrities_form' && $(element).parents('form').find('[name="selected_id"]').val() === '')) {
                return true;
            }

            var input = '';
            var field = '';
            var table = null;
            if ($(element).parents('form')[0].id === 'table_data_views_integrities_create_form' || $(element).parents('form')[0].id === 'table_data_views_restrictions_create_form') {
                input = $(element).val();
                field = $(element).parents('form').find('[name="integrity_data_collection_type"]').select2('data')[0].text;
                table = $('#table_data_views_integrities');
                if ($(element).parents('form')[0].id === 'table_data_views_restrictions_create_form') {
                    table = $('#table_data_views_restrictions');
                }

            } else if ($(element).parents('form')[0].id === 'table_collection_type_integrities_form') {
                input = $(element).val();
                field = $(element).parents('form').find('[name="integrity_data_view_field"]').select2('data')[0].text;
                table = $('#table_data_collection_type_integrities');
            }

            if (table !== null) {
                jQuery.each(table.dataTable().fnGetData(), function (i, val) {
                    if (val[2] === input && val[1] === field) {
                        valid = false;
                        return false;
                    }
                });
            }

            return valid;
        },
        Lang.get('tripletrax.integrity_exists')
    );

    $.validator.addMethod(
        "existingIntegrity",
        function (value, element) {
            var valid = true;

            if (!($(element).hasClass('integrity-description') && $(element).parents('form')[0].id === 'table_data_views_integrities_form')
                && !($(element).hasClass('integrity-description') && $(element).parents('form')[0].id === 'table_collection_type_integrities_form' && $(element).parents('form').find('[name="selected_id"]').val() !== '')) {
                return true;
            }

            if ($(element).parents('form')[0].id === 'table_data_views_integrities_form') {
                var input = $(element).val();
                var data_collection_type = $(element).parents('form').find('[name="integrity_data_collection_type"]').select2('data')[0].text;
                jQuery.each($('#table_data_views_integrities').dataTable().fnGetData(), function (i, val) {
                    if (val[2] === input && val[1] === data_collection_type && String(i) !== $(element).parents('.tt-content-dialog').find('.tt-selected-pos').val()) {
                        valid = false;
                        return false;
                    }
                });
            } else if ($(element).parents('form')[0].id === 'table_collection_type_integrities_form') {
                var input = $(element).val();
                var field = $(element).parents('form').find('[name="integrity_data_view_field"]').select2('data')[0].text;
                jQuery.each($('#table_data_collection_type_integrities').dataTable().fnGetData(), function (i, val) {
                    if (val[2] === input && val[1] === field && String(i) !== $('#content').find('.tt-content-detail').find('.tt-selected-pos-integrities').val()) {
                        valid = false;
                        return false;
                    }
                });
            }

            return valid;
        },
        Lang.get('tripletrax.integrity_exists')
    );

    $.validator.addMethod(
        "atLeastOneControlTypeValue",
        function (value, element) {

            if ($(element).select2('val').length > 0) {
                return true;
            } else {
                return false;
            }
        },
        Lang.get('tripletrax.at_least_one_control_type')
    );

    $.validator.addMethod(
        "backupDone",
        function (value, element) {

            if ($('backup_done').prop('checked')) {
                return true;
            } else {
                return false;
            }

        },
        Lang.get('tripletrax.backup_is_a_must')
    );

    $.validator.addMethod(
        "validNormValueRange",
        function (value, element) {
            var valid = true;

            var value_from = $(element).parents('form').find('[name="integrity_value_from"]').val();
            var value_till = $(element).parents('form').find('[name="integrity_value_till"]').val();

            if (value_from !== '' && value_till !== ''
                && parseInt(value_from) > parseInt(value_till))
            {
                return false;
            }

            return true;
        },
        Lang.get('tripletrax.invalid_range')
    );

    $.validator.addMethod(
        "validNormValueRangeMonitoringRestriction",
        function (value, element) {
            var valid = true;

            var value_from = $(element).parents('form').find('[name="monitoring_restriction_field_value_from"]').val();
            var value_till = $(element).parents('form').find('[name="monitoring_restriction_field_value_till"]').val();

            if (value_from !== '' && value_till !== ''
                && utils.stringToNumber(value_from) > utils.stringToNumber(value_till))
            {
                return false;
            }

            return true;
        },
        Lang.get('tripletrax.invalid_range')
    );

    $.validator.addMethod(
        "existingCompleteness",
        function (value, element) {
            var valid = true;

            if (element.id !== 'completeness_description') {
                return true;
            }

            var input = $(element).val();
            jQuery.each($('#table_data_collection_type_integrities').dataTable().fnGetData(), function (i, val) {
                if (val[1] === input && String(i) !== $(element).parents('.tt-content-dialog').find('.tt-selected-pos').val()) {
                    valid = false;
                    return false;
                }
            });

            return valid;
        },
        Lang.get('tripletrax.completeness_exists')
    );

    $.validator.addMethod(
        "importSeparatorsRequired",
        function (value, element) {
            var valid = true;

            var import_file = $(element).parents('form').find('[name="import_file_name"]').val();

            if ((value === '' || utils.isUndefined(value)) && import_file.substr(-3) === "csv") {
                valid = false;
            }

            return valid;
        },
        Lang.get('tripletrax.required_separators')
    );

    $.validator.addMethod(
        "validImportFile",
        function (value, element) {
            var valid = true;

            var import_file = $(element).val();

            if (import_file.length && import_file.substr(-3) !== "csv" && import_file.substr(-3) !== "xls" && import_file.substr(-4) !== "xlsx") {
                valid = false;
            }

            return valid;
        },
        Lang.get('tripletrax.invalid_import_file')
    );

    $.validator.addMethod(
        "atLeastOneFacilityPatientToExport",
        function (value, element, param) {
            var valid = false;
            $("input:checked", $('#' + param).dataTable().fnGetNodes()).each(function () {
                valid = true;
                return false;
            });

            return valid;
        },
        Lang.get('tripletrax.at_least_one_facility_patient_selected')
    );

    $.validator.addMethod(
        "atLeastOneFacilityToRestorePatient",
        function (value, element) {
            var valid = false;

            if ($('#table_restore_patient_facilities').dataTable().fnGetNodes().length <= 0) {
                return true;
            }

            $("input:checked", $('#table_restore_patient_facilities').dataTable().fnGetNodes()).each(function () {
                valid = true;
                return false;
            });

            return valid;
        },
        Lang.get('tripletrax.at_least_one_facility_to_restore_patient')
    );

    $.validator.addMethod(
        "atLeastOneDataViewToExport",
        function (value, element) {
            var valid = false;
            $("input:checked", $('#table_export_data_views').dataTable().fnGetNodes()).each(function () {
                valid = true;
                return false;
            });

            return valid;
        },
        Lang.get('tripletrax.at_least_one_data_view_selected')
    );

    $.validator.addMethod(
        "atLeastOneTableToDatabaseExport",
        function (value, element) {
            var valid = false;
            $("input:checked", $('#table_database_export_tables').dataTable().fnGetNodes()).each(function () {
                valid = true;
                return false;
            });

            return valid;
        },
        Lang.get('tripletrax.at_least_one_table_selected')
    );

    $.validator.addMethod(
        "allConflictResolved",
        function (value, element) {
            var valid = true;

            if ($('#table_merge_conflicts').length) {
                jQuery.each($('#table_merge_conflicts').dataTable().fnGetNodes(), function (i, val) {
                    if (!$(val).find('.selected-cell').length) {
                        valid = false;
                        return false;
                    }
                });
            }

            return valid;
        },
        Lang.get('tripletrax.choose_all_merge_conflicts')
    );

    $.validator.addMethod(
        "allSaveConflictResolved",
        function (value, element) {
            var valid = true;

            if ($('#table_save_conflicts').length) {
                jQuery.each($('#table_save_conflicts').dataTable().fnGetNodes(), function (i, val) {
                    if (!$(val).find('.selected-cell').length) {
                        valid = false;
                        return false;
                    }
                });
            }

            return valid;
        },
        Lang.get('tripletrax.save_conflicts_not_all_resolved')
    );

    $.validator.addMethod(
        "patientPseudonymExists",
        function (value, element) {

            if (value === '') {
                return true;
            }

            var attrAction = element.getAttribute('data-action');
            if (utils.isUndefined(attrAction)) {
                return false;
            }

            return $.validator.methods.remote.call(this, value, element, {
                url: attrAction + "/" + value
            });
        },
        Lang.get('tripletrax.not_existing_patient_pseudonym')
    );

    $.validator.addMethod(
        "patientPseudonymNotSame",
        function (value, element) {

            if (value === '') {
                return true;
            }

            if ($('[name="pseudonym_patient_1"]').val() === $('[name="pseudonym_patient_2"]').val()) {
                return false;
            }

            return true;
        },
        Lang.get('tripletrax.not_same_patient_pseudonym')
    );

    $.validator.addMethod(
        "minLocale",
        function (value, element, param) {
            var valid = true;

            try {
                var number = utils.stringToNumber(value);
                if (number < param) {
                    valid = false;
                }

            } catch (NaNError) {
                valid = false;
            }

            return valid;
        },
        Lang.get('tripletrax.invalid_float')
    );

    $.validator.addMethod(
        "maxLocale",
        function (value, element, param) {
            var valid = true;

            try {
                var number = utils.stringToNumber(value);
                if (number > param) {
                    valid = false;
                }

            } catch (NaNError) {
                valid = false;
            }

            return valid;
        },
        Lang.get('tripletrax.invalid_float')
    );

    $.validator.addMethod(
        "validFloatDecimalPlaces",
        function (value, element, param) {
            var valid = true;

            try {
                var splittedNumber = value.split(utils.getDecimalSeparator());
                if (splittedNumber.length === 2 && utils.stringToNumber(splittedNumber[0]) <= utils.stringToNumber(splittedNumber[1]) + 1) {
                    valid = false;
                }

            } catch (NaNError) {
                valid = false;
            }

            return valid;
        },
        Lang.get('tripletrax.invalid_float')
    );

    $.validator.addMethod(
        "requiredDateFormat",
        function (value, element, param) {

            var selectedValue = $(element).select2('val');

            if (jQuery.inArray('full', selectedValue) !== -1 || jQuery.inArray('mm/yy', selectedValue) !== -1 || jQuery.inArray('yy', selectedValue) !== -1)
            {
                return true;
            }
            return false;
        },
        Lang.get('tripletrax.element_from_group_is_required')
    );

    $.validator.addMethod(
        'validDate',
        function(value, element, params) {
            if (!utils.isFormatValue(utils.getValueFromInputWithDropDownField($(element))) && value.replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
                var picker = $(element).data('picker');

                return moment(value.replace(/_/g, ''), picker._o.format).isValid();
            }
            return true;
        },
        Lang.get('tripletrax.invalid_date')
    );

    $.validator.addMethod(
        "validRecipient",
        function (value, element) {

            if (value.join() === '') {
                return true;
            }

            var attrAction = element.getAttribute('data-action');
            if (utils.isUndefined(attrAction)) {
                return false;
            }

            return $.validator.methods.remote.call(this, value.join(), element, {
                url: attrAction + "/" + value.join()
            });
        },
        Lang.get('tripletrax.invalid_recipient')
    );

    var validCategoryField = '';
    $.validator.addMethod(
        "atLeastOneCategoryCalculationField",
        function (value, element) {

            var valid = false;
            var category = $('#content').find('[name="category"]').val();
            var table = $('#content').find('[name="table_if_item_is_in_accordion_or_list"]').val();

            jQuery.each($('#table_data_views_calculation_form').find('.tt-select2'), function (i, combo) {
                if (!utils.isUndefined($(combo).select2('data')) && !$(combo).hasClass('tt-calculation-match-list-field') && !utils.isUndefined($(combo).select2('data')[0].tableType)) {
                    if (table !== '') {
                        // zeitraumbezogene Daten
                        if (table === $(combo).select2('data')[0].table) {
                            valid = true;
                            return false;
                        }
                    } else {
                        // Stammdaten und Verlaufsdaten
                        if (category === $(combo).select2('data')[0].tableType.substring(0, $(combo).select2('data')[0].tableType.indexOf('_')) || (category === 'master' && $(combo).select2('data')[0].tableType === '')) {
                            valid = true;
                            return false;
                        }
                    }
                }
            });

            return valid;
        },
        function() { return Lang.get('tripletrax.at_least_one_valid_category_calculation_field', { "category": validCategoryField }); }
    );

    $.validator.addMethod(
        "requiredCategoryCalculationField",
        function (value, element) {

            return value !== '';
        },
        Lang.get('tripletrax.required_category_calculation_field')
    );

	$.validator.addMethod(
		"requiredAggregationRule",
		function (value, element) {

			return value !== '';
		},
		Lang.get('tripletrax.required_aggregation_rule')
	);

	$.validator.addMethod(
		"requiredAggregationRuleDataViewField",
		function (value, element) {

			if ($(element).parents('.row').hasClass('hide')) {
				return true;
			} else {
				return value !== '';
			}
		},
		Lang.get('tripletrax.required_aggregation_rule_data_view_field')
	);

	$.validator.addMethod(
		"requiredAggregationRuleRestriction",
		function (value, element) {

			if ($(element).parents('.row').hasClass('hide')) {
				return true;
			} else {
			    if (value.length) {
					return value[0] !== '';
				} else {
			        return false;
                }
			}
		},
		Lang.get('tripletrax.required_aggregation_rule_restriction')
	);

	$.validator.addMethod(
		"requiredAggregationRuleReferenceDate",
		function (value, element) {

			if ($(element).parents('.row').hasClass('hide')) {
				return true;
			} else {
				return value !== '';
			}
		},
		Lang.get('tripletrax.required_aggregation_rule_reference_date')
	);

    $.validator.addMethod(
        "correctCalculationFields",
        function (value, element) {

            var calculationFieldsValue = $('[name="edit_' + element.name + '_correct"]').val();
            return calculationFieldsValue === '';
        },
        Lang.get('tripletrax.incorrect_calculation_fields')
    );

    $.validator.addMethod(
        "minWithDropdown",
        function (value, element, param) {
            if (utils.isFormatValue(utils.getValueFromInputWithDropDownField($(element)))) {
                return true;
            }
            return this.optional(element) || value >= param;
        },
        Lang.get('tripletrax.positiv_integer')
    );

    $.validator.addMethod(
        "sameUnit",
        function (value, element) {
            var selectedValue = $(element).select2('val');
            var dataView = $(element).data().dataView;
            if (!utils.isUndefined(selectedValue) && selectedValue !== '' && !utils.isUndefined(dataView) && dataView !== '') {
                var data = jQuery.param({
                    fields: dataView.split('|')[0] + '#' + dataView.split('|')[1] + '#' + selectedValue.split('|')[0] + '#' + selectedValue.split('|')[1] + '##'
                });

                return $.validator.methods.remote.call(this, value, element, {
                    url: "admin/monitoring/checkunit",
                    data: data
                });
            } else {
                return true;
            }
        },
        Lang.get('tripletrax.monitoring_restriction_not_same_unit')
    );

    $.validator.addMethod(
        "integer",
        function (value, element) {
            return (value === '' || /^[-]?[0-9]+$/.test(value+''));
        },
        Lang.get('tripletrax.integer')
    );

	$.validator.addMethod(
		"allOrNone",
		function (value, element, param) {
			var searchClass = 'form';
			if (param.length > 1) {
				searchClass = param[1];
			}

			var countTotal = 0;
			var countValue = 0;
			var countNoneValue = 0;

			if (searchClass === '.tt-datatable' || searchClass === '.tt-datatable-detail' || searchClass === '.tt-datatable-dialog') {
				$(param[0], $(element).parents(searchClass).dataTable().fnGetNodes()).each(function () {
					countTotal =  $(element).parents(searchClass).dataTable().fnGetNodes().length;
					var current = $(this);

					if (!utils.isUndefined(current[0].name)) {

						if ($(current).hasClass('tt-validation-checkbox') || $(current).hasClass('tt-validation-radio')) {
							if ($(current)[0].checked) {
								countValue++;
							} else {
								countNoneValue++;
							}
						} else if ($(current).hasClass('tt-select2')) {
							if ($(current).hasClass('select2-hidden-accessible') && !utils.isUndefined($(current).select2('val')) && ($(current).select2('val').length > 1 || ($(current).select2('val').length === 1 && $(current).select2('val')[0] !== ''))) {
								countValue++;
							} else {
								countNoneValue++;
							}
						} else if ($(current).hasClass('datepicker')) {
							if ((utils.isFormatValue(utils.getValueFromInputWithDropDownField($(current))) || $(current).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '')) {
								countValue++;
							} else {
								countNoneValue++;
							}
						} else {
							if ($(current).val() !== '') {
								countValue++;
							} else {
								countNoneValue++;
							}
						}
					}
				});
            } else {
				countTotal = $(element).parents(searchClass).find(param[0]).length;

				jQuery.each($(element).parents(searchClass).find(param[0]), function (i, element) {
					if ($(element).hasClass('tt-validation-checkbox') || $(element).hasClass('tt-validation-radio')) {
						if ($(element)[0].checked) {
							countValue++;
						} else {
							countNoneValue++;
						}
					} else if ($(element).hasClass('tt-select2')) {
						if ($(element).hasClass('select2-hidden-accessible') && !utils.isUndefined($(element).select2('val')) && ($(element).select2('val').length > 1 || ($(element).select2('val').length === 1 && $(element).select2('val')[0] !== ''))) {
							countValue++;
						} else {
							countNoneValue++;
						}
					} else if ($(element).hasClass('datepicker')) {
						if ((utils.isFormatValue(utils.getValueFromInputWithDropDownField($(element))) || $(element).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '')) {
							countValue++;
						} else {
							countNoneValue++;
						}
					} else {
						if ($(element).val() !== '') {
							countValue++;
						} else {
							countNoneValue++;
						}
					}
				});
            }

			if ((countValue === 0 && countNoneValue === countTotal) || (countNoneValue === 0 && countValue === countTotal)) {
			    return true;
            } else {
			    return false;
            }
		},
		Lang.get('tripletrax.invalid_all_or_one')
	);

	$.validator.addMethod(
	    "uniqueValue",
        function (value, element, param) {
			var searchClass = 'form';
			if (param.length > 1) {
				searchClass = param[1];
			}

			var valid = true;

			var values = [];

			if (searchClass === '.tt-datatable' || searchClass === '.tt-datatable-detail' || searchClass === '.tt-datatable-dialog') {
				$(param[0], $(element).parents(searchClass).dataTable().fnGetNodes()).each(function () {
					var current = $(this);

					if (!utils.isUndefined(current[0].name) && element.name !== current[0].name) {
						if ($(current).hasClass('tt-validation-checkbox') || $(current).hasClass('tt-validation-radio')) {
							if ($(current)[0].checked) {
								values.push('true');
							}
						} else if ($(current).hasClass('tt-select2')) {
							if ($(current).hasClass('select2-hidden-accessible') && !utils.isUndefined($(current).select2('val')) && ($(current).select2('val').length > 1 || ($(current).select2('val').length === 1 && $(current).select2('val')[0] !== ''))) {
								values.push($(current).select2('val'));
							}
						} else if ($(current).hasClass('datepicker')) {
							if ((utils.isFormatValue(utils.getValueFromInputWithDropDownField($(current))) || $(current).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '')) {
								values.push($(current).val());
							}
						} else {
							if ($(current).val() !== '') {
								values.push($(current).val());
							}
						}
					}
				});
			} else {
				jQuery.each($(element).parents(searchClass).find(param[0]), function (i, current) {
					if (!utils.isUndefined(current[0].name) && element.name !== current[0].name) {
						if ($(current).hasClass('tt-validation-checkbox') || $(current).hasClass('tt-validation-radio')) {
							if ($(current)[0].checked) {
								values.push('true');
							}
						} else if ($(current).hasClass('tt-select2')) {
							if ($(current).hasClass('select2-hidden-accessible') && !utils.isUndefined($(current).select2('val')) && ($(current).select2('val').length > 1 || ($(current).select2('val').length === 1 && $(current).select2('val')[0] !== ''))) {
								values.push($(current).select2('val'));
							}
						} else if ($(current).hasClass('datepicker')) {
							if ((utils.isFormatValue(utils.getValueFromInputWithDropDownField($(current))) || $(current).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '')) {
								values.push($(current).val());
							}
						} else {
							if ($(current).val() !== '') {
								values.push($(current).val());
							}
						}
					}
				});
			}

			if ($(element).hasClass('tt-validation-checkbox') || $(element).hasClass('tt-validation-radio')) {
				if ($(element)[0].checked && jQuery.inArray('true', values) >= 0) {
					valid = false;
				}
			} else if ($(element).hasClass('tt-select2')) {
				if ($(element).hasClass('select2-hidden-accessible') && !utils.isUndefined($(element).select2('val')) && ($(element).select2('val').length > 1 || ($(element).select2('val').length === 1 && $(element).select2('val')[0] !== '')) && jQuery.inArray($(element).select2('val'), values) >= 0) {
					valid = false;
				}
			} else if ($(element).hasClass('datepicker')) {
				if ((utils.isFormatValue(utils.getValueFromInputWithDropDownField($(element))) || $(element).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') && jQuery.inArray($(element).val(), values) >= 0) {
					valid = false;
				}
			} else {
				if ($(element).val() !== '' && jQuery.inArray($(element).val(), values) >= 0) {
					valid = false;
				}
			}

			return valid;
        },
        Lang.get('tripletrax.value_exists')
    );

	$.validator.addMethod(
		"validModel",
		function (value, element, param) {

		    var valid = true;
			var searchClass = 'form';

			var sourceModel = $(element).parents(searchClass).find(param[0]).val();
			var targetModel = $(element).parents(searchClass).find(param[1]).val();

			if (sourceModel === targetModel) {
			    valid = false;
            }

			return valid;
		},
		Lang.get('tripletrax.invalid_aggregation_execution_model_name')
	);

    $.validator.addMethod(
        "overlappingPeriod", // param [Von-Datum, Bis-Datum, Tabelle zum Vergleichen, Spalte in Tabelle Von-Datum, Spalte in Tabelle Bis-Datum, Such-Klasse (nicht zwingend)]
        function (value, element, param) {
            var valid = true;

            var searchClass = 'form';
            if (param.length > 5) {
                searchClass = param[5];
            }

            var dateFrom = null;
            if ($(element).parents(searchClass).find(param[0]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
                dateFrom = $(element).parents(searchClass).find(param[0]).data('picker').getDate();
            }
            var dateTill = null;
            if ($(element).parents(searchClass).find(param[1]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
                dateTill = $(element).parents(searchClass).find(param[1]).data('picker').getDate();
            }

            if (utils.isUndefined(dateFrom) || utils.isUndefined(dateTill)) {
                return true;
            }

            var id = $(element).parents('.tt-content-dialog').find('[name="selected_id"]').val();

            jQuery.each($(param[2]).dataTable().fnGetData(), function (i, val) {
                if (String(val[0]) !== id && dateFrom <= utils.stringToDate(val[param[4]]) && dateTill >= utils.stringToDate(val[param[3]])) {
                    valid = false;
                    return false;
                }
            });

            return valid;
        },
        Lang.get('tripletrax.overlapping_period')
    );

    $.validator.addMethod(
        "existingLockedPseudonym",
        function (value, element) {
            var valid = true;

            var id = $(element).parents('.tt-content-dialog').find('[name="selected_id"]').val();

            var select2 = $(element).parents('.tt-content-dialog').find('.tt-select2').select2('data')[0];
            jQuery.each($('#table_locked_patients').dataTable().fnGetData(), function (i, val) {
                if (String(val[0]) !== id && val[4] === select2.id) {
                    valid = false;
                    return false;
                }
            });

            return valid;
        },
        Lang.get('tripletrax.pseudonym_exists')
    );

    $.validator.addClassRules('datepicker', {
        validDate: true
    });

    $.validator.addClassRules('tt-calculation-single-field', {
        requiredCategoryCalculationField: true,
        atLeastOneCategoryCalculationField: true
    });

    $.validator.addClassRules('tt-aggregation-rule', {
		requiredAggregationRule: true
    });

	$.validator.addClassRules('tt-aggregation-rule-data-view-field', {
		requiredAggregationRuleDataViewField: true
	});

	$.validator.addClassRules('tt-aggregation-rule-restriction', {
		requiredAggregationRuleRestriction: true
	});

	$.validator.addClassRules('tt-aggregation-rule-reference-date', {
		requiredAggregationRuleReferenceDate: true
	});

	$.validator.addClassRules('tt-aggregation-control-value', {
	    integer: true,
		uniqueValue: ['.tt-aggregation-control-value', '.tt-datatable-dialog'],
        allOrNone: ['.tt-aggregation-control-value', '.tt-datatable-dialog']
    });

    $.validator.addClassRules('tt-aggregation-period-field-conversion', {
        uniqueValue: ['.tt-aggregation-period-field-conversion', '.tt-datatable-dialog'],
        allOrNone: ['.tt-aggregation-period-field-conversion', '.tt-datatable-dialog']
    });

    $.validator.addClassRules('tt-aggregation-period-field-conversion-checkbox-from', {
        uniqueValue: ['.tt-aggregation-period-field-conversion-checkbox-from', '.tt-datatable-dialog']
    });

    $.validator.addClassRules('tt-aggregation-period-field-conversion-checkbox-till', {
        uniqueValue: ['.tt-aggregation-period-field-conversion-checkbox-till', '.tt-datatable-dialog']
    });

	$.validator.addClassRules('tt-calculation-match-list-field', {
		requiredCategoryCalculationField: true
	});

	$.validator.addClassRules('tt-score-value', {
		integer: true
	});

	$.validator.addClassRules('tt-match-list-value', {
		required: true
	});

}

function setValidationToForms(element) {

    $(element).find('.tt-validation-form:not(.validation-container)').each(function () {

        var element = $(this);

        var submitForm = function (form) {

			var validator = this;
			var processData = true;
			var contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
			var action = form.action;
			var method = form.method;

			if (form.id === "table_users_roles_form") {

				saveUserRole(element, form);

			} else if (form.id === "table_locked_period_form") {

                saveFreezeFacilityDataLockedPeriod(element, form);

            } else if (form.id === "table_locked_patient_form") {

                saveFreezeFacilityDataLockedPatient(element, form);

			} else if (form.id === "table_agreement_list_form") {

				action = 'admin/agreement/patient/' + $(form).find('[name="pseudonym"]').val() + '/datatable';
				$('#table_agreement_list').DataTable().ajax.url(action).load();

			} else if (form.id === "restore_patient_form" && $(form).find('[name="restore_action"]').val() == 'check') {

				var newTableUrl = 'admin/restore/patient/' + $(form).find('[name="pseudonym"]').val() + '/datatable';
				ajax.ajaxCallDeferred(newTableUrl, 'GET', null, false).done(function (data) {
					$('#table_restore_patient_facilities').dataTable().api().clear().rows.add(data).draw();

					$('#content').find('.tt-save').removeClass('disabled');
					$('#content').find('.tt-save').prop('disabled', '');

					if ($('#table_restore_patient_facilities').dataTable().fnGetData().length > 0) {
						$('.tt-restore-patient').removeClass('disabled');
					} else {
						$('.tt-restore-patient').addClass('disabled');
					}
				});

			} else if (form.id === "table_data_collection_type_master_views_form") {

				saveCollectionTypeMasterView(element, form);

			} else if (form.id === "table_data_collection_type_course_views_register_form") {

				saveCollectionTypeCourseViewRegister(element, form);

			} else if (form.id === "table_data_collection_type_questionnaire_projects_form") {

				saveCollectionTypeQuestionnaireProject(element, form);

			} else if (form.id === "table_data_collection_type_questionnaires_form") {

				saveCollectionTypeQuestionnaire(element, form);

			} else if (form.id === "table_data_collection_type_course_views_study_new_form") {

				addNewCollectionTypeCourseViewStudy(element, form);

			} else if (form.id === "table_data_collection_type_course_views_study_edit_form") {

				saveCollectionTypeCourseViewStudy(element, form);

			} else if (form.id === "table_data_views_control_type_form") {

				saveDataViewControlType(element, form);

			} else if (form.id === "table_data_views_control_type_create_value_form") {

				addNewDataViewControlType(element, form);

			} else if (form.id === "table_data_views_units_form") {

				saveUnit(element, form);

			} else if (form.id === "table_data_views_units_create_form") {

				addNewUnit(element, form);

			} else if (form.id === "table_data_views_display_restrictions_form") {

				saveOrAddNewDataViewDisplayRestriction(element, form, false);

			} else if (form.id === "table_data_views_display_restrictions_create_form") {

				saveOrAddNewDataViewDisplayRestriction(element, form, true);

			} else if (form.id === "table_data_views_integrities_form" || form.id === "table_data_views_restrictions_form") {

				integrities.saveOrAddNewDataViewIntegrity(element, form, false);

			} else if (form.id === "table_data_views_integrities_create_form" || form.id === "table_data_views_restrictions_create_form") {

				integrities.saveOrAddNewDataViewIntegrity(element, form, true);

			} else if (form.id === "table_collection_type_integrities_form") {

				saveOrAddNewDataCollectionTypeIntegrity(element, form);

			} else if (form.id === "table_monitoring_restriction_create_form") {

				saveOrAddNewMonitoringRestriction(element, form);

			} else if (form.id === "table_monitoring_types_restriction_form") {

				saveOrAddNewMonitoringRestriction(element, form);

			} else if (form.id === "table_patient_examination_create_form" && ($(form).find('.tt-selected-id').val() === '' || $(form).find('.tt-selected-id').val() === '0')) {

				var url = action + '/facility/' + views.getFacilityId() + '/model/' + views.getModelId() + '/patient/' + views.getPatientId() + '/checktransferdata/' + getExaminationDateFromForm(form);
				checkForTransferDataViewFields(url).done(function (doSave) {
					if (doSave) {
						saveExamination(element, form);
					} else {
						$('#table_patient_examination_transfer_dialog').modal('show');
					}
				});

			} else if (form.id === "table_patient_examination_transfer_form") {

				getFormData(form).done(function (transferData) {
					var transferArray = transferData.split('&');
					var data = {};
					for (var i = 0; i < transferArray.length; ++i) {
						var itemArray = transferArray[i].split('=');
						data[decodeURIComponent(itemArray[0])] = decodeURIComponent(itemArray[1]);
					}
					var tabArray = [];
					$.each($(form).find('.tt-transfer-tab'), function (i, input) {
						tabArray.push($(input).val())
					});

					if ($(form).parents('.tt-content-dialog').find('.tt-create-transfer-examination').val() == '1') {
						$('#table_patient_examination_transfer_dialog').find('.content-dialog').empty();
						element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
						saveExamination($('#table_patient_examination_create_form'), $('#table_patient_examination_create_form')[0], data, tabArray);
					} else {
						views.setTransferData($('#' + tabArray[0]), data);
						$('#table_patient_examination_transfer_dialog').find('.content-dialog').empty();
						element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
					}
				});

			} else if (form.id === "table_data_collection_types_detail_master_views_form") {

				return;

			} else if (form.id === "table_monitoring_display_fields_form") {

				return;

			} else if (form.id === "save_conflicts_form") {

				setResolvedSaveConflicts();

			} else if (form.id === "table_mails_create_folder_form") {

				mails.moveSelectedMailsToFolder(action, $(form).find('[name="new_folder_name"]').val());

			} else if (form.id === "table_monitoring_display_field_create_form") {

				addNewMonitoringDisplayField(element);

			} else if (form.id === "table_aggregation_control_values_form") {

				var parentForm = $(form).find('[name="aggregation_control_values_parent_form"]').val();

				var controlValues = {};
				$(".tt-aggregation-control-value", $('#table_aggregation_definition_control_values').dataTable().fnGetNodes()).each(function () {

					var element = $(this);

					if (!utils.isUndefined(element[0].name)) {

						controlValues[element[0].name.substring(element[0].name.lastIndexOf('_') + 1)] = $(element).val();
					}
				});

				if (parentForm !== '' && $('#' + parentForm).find('[name="aggregation_control_values"]').length) {
					$('#' + parentForm).find('[name="aggregation_control_values"]').val(JSON.stringify(controlValues));
				}

				if ($('#' + parentForm).parents('.tt-content-detail').find('.tt-aggregation-control-values-changes').length && $('#' + parentForm).parents('.tt-content-detail').find('.tt-aggregation-control-values-changes').val() !== 'changed') {
					$('#' + parentForm).parents('.tt-content-detail').find('.tt-aggregation-control-values-changes').val('changed');
					$('#' + parentForm).parents('.tt-content-detail').find('form').trigger('checkform.areYouSure');
				}

                $('#table_aggregation_control_values_dialog').modal("hide");

            } else if (form.id === "table_aggregation_period_field_conversion_form") {

                var parentForm = $(form).find('[name="aggregation_period_field_conversions_parent_form"]').val();

                var fieldConversions = {};
                $.each($('#table_aggregation_definition_period_field_conversions').dataTable().fnGetData(), function (i, data) {
                    if (data[6] !== '') {
                        fieldConversions[data[0]] = [data[5], data[6], data[7], data[8]];
                    }
                });

                if (parentForm !== '' && $('#' + parentForm).find('[name="aggregation_period_field_conversions"]').length && Object.keys(fieldConversions).length > 0) {
                    $('#' + parentForm).find('[name="aggregation_period_field_conversions"]').val(JSON.stringify(fieldConversions));
                } else {
                    $('#' + parentForm).find('[name="aggregation_period_field_conversions"]').val('');
                }

                if ($('#' + parentForm).parents('.tt-content-detail').find('.tt-aggregation-period-field-conversions-changes').length && $('#' + parentForm).parents('.tt-content-detail').find('.tt-aggregation-period-field-conversions-changes').val() !== 'changed') {
                    $('#' + parentForm).parents('.tt-content-detail').find('.tt-aggregation-period-field-conversions-changes').val('changed');
                    $('#' + parentForm).parents('.tt-content-detail').find('form').trigger('checkform.areYouSure');
                }

                $('#table_aggregation_period_field_conversion_dialog').modal("hide");

			} else {

				if (form.id === "table_data_views_create_form") {

					addDataViewNestableItem(element, form);

				} else if (form.id === "table_agreement_type_documents_form") {

					processData = false;
					contentType = false;

				} else if (form.id === "table_documents_detail_form") {

					processData = false;
					contentType = false;

				} else if (form.id === "freeze_data_form") {

					$('.tt-please-wait-freeze-data').removeClass('hide');
					$('.tt-data-frozen-ok,.tt-data-frozen-fail').addClass('hide');

				} else if (form.id === "import_form") {

					processData = false;
					contentType = false;

					$('[name="import_time_stamp"]').val($.now());

					action = 'admin/import/check';

					$('.tt-please-wait-file-check').removeClass('hide');

				} else if (form.id === "import_query_form") {

					processData = false;
					contentType = false;

					$('[name="import_time_stamp"]').val($.now());

					action = 'admin/import_query/check';

					$('.tt-please-wait-file-check').removeClass('hide');

				} else if (form.id === "delete_patient_finally_form") {

					action = form.action + '/agreement/' + $(form).find('[name="pseudonym"]').val();

				} else if (form.id === "export_form" || form.id === "database_export_form") {

					$(form).parents('.tt-content-detail').find('.tt-please-wait-export').removeClass('hide');

                    $(form).find('[name="export_time_stamp"]').val($.now());

				} else if (form.id === "table_data_views_detail_form") {

					$('.tt-please-wait-save-data-views').removeClass('hide');

				} else if (form.id === "table_audit_trail_form") {

					$('.tt-datatable-search').val('');
					$('#table_audit_trail').dataTable().fnFilterClear();
					$('.tt-audit-trail-results').addClass('hide');
					$('.tt-please-wait-audit-trail').removeClass('hide');

					$('[name="audit_trail_time_stamp"]').val($.now());

				} else if (form.id === "table_patient_agreement_create_form") {

					action = setActionForSavingAgreement(form, action);

					$("#table_patient_agreement_create_form :disabled").removeAttr('disabled');

					// Ist eine ablaufende Einwilligung vorhanden und soll die neue Einwilligung bei Klick auf "Neue Untersuchung" automatisch angelegt werden
					// so soll bei Angabe von "ja" der Button "Neue Untersuchung" geklickt werden
                    if ($('#table_patient_agreement_create_form').find('.tt-show-examination-dialog').length && $('#table_patient_agreement_create_form').find('.tt-show-examination-dialog').val() === 'true'
                    && $('#table_patient_agreement_create_form').find('[name="agreement"][value="0"]').length && $('#table_patient_agreement_create_form').find('[name="agreement"][value="0"]')[0].checked) {
                        utils.updateGlobals('elementToClickAfterSave', $('#content').find('.tt-create-examination'));
                    }

				} else if (form.id === "table_patientlist_delete_form") {

					action = action.replace('patient/0', 'patient/' + views.getPatientId());
					var deleteReason = $(form).find("input:radio[name ='delete_reason']:checked").val();

					if (deleteReason === 'not_treated_anymore' || deleteReason === 'canceled_agreement') {

						var title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_patient_x', {"patient": "<span class='txt-color-orangeDark'><strong>" + views.setPatientDisplayName() + "</strong></span>"});
						var content = '';
						if (deleteReason === 'not_treated_anymore') {
							content = Lang.get('tripletrax.delete_patient_not_treated_anymore');
						} else if (deleteReason === 'canceled_agreement') {
							content = Lang.get('tripletrax.delete_patient_canceled_agreement');
						}

						$.SmartMessageBox({
							title: title,
							content: content,
							buttons: '[' + Lang.get('tripletrax.ok') + ']'
						}, function (ButtonPressed) {
							if (ButtonPressed === Lang.get('tripletrax.ok')) {
								$(form).parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
							}
						});

						return;
					}

				} else if (form.id === "table_patient_examination_create_form") {

					action = action + '/' + views.getExaminationId() + '/model/' + views.getModelId() + '/patient/' + views.getPatientId() + '/checkupdate/' + getExaminationDateFromForm(form);

				} else if (form.id === "staging_form") {
					$('.tt-please-wait-staging').removeClass('hide');
					$('.tt-info-do-staging').addClass('hide');
					$('.tt-please-wait-staging').addClass('hide');
					$('.tt-done-staging').removeClass('hide');

				} else if (form.id === "table_merge_patients_1_form") {

					$('[name="merge_patient_time_stamp"]').val($.now());

					$('.tt-please-wait-conflict-check').removeClass('hide');

				} else if (form.id === "table_merge_patients_2_form") {

					$('.tt-merge-conflict-step-3').removeClass('alert-info');
					$('.tt-merge-conflict-step-3').addClass('alert-success');

					$('.tt-merge-patients-button').addClass('hide');

					$('.tt-merge-conflict-section').addClass('hide');
					$('.tt-merge-patients-section').removeClass('hide');

				} else if (form.id === "email_compose_form" || form.id === "email_completeness_form") {

					processData = false;
					contentType = false;

				} else if (form.id === "restore_patient_form" && $(form).find('[name="restore_action"]').val() === "restore") {

					action = 'admin/restore/patient/' + $(form).find('[name="pseudonym"]').val();

				} else if (form.id === "table_completeness_create_form") {

					$('#table_completeness').DataTable().clear().draw();
					$('#table_completeness').find('.dataTables_empty').text('').append('<h1><i class="fad fa-cog fa-spin"></i> ' + Lang.get('tripletrax.loading') + '...</h1>');

				} else if (form.id === "table_aggregation_execution_3_form") {

					$('[name="aggregation_time_stamp"]').val($.now());

					$('#table_aggregation_preview').DataTable().clear().draw();
					$('#table_aggregation_preview').find('.dataTables_empty').text('').append('<h1><i class="fad fa-cog fa-spin"></i> ' + Lang.get('tripletrax.loading') + '...</h1>');

				} else if (form.id === "table_patient_questionnaires_create_form") {

					action = 'doc/patient/patient/questionnaires/facility/' + views.getFacilityId() + '/model/' + views.getModelId() + '/patient/' + views.getPatientId() + '/examination/' + views.getExaminationDate();

                } else if (views.isDevice()) {

				    action = $(form).parents('.tt-content-detail').find('#route').val();
				    method = 'POST';
				}

				var doInitializeElements = false;
				if (utils.GLOBALS.elementToClickAfterSave === null) {
					doInitializeElements = true;
				}
				getFormData(form).done(function (data) {

					var originalData = data;

					ajax.ajaxCallExtended(action, method, data, false, processData, contentType, null, null, function (data) {

						var doClickElements = true;
						if (form.id === "table_users_detail_form" || form.id === "table_facilities_detail_form" || form.id === "table_roles_detail_form" || form.id === "table_news_detail_form"
							|| form.id === "table_documents_detail_form" || form.id === "table_data_collection_types_detail_form" || form.id === "table_monitoring_detail_form" || form.id === "table_aggregation_definition_detail_form"
                            || form.id === "table_devices_detail_form" || form.id === "table_agreement_types_detail_form" || form.id === "table_freeze_facility_data_detail_form") {

							showDetailData(data, element, form, validator, doInitializeElements, false);

						} else if (form.id === "table_devices_create_form") {

							showDetailData(data, element, form, validator, doInitializeElements, true);

						} else if (form.id === "table_users_create_form" || form.id === "table_facilities_create_form" || form.id === "table_roles_create_form" || form.id === "table_news_create_form"
							|| form.id === "table_documents_create_form" || form.id === "table_data_collection_types_create_form" || form.id === "table_monitoring_create_form" || form.id === "table_aggregation_create_form" || form.id === "table_agreement_types_create_form") {

							showNewDetailData(data, element, form, validator, doInitializeElements);

						} else if (form.id === "table_users_change_password_form") {

							if (data === '') {
								element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
							} else {
								validator.showErrors({'password': data});
							}

						} else if (form.id === "table_data_views_create_form") {

							showNewDataViewDetailData(data, element, form, doInitializeElements);

						} else if (form.id === "table_data_views_detail_form") {

							doClickElements = false;
							nestable.showDataViewNestableItemClicked(data);

						} else if (form.id === "table_agreement_type_documents_form") {

							addAgreementTypeDocumentToList(data, element, form);

						} else if (form.id === "settings_language_form") {

							$('#settings_language_form').trigger('reinitialize.areYouSure');
							$('#settings_language_form').removeClass('dirty');
							$('#settings_import_export_form').trigger('reinitialize.areYouSure');
							$('#settings_import_export_form').removeClass('dirty');
							$('#settings_form').trigger('reinitialize.areYouSure');
							$('#settings_form').removeClass('dirty');

							if (access.getRight($('#content').find('.tt-save'), 'update') > 0) {
								$('#content').find('.tt-save').removeClass('disabled');
								$('#content').find('.tt-save').prop('disabled', '');
							}

							if (access.getRight($('#content').find('.tt-save-sub-form'), 'update') > 0) {
								$('#content').find('.tt-save-sub-form').removeClass('disabled');
								$('#content').find('.tt-save-sub-form').prop('disabled', '');
							}

						} else if (form.id === "user_options_form") {

							$('#user_options_form').trigger('reinitialize.areYouSure');
							$('#user_options_form').removeClass('dirty');
							$('#facility_options_form').trigger('reinitialize.areYouSure');
							$('#facility_options_form').removeClass('dirty');

							$('#content').find('.tt-save').removeClass('disabled');
							$('#content').find('.tt-save').prop('disabled', '');

							if (access.getRight($('#content').find('.tt-save-sub-form'), 'update') > 0) {
								$('#content').find('.tt-save-sub-form').removeClass('disabled');
								$('#content').find('.tt-save-sub-form').prop('disabled', '');
							}

                        } else if (form.id === "user_settings_form") {

                            $('#user_settings_form').trigger('reinitialize.areYouSure');
                            $('#user_settings_form').removeClass('dirty');

                            $('#content').find('.tt-save').removeClass('disabled');
                            $('#content').find('.tt-save').prop('disabled', '');

						} else if (form.id === "import_form" || form.id === "import_query_form") {

							importData(data, form);

						} else if (form.id === "export_form" || form.id === "database_export_form") {

							doExport(form, data, originalData);

						} else if (form.id === "delete_patient_finally_form") {

							$(form).find('.tt-patient-finally-deleted').addClass('hide');
							$(form).find('.tt-patient-finally-not-deleted').addClass('hide');

							deletePatientFinally(data, form);

						} else if (form.id === "delete_patient_finally_dialog_form") {

							doDeletePatientFinally(form, $('#delete_patient_finally_form')[0]);

						} else if (form.id === "table_patientlist_create_form") {

							if (data === 'EXISTS') {
								var titleText = $(form).find('[name="patient_pseudonym"]').val();
								if (titleText === '') {
									var patientname = views.getControlValue($(form).find('[data-match-field="patientname"]'));
									var prename = views.getControlValue($(form).find('[data-match-field="prename"]'));
									titleText = patientname.split('=')[0] + ', ' + prename.split('=')[0]
								}
								$.SmartMessageBox({
									title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.save_patient', {"patientname": "<span class='txt-color-orangeDark'><strong>" + titleText + "</strong></span>"}),
									content: Lang.get('tripletrax.save_patient_desc'),
									buttons: '[' + Lang.get('tripletrax.ok') + ']'
								}, function (ButtonPressed) {
								});
							} else if (data !== 'FAILS') {
								patients.loadPatientlist(true).done(function (patientData) {

									var list_data = patients.getPatientlist(patientData);
									$('#table_patientlist').dataTable().api().clear().rows.add(list_data).draw();

									$('#table_patientlist').DataTable().page.jumpToData(parseInt(data), 0);
									changes.tableSingleClick($('#table_patientlist').find('tr[id="' + data + '"]'));

									element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
								});
							}

						} else if (form.id === "table_patient_agreement_create_form") {

                            doClickElements = false;
							reloadAgreementTable(element).done(function () {
                                if (utils.GLOBALS.elementToClickAfterSave != null) {
                                    nestable.clickElement(utils.GLOBALS.elementToClickAfterSave, true);
                                    utils.updateGlobals('elementToClickAfterSave', null);
                                }
                            });

						} else if (form.id === "table_patientlist_delete_form") {

							reloadPatientList(element, false);

						} else if (form.id === "table_patient_examination_create_form") {

							changeExamination(element, form, data);

						} else if (form.id === "table_merge_patients_1_form") {

							utils.setHtmlData($("#content"), data, doInitializeElements);

						} else if (form.id === "table_merge_patients_2_form") {

							doMerge(form, data, originalData);

						} else if (form.id === "email_compose_form") {

							if ($(form).find('[name="mail_folder"]').val() === "sent") {
								// wenn Mail versandt, dann in Posteingang springen und Anzahl der Entwürfe minimieren (nur wenn es sich um eine Mail handelt, welche als Entwurf gespeichert war)
								$('.tt-mail-folder[data-folder-name="inbox"]').click();
								if ($('[name="mail_id"]').val() !== "") {
									if ($('[data-folder-name="draft"]').length) {
										var unreadMails = parseInt($('.inbox-menu-lg').find('[data-folder-name="draft"]').find('strong').text().replace('(', '').replace(')', ''));
										if (unreadMails <= 1) {
											$('.inbox-menu-lg').find('[data-folder-name="draft"]').find('strong').remove();
										} else {
											$('.inbox-menu-lg').find('[data-folder-name="draft"]').find('strong').text('(' + (unreadMails - 1) + ')');
										}
									}
								}
							} else {
								// wenn Mail in Entwürfe gespeichert, dort bleiben und Anzahl in Navigation erhöhen (nur wenn es sich um eine neue Mail handelt)
								if ($('[name="mail_id"]').val() === "") {
									if ($('[data-folder-name="draft"]').length) {
										if ($('[data-folder-name="draft"]').find('strong').length) {
											$('.inbox-menu-lg').find('[data-folder-name="draft"]').find('strong').text('(' + (parseInt($('.inbox-menu-lg').find('[data-folder-name="draft"]').find('strong').text().replace('(', '').replace(')', '')) + 1) + ')');
										} else {
											$('.inbox-menu-lg').find('[data-folder-name="draft"]').append('<strong>(1)</strong>');
										}
									}
								}
								if (data.length === 2) {
									$('[name="mail_id"]').val(data[0]);
									$('[name="mail_attachment_ids"]').val(data[1]);
								}
								$('#content').find('.tt-save').removeClass('disabled');
								$('#content').find('.tt-save').prop('disabled', '');
								$('#content').find('.tt-delete-mail-compose').removeClass('hide');

								if ($('[name="do_print"]').val().toString() === 'true') {
									mails.printMail('doc/mail/' + $('[name="mail_id"]').val() + '/print');
									$('[name="do_print"]').val('false');
								}
							}

							utils.GLOBALS.mailAttachments.length = 0;

						} else if (form.id === "restore_patient_form") {

							var facilities = '';
							$("input:checked", $(form).find('#table_restore_patient_facilities').dataTable().fnGetNodes()).each(function (i, val) {

								if (facilities !== '') {
									facilities += ", ";
								}
								facilities += $(this).parents('tr')[0].cells[2].innerHTML;
							});

							$('.tt-restore-all-patients')[0].checked = false;

							$('.alert-block').find('.patient-restored').html(trans('tripletrax.patient_restored_desc', {facilities: facilities}));
							$('.tt-patient-restored').removeClass('hide');

							$(form).find('[name="pseudonym"]').val('');

							var newTableUrl = 'admin/restore/patient/0/datatable';
							ajax.ajaxCallDeferred(newTableUrl, 'GET', null, false).done(function (data) {
								$('#table_restore_patient_facilities').dataTable().api().clear().rows.add(data).draw();

								$('#content').find('.tt-save').removeClass('disabled');
								$('#content').find('.tt-save').prop('disabled', '');

								if ($('#table_restore_patient_facilities').dataTable().fnGetData().length > 0) {
									$('.tt-restore-patient').removeClass('disabled');
								} else {
									$('.tt-restore-patient').addClass('disabled');
								}
							});

						} else if (form.id === "table_audit_trail_form") {

							//loadAuditTrail(form, data, originalData);
							//showAuditTrailSearchResults(data);
						} else if (form.id === "freeze_data_form") {

							freezeData(data, form);

						} else if (form.id === "password_change_form") {

							if (data === '') {
								element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
							}
							else {
								element.parents('.tt-content-dialog').find('.tt-save').removeAttr('disabled').removeClass('disabled');
								utils.setHtmlData($(form), data, true);
							}
						} else if (form.id === "table_monitoring_restrictions_form") {

							utils.setHtmlData($('#content-detail'), data, false);
							$('[id^="table_monitoring_custom_"]').data('monitoring_restrictions', originalData);
							initialize.initializeElements($('#content-detail'), true, false);

						} else if (form.id === "table_completeness_create_form") {

							$('#table_completeness').dataTable().api().clear().rows.add(data).draw();
							$(form).parents('.tt-content-detail').find('.tt-save').removeClass('disabled');
							$(form).parents('.tt-content-detail').find('.tt-export-completeness-list').removeClass('disabled');
							$(form).parents('.tt-content-detail').find('.tt-compose-mail').removeClass('disabled');

						} else if (form.id === "email_completeness_form") {

							element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();

						} else if (form.id === "table_patient_administration_history_form") {

							$('#table_patient_administration_history').dataTable().api().clear().rows.add(data).draw();
							$(form).parents('.tt-content-detail').find('.tt-show-merge-detail').addClass('disabled');

							$(form).parents('.tt-content-detail').find('.tt-save').removeClass('disabled');

						} else if (form.id === "table_aggregation_execution_1_form") {

							utils.setHtmlData($("#content"), data, doInitializeElements);

						} else if (form.id === "table_aggregation_execution_2_form") {

							utils.setHtmlData($("#content"), data, doInitializeElements);

						} else if (form.id === "table_aggregation_execution_3_form") {

                            if($(form).find('[name="execute_button"]').val() === 'execute') {

								utils.setHtmlData($("#content"), data, doInitializeElements);

								doAggregation(action + '/check', originalData);

							} else if ($(form).find('[name="execute_button"]').val() === 'preview') {
								var firstPatient = Object.keys(data)[0];
								var selectedTab = $(form).parents('.tt-content-detail').find('li.active a').attr('href').substr(1);

								$('.tt-patient-preview').html(views.getPatientDisplayName(firstPatient.split('|')[1], '', '', firstPatient.split('|')[2], firstPatient.split('|')[3], null, null, null));

								$('#table_aggregation_preview').dataTable().api().clear().rows.add(data[firstPatient]).draw();
								$('#table_aggregation_preview').DataTable().search(selectedTab.replace(/"/g, '\\b'), true, true).draw();

								$(form).find('[name="preview_data"]').val(JSON.stringify(data));
								$(form).find('[name="preview_patient"]').val(firstPatient.split('|')[0]);
								$(form).parents('.tt-content-detail').find('.tt-previous-aggregation-preview').addClass('disabled');
								$(form).parents('.tt-content-detail').find('.tt-previous-aggregation-preview').prop('disabled', 'disabled');

								if (data.length <= 1) {
									$(form).parents('.tt-content-detail').find('.tt-next-aggregation-preview').addClass('disabled');
									$(form).parents('.tt-content-detail').find('.tt-next-aggregation-preview').prop('disabled', 'disabled');
								} else {
									$(form).parents('.tt-content-detail').find('.tt-next-aggregation-preview').removeClass('disabled');
									$(form).parents('.tt-content-detail').find('.tt-next-aggregation-preview').removeAttr('disabled');
                                }

								$(form).parents('.tt-content-detail').find('.tt-save').removeClass('disabled');
								$(form).parents('.tt-content-detail').find('.tt-save').removeAttr('disabled');
                            }

						} else if (form.id === "table_patient_questionnaires_create_form") {

						    if (data === '') {
								$.SmartMessageBox({
									title: "<i class='fad fa-exclamation txt-color-orangeDark'></i> " + Lang.get('tripletrax.add_questionnaires', {"patient": "<span class='txt-color-orangeDark'><strong>" + views.setPatientDisplayName() + "</strong></span>"}),
									content: Lang.get('tripletrax.questionnaires_sent_to_device', {"device": "<strong>" + $('[name="questionnaire_device"]').select2('data')[0].text + "</strong></span>"}),
									buttons: '[' + Lang.get('tripletrax.ok') + ']'
								}, function (ButtonPressed) {
									$(form).parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
								});
                            } else if (data === 'exists') {
								$.SmartMessageBox({
									title: "<i class='fad fa-exclamation txt-color-orangeDark'></i> " + Lang.get('tripletrax.add_questionnaires', {"patient": "<span class='txt-color-orangeDark'><strong>" + views.setPatientDisplayName() + "</strong></span>"}),
									content: Lang.get('tripletrax.questionnaires_not_sent_to_device', {"device": "<strong>" + $('[name="questionnaire_device"]').select2('data')[0].text + "</strong></span>"}),
									buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
								}, function (ButtonPressed) {
									if (ButtonPressed === Lang.get('tripletrax.yes')) {

									    var questionnaireData = originalData + '&send_data=true';

										ajax.ajaxCallExtended(action, method, questionnaireData, false, processData, contentType, null, null, function (data) {
											$.SmartMessageBox({
												title: "<i class='fad fa-exclamation txt-color-orangeDark'></i> " + Lang.get('tripletrax.add_questionnaires', {"patient": "<span class='txt-color-orangeDark'><strong>" + views.setPatientDisplayName() + "</strong></span>"}),
												content: Lang.get('tripletrax.questionnaires_sent_to_device', {"device": "<strong>" + $('[name="questionnaire_device"]').select2('data')[0].text + "</strong></span>"}),
												buttons: '[' + Lang.get('tripletrax.ok') + ']'
											}, function (ButtonPressed) {
												$(form).parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
											});
										});
									}
									$(form).parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
								});
							}



						} else if (views.isDevice()) {

							utils.setHtmlData($('#content'), data, true);
							utils.setIDATData($('#content'));
							$('.tt-btn-eraser,.tt-btn-query').addClass('hide');
							if ($('.tt-show-questionnaires').length) {
								addQuestionnairesRules($('#content').find('form'));
							}

						}

						if (doClickElements) {
							if (utils.GLOBALS.elementToClickAfterSave != null) {
								nestable.clickElement(utils.GLOBALS.elementToClickAfterSave, true);
								utils.updateGlobals('elementToClickAfterSave', null);
							}
							if (utils.GLOBALS.secondElementToClickAfterSave != null) {
								nestable.clickElement(utils.GLOBALS.secondElementToClickAfterSave, true);
								utils.updateGlobals('secondElementToClickAfterSave', null);
							}
						}
					});
				});
			}
		}

        var showInformationBox = function (form) {
            $(form.target).parents('.tt-content-detail').find('.tt-save').removeClass('disabled');
            if (utils.GLOBALS.showValidationErrorMessageBox) {
                showValidationMessage();
            }
        }

        $(this).validate({

			errorClass: 'invalid',

			validClass: 'valid',

			errorElement: 'em',

            debug: false,

            ignore: getIgnore(element),

            rules: getRules(element),

            messages: getMessages(element),

            submitHandler: submitForm,

            invalidHandler: showInformationBox,

            errorPlacement: function (error, element) {
                if (element[0].type === "radio" || element.hasClass('tt-select-with-dropdown') || element.hasClass('tt-control-in-inline-group')) {
                    error.insertAfter(element.parent().parent());
                } else {
                    error.insertAfter(element.parent());
                }
            },

            highlight: function (element, errorClass, validClass) {
                if ($(element).parents('form').length && $(element).parents('form')[0].id === 'table_patient_examination_create_form') {
                    $(element).parents('.tt-content-dialog').find('.tt-save-examination').removeClass('disabled');
                }
                if (element.type === "radio" || $(element).hasClass('tt-select-with-dropdown') || $(element).hasClass('tt-control-in-inline-group')) {
                    this.findByName(element.name).addClass(errorClass).removeClass(validClass).parent().addClass('state-error');
                    $(element).parent().addClass(errorClass).removeClass(validClass).parent().addClass('state-error');
                } else {
                    $(element).addClass(errorClass).removeClass(validClass).parent().addClass('state-error');
                }
            },

            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "radio" || $(element).hasClass('tt-select-with-dropdown') || $(element).hasClass('tt-control-in-inline-group')) {
                    var control = this.findByName(element.name);
                    if (!control.hasClass('tt-view-input') && !control.hasClass('tt-view-textarea') && !control.hasClass('tt-view-combo') && !control.hasClass('tt-view-combo-multiselect') && !control.hasClass('tt-view-checkbox') && !control.hasClass('tt-view-radio')) {
                        if (!control.hasClass('tt-view-datepanel') || utils.isUndefined(control.attr('data-integrity-rule')) || control.attr('data-integrity-rule') === '') {
                            control.removeClass(errorClass).addClass(validClass).parent().removeClass('state-error');
                            $(element).parent().removeClass(errorClass).addClass(validClass).parent().removeClass('state-error');
                        }
                    }
                } else {
                    if (!$(element).hasClass('tt-view-input') && !$(element).hasClass('tt-view-textarea') && !$(element).hasClass('tt-view-combo') && !$(element).hasClass('tt-view-combo-multiselect') && !$(element).hasClass('tt-view-checkbox') && !$(element).hasClass('tt-view-radio')) {
                        if (!$(element).hasClass('tt-view-datepanel') || utils.isUndefined($(element).attr('data-integrity-rule')) || $(element).attr('data-integrity-rule') === '') {
                            $(element).removeClass(errorClass).addClass(validClass).parent().removeClass('state-error');
                        }
                    }
                }
            }
        });

        $(this).addClass("validation-container");
    });
}

function getExaminationDateFromForm(form) {

    var date = utils.dateToString($(form).parents('.tt-content-dialog').find('.datepicker').data('picker').getDate());
    var timeArray = $(form).parents('.tt-content-dialog').find('.timepicker').timepicker().val().split(':');
    var time = '';
    if (timeArray.length === 2) {
        time = ('00' + timeArray[0]).substr(timeArray[0].length) + ':' + ('00' + timeArray[1]).substr(timeArray[1].length) + ':00';
    } else {
        time = ('00' + timeArray[0]).substr(timeArray[0].length) + ':00:00';
    }

    return date + ' ' + time;
}

function getFormData(form) {

    return $.Deferred(function (defer) {
		var data = [];
        if (form.id === "table_patient_examination_transfer_form") {
			data = utils.getSerializedFormDataWithoutIgnore(form, '', true);
        } else {
			data = utils.getSerializedFormData(form);
		}

        if (form.id === "table_users_detail_form") {

            data = addDataUsers(data);
            defer.resolve(data);

        } else if (form.id === "table_roles_detail_form") {

            data = addDataRoles(data);
            defer.resolve(data);

        } else if (form.id === "table_data_collection_types_detail_form") {

            data = addDataCollectionType(data);
            defer.resolve(data);

        } else if (form.id === "table_agreement_types_detail_form") {

            data = addAgreementType(data);
            defer.resolve(data);

        } else if (form.id === "table_agreement_type_documents_form") {

            data = new FormData(form);
            defer.resolve(data);

        } else if (form.id === "table_monitoring_detail_form" || form.id === "table_monitoring_restrictions_form") {

            data = addDataMonitoring(data);
            defer.resolve(data);

        } else if (form.id === "import_form" || form.id === "import_query_form") {

            data = new FormData(form);
            defer.resolve(data);

        } else if (form.id === "table_patientlist_create_form") {

            var birthDate = views.getControlValue($(form).find('[data-match-field="birth_date"]'));
            var gender = views.getControlValue($(form).find('[data-match-field="gender"]'));

            if ($('#locale').data().pseudonymization !== 'none') {
                var pseudonym = $(form).find('[name="patient_pseudonym"]').val();
                if (utils.isUndefined(pseudonym) || pseudonym === '') {
                    var patientname = views.getControlValue($(form).find('[data-match-field="patientname"]'));
                    var prename = views.getControlValue($(form).find('[data-match-field="prename"]'));
                    var street = views.getControlValue($(form).find('[data-match-field="street"]'));
                    var postalCode = views.getControlValue($(form).find('[data-match-field="postal_code"]'));
                    var city = views.getControlValue($(form).find('[data-match-field="city"]'));
                    var birthName = views.getControlValue($(form).find('[data-match-field="birth_name"]'));
                    var birthCity = views.getControlValue($(form).find('[data-match-field="birth_city"]'));
                    patients.addPatientToIDAT(prename, patientname, birthDate, gender, street, postalCode, city, birthName, birthCity).done(function (pseudonym) {
                        if (pseudonym === '409') {
                            $.SmartMessageBox({
                                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.save_patient', {"patientname": "<span class='txt-color-orangeDark'><strong>" + patientname.split('=')[0] + ', ' + prename.split('=')[0] + "</strong></span>"}),
                                content: Lang.get('tripletrax.save_patient_idat_error_409'),
                                buttons: '[' + Lang.get('tripletrax.ok') + ']'
                            }, function (ButtonPressed) {
                                $(form).parents('.tt-content-dialog').find('.tt-save').removeAttr('disabled').removeClass('disabled');
                            });
                            defer.reject();
                        } else if (pseudonym === '' || utils.isUndefined(pseudonym)) {
                            $.SmartMessageBox({
                                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.save_patient', {"patientname": "<span class='txt-color-orangeDark'><strong>" + patientname.split('=')[0] + ', ' + prename.split('=')[0] + "</strong></span>"}),
                                content: Lang.get('tripletrax.save_patient_idat_desc'),
                                buttons: '[' + Lang.get('tripletrax.ok') + ']'
                            }, function (ButtonPressed) {
                                $(form).parents('.tt-content-dialog').find('.tt-save').removeAttr('disabled').removeClass('disabled');
                            });
                            defer.reject();
                        } else {

                            data = utils.getSerializedFormDataWithoutIgnore(form, utils.getIgnoreFields(), false) + "&pseudonym=" + encodeURIComponent(pseudonym);

                            if (birthDate.split('=')[0] !== '') {
                                if (data !== '') {
                                    data += '&';
                                }
                                data += $(form).find('[data-match-field="birth_date"]').attr('name') + '=' + birthDate.split('=')[0].substr(0, 8) + '15';
                                data += '&' + $(form).find('[data-match-field="birth_date"]').attr('name') + '_format=mm/yy';
                            }
                            if (gender.split('=')[0] !== '') {
                                if (data !== '') {
                                    data += '&';
                                }
                                data += $(form).find('[data-match-field="gender"]').attr('name') + '=' + gender.split('=')[0];
                            }
                            defer.resolve(data);
                        }
                    });
                } else {
                    patients.addPatientToIDATWithPseudonym(pseudonym).done(function (idatData) {
                        if (idatData === '' || utils.isUndefined(idatData) || idatData.length <= 0) {
                            $.SmartMessageBox({
                                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.save_patient', {"patientname": "<span class='txt-color-orangeDark'><strong>" + pseudonym + "</strong></span>"}),
                                content: Lang.get('tripletrax.save_patient_idat_with_pseudonym_desc'),
                                buttons: '[' + Lang.get('tripletrax.ok') + ']'
                            }, function (ButtonPressed) {
                                $(form).parents('.tt-content-dialog').find('.tt-save').removeAttr('disabled').removeClass('disabled');
                            });
                            defer.reject();
                        } else {

                            data = utils.getSerializedFormDataWithoutIgnore(form, utils.getIgnoreFields(), false) + "&pseudonym=" + encodeURIComponent(pseudonym);

                            if (idatData[0]["ids"][0]["idString"] === pseudonym) {

                                if (data !== '') {
                                    data += '&';
                                }
                                data += $(form).find('[data-match-field="birth_date"]').attr('name') + '=' + idatData[0]["fields"]["geburtsjahr"] + '-' + idatData[0]["fields"]["geburtsmonat"] + '-' + '15';
                                data += '&' + $(form).find('[data-match-field="birth_date"]').attr('name') + '_format=mm/yy';

                                var genderMatchValues = $('#gender_values').data().matchValues;
                                var gender = idatData[0]["fields"]["geschlecht"];
                                if (gender === 'M' && !utils.isUndefined(genderMatchValues["male"])) {
                                    gender = genderMatchValues["male"];
                                } else if (gender === 'W' && !utils.isUndefined(genderMatchValues["female"])) {
                                    gender = genderMatchValues["female"];
                                }
                                if (data !== '') {
                                    data += '&';
                                }
                                data += $(form).find('[data-match-field="gender"]').attr('name') + '=' + gender;
                            }

                            defer.resolve(data);
                        }
                    });
                }
            } else {
                var pseudonym = views.getControlValue($(form).find('[data-match-field="pseudonym"]'));
                data = utils.getSerializedFormDataWithoutIgnore(form, utils.getIgnoreFields(), false) + "&pseudonym=" + encodeURIComponent(pseudonym.split('=')[0]);

                if (birthDate.split('=')[0] !== '') {
                    if (data !== '') {
                        data += '&';
                    }
                    data += $(form).find('[data-match-field="birth_date"]').attr('name') + '=' + birthDate.split('=')[0].substr(0, 8) + '15';
                    data += '&' + $(form).find('[data-match-field="birth_date"]').attr('name') + '_format=mm/yy';
                }
                if (gender.split('=')[0] !== '') {
                    if (data !== '') {
                        data += '&';
                    }
                    data += $(form).find('[data-match-field="gender"]').attr('name') + '=' + gender.split('=')[0];
                }

                defer.resolve(data);
            }
        } else if (form.id === "export_form") {

            data = addExportTreeItems(form, data);
            defer.resolve(data);

        } else if (form.id === "database_export_form") {

            data = addDatabaseExportTreeItems(form, data);
            defer.resolve(data);

        } else if (form.id === "settings_language_form") {

            data = addDataSettings();
            defer.resolve(data);

        } else if (form.id === "user_settings_form") {

            data = addDataUserSettings();
            defer.resolve(data);

        } else if (form.id === "user_options_form") {

            data = addDataOptions();
            defer.resolve(data);

        } else if (form.id === "table_merge_patients_2_form") {

            data = addResolvedMergeConflicts(data);
            defer.resolve(data);

        } else if (form.id === "table_news_detail_form") {

            data = addDataNews(data);
            defer.resolve(data);

        } else if (form.id === "table_documents_detail_form") {

            var formData = data.split('&');
            data = new FormData(form);
            data = addDataDocuments(data);
            for (var i = 0; i < formData.length; i++) {
                var fieldValue = formData[i].split('=');
                data.append(decodeURIComponent(fieldValue[0]), decodeURIComponent(fieldValue[1]));
            }
            defer.resolve(data);

        } else if (form.id === "email_compose_form"  || form.id === "email_completeness_form") {

            data = addDataMail(form);
            defer.resolve(data);

        } else if (form.id === "restore_patient_form") {

            data = addRestorePatientItems(form);
            defer.resolve(data);

        } else if (form.id === "table_freeze_facility_data_detail_form") {

            data = addDataFreezeFacilityData(data);
            defer.resolve(data);

		} else if (views.isDevice()) {

			data += '&' + jQuery.param({ questionnaires: $(form).parents('.tt-content-detail').find('#questionnaires').val(), app_locale: $(form).parents('.tt-content-detail').find('#app_locale').val(), signer: $(form).parents('.tt-content-detail').find('#signer').val() });
			defer.resolve(data);

        } else {
            defer.resolve(data);
        }
    }).promise();
}

function showValidationMessage() {

    if (views.isDevice()) {
		$.smallBox({
			title: trans('device/content/questionnaires.validation_device', [], $('#app_locale').val()),
			content: trans('device/content/questionnaires.validation_device_message', [], $('#app_locale').val()),
			color: "#CA4862",
			sound: $.sound_off,
			iconSmall: "fad fa-bell swing animated",
			timeout: 6000
		});
    } else {
		$.smallBox({
			title: trans('tripletrax.validation'),
			content: trans('tripletrax.validation_message'),
			color: "#CA4862",
			sound: $.sound_off,
			iconSmall: "fad fa-bell swing animated",
			timeout: 4000
		});
	}
}

function getRules(element) {

    var rules = {};

    if (element[0].id === "table_users_detail_form" || element[0].id === "table_users_create_form") {
        rules = {
            username: {
                required: true,
                validUsername: true,
                uniqueUsername: true
            },
            firstname: {
                required: true
            },
            name: {
                required: true
            },
            email: {
                required: true,
                email: true
            },
            password_lifetime: {
                required: true,
                digits: true,
                min: 0
            },
            password: {
                required: true,
                minlength: 8,
                minNonAlpha: 2
            },
            password_repetition_new: {
                equalTo: '#password_new'
            },
            password_repetition_change: {
                equalTo: '#password_change'
            }
        };
    } else if (element[0].id === "table_users_change_password_form") {
        rules = {
            password: {
                required: true,
                minlength: 8,
                minNonAlpha: 2
            },
            password_repetition_new: {
                equalTo: '#password_new'
            },
            password_repetition_change: {
                equalTo: '#password_change'
            }
        };
    } else if (element[0].id === "table_users_roles_form") {
        rules = {
            facility: {
                required: true,
                existingFacility: true
            },
            table_user_facility_roles: {
                atLeastOneRole: true
            }
        };
    } else if (element[0].id === "table_facilities_detail_form" || element[0].id === "table_facilities_create_form") {
        rules = {
            facilityname: {
                required: true,
                uniqueFacilityname: true
            },
            facilitycity: {
                required: true
            },
            facilityid: {
                required: true,
                digits: true,
                min: 0,
                uniqueFacilityid: true
            },
            contact_medical_email: {
                email: true
            },
            contact_technical_email: {
                email: true
            }
        };
    } else if (element[0].id === "table_roles_detail_form" || element[0].id === "table_roles_create_form") {
        rules = {
            rolename: {
                required: true,
                uniqueRolename: true
            },
            roledescription: {
                required: true
            }
        };
    } else if (element[0].id === "table_data_collection_types_detail_form" || element[0].id === "table_data_collection_types_create_form") {
        rules = {
            model: {
                required: true,
                uniqueModel: true
            },
            abbreviation: {
                required: true,
                uniqueAbbreviation: true,
                maxlength: 15
            },
            datacollectiontype: {
                required: true
            },
            agreementtype: {
                required: true
            },
            given_period_radio: {
                required: true
            },
            completeness_notification_radio: {
                required: true
            },
            period_active_patients: {
                required: true,
                min: 0
            },
            period_examinationlist_active_patients: {
                required: true,
                minWithDropdown: 0
            },
            period_examinationlist_inactive_patients: {
                required: true,
                minWithDropdown: 0
            },
            examinationdate_format: {
                required: true
            },
            depending_models: {
                required: true
            },
			device_roles: {
                required: true
            }
        };
    } else if (element[0].id === "table_data_collection_types_detail_master_views_form") {
        rules = {
            table_data_collection_type_master_views: {
                atLeastOneMasterView: true
            }
        };
    } else if (element[0].id === "table_data_collection_type_master_views_form") {
        rules = {
            master_view: {
                required: true,
                existingMasterView: true,
                existingMasterViewMatchFields: true
            }
        };
    } else if (element[0].id === "table_data_collection_type_course_views_register_form") {
        rules = {
            course_view_register: {
                required: true,
                existingCourseViewRegister: true,
                existingCourseViewMatchFields: true
            }
        };
	} else if (element[0].id === "table_data_collection_type_questionnaire_projects_form") {
		rules = {
			course_view_register: {
				required: true,
				existingQuestionnaireProject: true
			}
		};
	} else if (element[0].id === "table_data_collection_type_questionnaires_form") {
		rules = {
			questionnaire: {
				required: true,
				existingQuestionnaire: true,
				existingCourseViewMatchFields: true
			}
		};
    } else if (element[0].id === "table_data_collection_type_course_views_study_new_form") {
        rules = {
            course_view_study_new: {
                required: true,
                existingCourseViewStudy: true,
                existingCourseViewMatchFields: true
            }
        };
    } else if (element[0].id === "table_data_views_create_form") {
        if ($(element[0]).find('.tt-existing-element').length > 0) {
            rules = {
                viewname: {
                    requireFromGroup: [1, '.element-group']
                },
                element: {
                    requiredWhenElementFilled: ['.tt-new-element']
                },
                existing_element: {
                    requireFromGroup: [1, '.element-group']
                }
            };
        } else {
            rules = {
                viewname: {
                    required: true
                },
                element: {
                    required: true
                }
            };
        }
    } else if (element[0].id === "table_data_views_control_type_create_value_form" || element[0].id === "table_data_views_control_type_form") {
        rules = {
            control_type_value: {
                required: true,
                maxlength: 255,
                uniqueControlTypeValue: true,
                validText: '#|'
            },
            value_in_database: {
                required: true,
                maxlength: 255,
                uniqueValueInDatabase: true,
                validControlTypeDatabaseValue: true
            },
            score_value: {
                integer: true
            },
            aggregation_value: {
                integer: true,
				uniqueAggregationValue: true
            }
        };
    } else if (element[0].id === "table_agreement_type_documents_form") {
        rules = {
            document_description: {
                required: true,
                validDocumentName: true
            },
            document_filename: {
                required: true
            }
        };
    } else if (element[0].id === "table_data_views_units_form" || element[0].id === "table_data_views_units_create_form") {
        rules = {
            unit: {
                required: true,
                maxlength: 80,
                existingNewUnit: true,
                existingUnit: true,
                validText: '#|'
            },
            conversion_factor: {
				requireFromGroup: [1, '.tt-conversion-element'],
                minLocale: 0
            },
			conversion_formula: {
				requireFromGroup: [1, '.tt-conversion-element']
			},
            display_decimals: {
                required: true,
                digits: true,
                min: 0
            }
        };
    } else if (element[0].id === "table_data_views_detail_form") {
        rules = {
            name: {
                required: true,
                maxlength: 100,
                validDataViewName: true,
                uniqueDataViewName: true
            },
            desc: {
                required: true
            },
            match: {
                uniqueMatchField: true
            }
        }

        if ($(element).find('[name="no_complications_value"]').length && ($(element).find('[name="control_type"]').val() === 'input' || $(element).find('[name="control_type"]').val() === 'input_with_additionalfield')) {
            no_complications_value_rules = {
                no_complications_value: {
                    maxlength: 255
                }
            }
            $.extend(rules, no_complications_value_rules);
        }

        if ($(element).find('[name="not_collected_value"]').length && ($(element).find('[name="control_type"]').val() === 'input' || $(element).find('[name="control_type"]').val() === 'input_with_additionalfield')) {
            not_collected_value_rules = {
                not_collected_value: {
                    maxlength: 255
                }
            }
            $.extend(rules, not_collected_value_rules);
        }

        if ($(element).find('[name="display"]').length) {
            rules_display = {
                display: {
                    required: true
                }
            }
            $.extend(rules, rules_display);
        }

        if ($(element).find('[name="page_length"]').length) {
            rules_page_length = {
                page_length: {
                    required: true,
                    digits: true,
                    min: 0
                }
            }
            $.extend(rules, rules_page_length);
        }

		if ($(element).find('[name="repetition"]').length) {
			rules_repetition = {
				repetition: {
					required: true,
					digits: true,
					min: 1
				}
			}
			$.extend(rules, rules_repetition);
		}

        if ($(element).find('[name="column_width"]').length) {
            rules_column_width = {
                column_width: {
                    required: true,
                    digits: true,
                    min: 0
                }
            }
            $.extend(rules, rules_column_width);
        }

        if ($(element).find('[name="max_width"]').length) {
            rules_max_width = {
                max_width: {
                    digits: true,
                    min: 0
                }
            }
            $.extend(rules, rules_max_width);
        }

        if ($(element).find('[name="row_count"]').length) {
            rules_row_count = {
                row_count: {
                    required: true,
                    digits: true,
                    min: 1
                }
            }
            $.extend(rules, rules_row_count);
        }

        if ($(element).find('[name="format_fields"]').length && ($(element).find('[name="control_type"]').val() === 'date_panel' || $(element).find('[name="control_type"]').val() === 'date_range')) {
            rules_format_fields = {
                format_fields: {
                    requiredDateFormat: true
                }
            }
            $.extend(rules, rules_format_fields);
        }

        var controlTypeRadioComboList = ['group_with_radio', 'list_with_radio', 'accordion_as_list_with_radio', 'column_with_radio', 'accordion_with_radio', 'combo', 'combo_multiselect', 'radio', 'combo_with_additionalfield', 'combo_multiselect_with_additionalfield', 'radio_with_additionalfield', 'combo_with_two_additionalfields', 'combo_multiselect_with_two_additionalfields', 'radio_with_two_additionalfields'];
        if (jQuery.inArray($(element).find('[name="control_type"]').val(), controlTypeRadioComboList) >= 0) {
            rules_control_type_values = {
                control_type: {
                    existingControlTypeValues: true
                }
            }
            $.extend(rules, rules_control_type_values);
        }

        if ($(element).find('[name="calculation"]').val() !== '') {
            rules_calculation = {
                calculation: {
                    correctCalculationFields: true
                }
            }
            $.extend(rules, rules_calculation);
        }

        if ($(element).find('[name="name_additionalfield_1"]').length) {
            rules_additionalfield_1 = {
                name_additionalfield_1: {
                    required: true,
                    maxlength: 100,
                    validDataViewName: true,
                    uniqueDataViewName: true
                },
                desc_additionalfield_1: {
                    required: true
                },
                control_type_additionalfield_1: {
                    required: true
                },
                match_additionalfield_1: {
                    uniqueMatchField: true
                }
            }
            $.extend(rules, rules_additionalfield_1);

            if ($(element).find('[name="calculation_additionalfield_1"]').val() !== '') {
                rules_calculation = {
                    calculation_additionalfield_1: {
                        correctCalculationFields: true
                    }
                }
                $.extend(rules, rules_calculation);
            }

            if ($(element).find('[name="control_type_additionalfield_1"]').val() === 'radio') {
                rules_display_additionalfield_1 = {
                    display_additionalfield_1: {
                        required: true
                    },
                    control_type_additionalfield_1: {
                        existingControlTypeValues: true
                    }
                }
                $.extend(rules, rules_display_additionalfield_1);
            } else if ($(element).find('[name="control_type_additionalfield_1"]').val() === 'input') {

                rules_data_type = {
                    data_type_additionalfield_1: {
                        required: true
                    }
                }
                $.extend(rules, rules_data_type);

                rules_data_type_length = {};
                if ($(element).find('[name="data_type_additionalfield_1"]').val() === 'decimal') {
                    rules_data_type_length = {
                        data_type_length_additionalfield_1: {
                            required: true,
                            min: 1,
                            max: 20.0
                        }
                    }
                } else if ($(element).find('[name="data_type_additionalfield_1"]').val() === 'integer') {
                    rules_data_type_length = {
                        data_type_length_additionalfield_1: {
                            required: true,
                            digits: true,
                            min: 1,
                            max: 20
                        }
                    }
                } else if ($(element).find('[name="data_type_additionalfield_1"]').val() === 'text') {
                    rules_data_type_length = {
                        data_type_length_additionalfield_1: {
                            required: true,
                            digits: true,
                            min: 0,
                            max: 255
                        }
                    }
                }
                $.extend(rules, rules_data_type_length);
            } else if ($(element).find('[name="control_type_additionalfield_1"]').val() === 'date_panel' || $(element).find('[name="control_type_additionalfield_1"]').val() === 'date_range') {
                rules_format_fields = {
                    format_fields_additionalfield_1: {
                        requiredDateFormat: true
                    }
                }
                $.extend(rules, rules_format_fields);
            } else if ($(element).find('[name="control_type_additionalfield_1"]').val() === 'combo' || $(element).find('[name="control_type_additionalfield_1"]').val() === 'combo_multiselect') {
                rules_control_type_values_additionalfield_1 = {
                    control_type_additionalfield_1: {
                        existingControlTypeValues: true
                    }
                }
                $.extend(rules, rules_control_type_values_additionalfield_1);
            }
        }

        if ($(element).find('[name="name_additionalfield_2"]').length) {
            rules_additionalfield_2 = {
                name_additionalfield_2: {
                    required: true,
                    maxlength: 100,
                    validDataViewName: true,
                    uniqueDataViewName: true
                },
                desc_additionalfield_2: {
                    required: true
                },
                control_type_additionalfield_2: {
                    required: true
                },
                match_additionalfield_2: {
                    uniqueMatchField: true
                }
            }
            $.extend(rules, rules_additionalfield_2);

            if ($(element).find('[name="control_type_additionalfield_2"]').val() === 'radio') {
                rules_display_additionalfield_2 = {
                    display_additionalfield_2: {
                        required: true
                    },
                    control_type_additionalfield_2: {
                        existingControlTypeValues: true
                    }
                }
                $.extend(rules, rules_display_additionalfield_2);
            } else if ($(element).find('[name="control_type_additionalfield_2"]').val() === 'input') {
                rules_data_type = {
                    data_type_additionalfield_2: {
                        required: true
                    }
                }
                $.extend(rules, rules_data_type);

                rules_data_type_length = {};
                if ($(element).find('[name="data_type_additionalfield_2"]').val() === 'decimal') {
                    rules_data_type_length = {
                        data_type_length_additionalfield_2: {
                            required: true,
                            min: 1,
                            max: 20.0
                        }
                    }
                } else if ($(element).find('[name="data_type_additionalfield_2"]').val() === 'integer') {
                    rules_data_type_length = {
                        data_type_length_additionalfield_2: {
                            required: true,
                            digits: true,
                            min: 1,
                            max: 20
                        }
                    }
                } else if ($(element).find('[name="data_type_additionalfield_2"]').val() === 'text') {
                    rules_data_type_length = {
                        data_type_length_additionalfield_2: {
                            required: true,
                            digits: true,
                            min: 0,
                            max: 255
                        }
                    }
                }
                $.extend(rules, rules_data_type_length);
            } else if ($(element).find('[name="control_type_additionalfield_2"]').val() === 'date_panel' || $(element).find('[name="control_type_additionalfield_2"]').val() === 'date_range') {
                rules_format_fields = {
                    format_fields_additionalfield_2: {
                        requiredDateFormat: true
                    }
                }
                $.extend(rules, rules_format_fields);
            } else if ($(element).find('[name="control_type_additionalfield_2"]').val() === 'combo' || $(element).find('[name="control_type_additionalfield_2"]').val() === 'combo_multiselect') {
                rules_control_type_values_additionalfield_2 = {
                    control_type_additionalfield_2: {
                        existingControlTypeValues: true
                    }
                }
                $.extend(rules, rules_control_type_values_additionalfield_2);
            }
        }

        if ($(element).find('[name="table"]').length && !$(element).find('[data-name="table"]').hasClass('hide')) {
            rules_database = {
                table: {
                    required: true,
                    maxlength: 61,
                    uniqueTableNameAndTableType: true
                },
                table_type: {
                    required: true,
                    uniqueTableNameAndTableType: true
                },
                column: {
                    required: true,
                    validDataViewName: true,
                    maxlength: 65,
                    uniqueColumnNameInTable: true
                },
                column_type: {
                    required: true
                }
            }
            $.extend(rules, rules_database);
        }

        if ($(element).find('[name="column_length"]').length && !$(element).find('[data-name="column_length"]').hasClass('hide')) {
            rules_column_length = {};
            if ($(element).find('[name="column_type"]').val() === 'DECIMAL') {
                rules_column_length = {
                    column_length: {
                        required: true,
                        minLocale: 1,
                        maxLocale: 20.0,
                        validFloatDecimalPlaces: true
                    }
                }
            } else if ($(element).find('[name="column_type"]').val() === 'INT') {
                rules_column_length = {
                    column_length: {
                        required: true,
                        digits: true,
                        min: 1,
                        max: 20
                    }
                }
            } else if ($(element).find('[name="column_type"]').val() === 'VARCHAR') {
                rules_column_length = {
                    column_length: {
                        required: true,
                        digits: true,
                        min: 1,
                        max: 255
                    }
                }
            }
            $.extend(rules, rules_column_length);
        }

        if ($(element).find('[name="column_additionalfield_1"]').length) {
            rules_database_additionalfield_1 = {
                column_additionalfield_1: {
                    required: true,
                    validDataViewName: true,
                    maxlength: 65,
                    uniqueColumnNameInTable: true
                },
                column_type_additionalfield_1: {
                    required: true
                }
            }
            $.extend(rules, rules_database_additionalfield_1);

            if ($(element).find('[name="control_type_additionalfield_1"]').val() !== 'date_panel' || $(element).find('[name="control_type_additionalfield_1"]').val() !== 'date_range') {
                rules_column_length_additionalfield_1 = {};
                if ($(element).find('[name="column_type_additionalfield_1"]').val() === 'DECIMAL') {
                    rules_column_length_additionalfield_1 = {
                        column_length_additionalfield_1: {
                            required: true,
                            minLocale: 1,
                            maxLocale: 20.0,
                            validFloatDecimalPlaces: true
                        }
                    }
                } else if ($(element).find('[name="column_type_additionalfield_1"]').val() === 'INT') {
                    rules_column_length_additionalfield_1 = {
                        column_length_additionalfield_1: {
                            required: true,
                            digits: true,
                            min: 1,
                            max: 20
                        }
                    }
                } else if ($(element).find('[name="column_type_additionalfield_1"]').val() === 'VARCHAR') {
                    rules_column_length_additionalfield_1 = {
                        column_length_additionalfield_1: {
                            required: true,
                            digits: true,
                            min: 1,
                            max: 255
                        }
                    }
                }
                $.extend(rules, rules_column_length_additionalfield_1);
            }
        }

        if ($(element).find('[name="column_additionalfield_2"]').length) {
            rules_database_additionalfield_2 = {
                column_additionalfield_2: {
                    required: true,
                    validDataViewName: true,
                    maxlength: 65,
                    uniqueColumnNameInTable: true
                },
                column_type_additionalfield_2: {
                    required: true
                }
            }
            $.extend(rules, rules_database_additionalfield_2);

            if ($(element).find('[name="control_type_additionalfield_2"]').val() !== 'date_panel' || $(element).find('[name="control_type_additionalfield_2"]').val() !== 'date_range') {
                rules_column_length_additionalfield_2 = {};
                if ($(element).find('[name="column_type_additionalfield_2"]').val() === 'DECIMAL') {
                    rules_column_length_additionalfield_2 = {
                        column_length_additionalfield_2: {
                            required: true,
                            minLocale: 1,
                            maxLocale: 20.0,
                            validFloatDecimalPlaces: true
                        }
                    }
                } else if ($(element).find('[name="column_type_additionalfield_2"]').val() === 'INT') {
                    rules_column_length_additionalfield_2 = {
                        column_length_additionalfield_2: {
                            required: true,
                            digits: true,
                            min: 1,
                            max: 20
                        }
                    }
                } else if ($(element).find('[name="column_type_additionalfield_2"]').val() === 'VARCHAR') {
                    rules_column_length_additionalfield_2 = {
                        column_length_additionalfield_2: {
                            required: true,
                            digits: true,
                            min: 1,
                            max: 255
                        }
                    }
                }
                $.extend(rules, rules_column_length_additionalfield_2);
            }
        }

        if ($(element).find('[name="data_type"]').length) {
            rules_data_type = {
                data_type: {
                    required: true
                }
            }
            $.extend(rules, rules_data_type);

            rules_data_type_length = {};
            if ($(element).find('[name="data_type"]').val() === 'decimal') {
                rules_data_type_length = {
                    data_type_length: {
                        required: true,
                        minLocale: 1.0,
                        maxLocale: 20.0
                    }
                }
            } else if ($(element).find('[name="data_type"]').val() === 'integer') {
                rules_data_type_length = {
                    data_type_length: {
                        required: true,
                        digits: true,
                        min: 1,
                        max: 20
                    }
                }
            } else if ($(element).find('[name="data_type"]').val() === 'text') {
                rules_data_type_length = {
                    data_type_length: {
                        required: true,
                        digits: true,
                        min: 0,
                        max: 255
                    }
                }
            }
            $.extend(rules, rules_data_type_length);
        }

    } else if (element[0].id === "table_data_views_integrities_form" || element[0].id === "table_data_views_integrities_create_form" || element[0].id === "table_collection_type_integrities_form"
        || element[0].id === "table_data_views_restrictions_form" || element[0].id === "table_data_views_restrictions_create_form") {

        if (element[0].id === "table_collection_type_integrities_form") {
            // vordefinierte Regel
            if ((!$(element).find('[name="integrity_type"]').hasClass('select2-container') || utils.isUndefined($(element).find('[name="integrity_type"]').select2('val')) || $(element).find('[name="integrity_type"]').select2('val') === '') &&
                (!$(element).find('[name="integrity_custom_rule"]').hasClass('select2-container') || utils.isUndefined($(element).find('[name="integrity_custom_rule"]').select2('val')) || $(element).find('[name="integrity_custom_rule"]').select2('val') !== '')) {
                rules = {
                    integrity_data_view_field: {
                        required: true
                    },
                    integrity_description: {
                        required: true,
                        maxlength: 200,
                        existingIntegrity: true,
                        existingNewIntegrity: true,
                        validText: '|#$'
                    },
                    integrity_from_date: {
                        validDateRange: ['.tt-begin-integrity', '.tt-end-integrity']
                    },
                    integrity_till_date: {
                        validDateRange: ['.tt-begin-integrity', '.tt-end-integrity']
                    },
                    integrity_type: {
                        requireFromGroup: [1, '.tt-completeness-rule-group']
                    },
                    integrity_custom_rule: {
                        requireFromGroup: [1, '.tt-completeness-rule-group']
                    }
                };
            } else {
                rules = {
                    integrity_data_view_field: {
                        required: true
                    },
                    integrity_description: {
                        required: true,
                        maxlength: 200,
                        existingIntegrity: true,
                        existingNewIntegrity: true,
                        validText: '|#$'
                    },
                    integrity_from_date: {
                        validDateRange: ['.tt-begin-integrity', '.tt-end-integrity']
                    },
                    integrity_till_date: {
                        validDateRange: ['.tt-begin-integrity', '.tt-end-integrity']
                    },
                    integrity_integritytype: {
                        required: true
                    },
                    integrity_gender: {
                        required: true
                    },
                    integrity_type: {
                        requireFromGroup: [1, '.tt-completeness-rule-group']
                    },
                    integrity_custom_rule: {
                        requireFromGroup: [1, '.tt-completeness-rule-group']
                    },
                    integrity_age_from_range: {
                        digits: true,
                        min: 0
                    },
                    integrity_age_till_range: {
                        digits: true,
                        min: 0
                    }
                };
            }
        } else {
            // vordefinierte Regel
            if ((!$(element).find('[name="integrity_type"]').hasClass('select2-container') || utils.isUndefined($(element).find('[name="integrity_type"]').select2('val')) || $(element).find('[name="integrity_type"]').select2('val') === '') &&
                (!$(element).find('[name="integrity_custom_rule"]').hasClass('select2-container') || utils.isUndefined($(element).find('[name="integrity_custom_rule"]').select2('val')) || $(element).find('[name="integrity_custom_rule"]').select2('val') !== '')) {
                rules = {
                    integrity_data_collection_type: {
                        required: true
                    },
                    integrity_description: {
                        required: true,
                        maxlength: 200,
                        existingIntegrity: true,
                        existingNewIntegrity: true,
                        validText: '|#$'
                    },
                    integrity_from_date: {
                        validDateRange: ['.tt-begin-integrity', '.tt-end-integrity']
                    },
                    integrity_till_date: {
                        validDateRange: ['.tt-begin-integrity', '.tt-end-integrity']
                    },
                    integrity_type: {
                        requireFromGroup: [1, '.tt-completeness-rule-group']
                    },
                    integrity_custom_rule: {
                        requireFromGroup: [1, '.tt-completeness-rule-group']
                    }
                };
            } else {
                rules = {
                    integrity_data_collection_type: {
                        required: true
                    },
                    integrity_description: {
                        required: true,
                        maxlength: 200,
                        existingIntegrity: true,
                        existingNewIntegrity: true,
                        validText: '|#$'
                    },
                    integrity_from_date: {
                        validDateRange: ['.tt-begin-integrity', '.tt-end-integrity']
                    },
                    integrity_till_date: {
                        validDateRange: ['.tt-begin-integrity', '.tt-end-integrity']
                    },
                    integrity_integritytype: {
                        required: true
                    },
                    integrity_gender: {
                        required: true
                    },
                    integrity_type: {
                        requireFromGroup: [1, '.tt-completeness-rule-group']
                    },
                    integrity_custom_rule: {
                        requireFromGroup: [1, '.tt-completeness-rule-group']
                    },
                    integrity_age_from_range: {
                        digits: true,
                        min: 0
                    },
                    integrity_age_till_range: {
                        digits: true,
                        min: 0
                    }
                };
            }
        }

        // Vollständigkeit
        if ($(element).find('[name="integrity_type"]').hasClass('select2-container') && $(element).find('[name="integrity_type"]').select2('val') === 'completeness') {
            rules_integrity_completeness = {
                completeness_frequency: {
                    requireFromGroup: [1, '.tt-completeness-frequency-group']
                },
                completeness_mandatory_field: {
                    requireFromGroup: [1, '.tt-completeness-frequency-group']
                }
            }
            $.extend(rules, rules_integrity_completeness);
        }

        // Wertebereich (Input)
        if ($(element).find('[name="integrity_type"]').hasClass('select2-container') && $(element).find('[name="integrity_type"]').select2('val') === 'range'
            && ($(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'input' || $(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'input_with_additionalfield')) {
            rules_integrity_range_input = {
                integrity_logical_from_field: {
                    required: true
                },
                integrity_value_from: {
                    requireFromGroup: [1, '.validation-group-range-input-from'],
                    minLocale: 0,
                    validNormValueRange: true
                },
                integrity_value_from_field: {
                    requireFromGroup: [1, '.validation-group-range-input-from']
                },
                integrity_value_till: {
                    requireFromGroupWhenElementFilled: ['[name="integrity_logical_till_field"]', 1, '.validation-group-range-input-till'],
                    minLocale: 0,
                    validNormValueRange: true
                },
                integrity_value_till_field: {
                    requireFromGroupWhenElementFilled: ['[name="integrity_logical_till_field"]', 1, '.validation-group-range-input-till']
                }
            }
            $.extend(rules, rules_integrity_range_input);
        }

        // Wertebereich (Datum)
        if ($(element).find('[name="integrity_type"]').hasClass('select2-container') && $(element).find('[name="integrity_type"]').select2('val') === 'range'
            && ($(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'date_panel' || $(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'date_range')) {
            rules_integrity_range_date = {
                integrity_logical_from_date_field: {
                    required: true
                },
                integrity_value_from_date_field: {
                    required: true
                },
                integrity_value_from_date_range: {
                    digits: true,
                    min: 0,
                    required: true
                },
                integrity_value_till_date_field: {
                    requiredWhenElementFilled: ['[name="integrity_logical_till_date_field"]']
                },
                integrity_value_till_date_range: {
                    digits: true,
                    min: 0,
                    requiredWhenElementFilled: ['[name="integrity_logical_till_date_field"]']
                }
            }
            $.extend(rules, rules_integrity_range_date);
        }

        // Wertebereich (Auswahllisten)
        if ($(element).find('[name="integrity_type"]').hasClass('select2-container') && $(element).find('[name="integrity_type"]').select2('val') === 'range'
            && !($(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'input'
                || $(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'input_with_additionalfield'
                || $(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'date_panel'
                || $(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'date_range')) {
            rules_integrity_range_list = {
                integrity_control_type: {
                    atLeastOneControlTypeValue: true
                }
            }
            $.extend(rules, rules_integrity_range_list);
        }

        // Abweichung (Input)
        if ($(element).find('[name="integrity_type"]').hasClass('select2-container') && $(element).find('[name="integrity_type"]').select2('val') === 'deviation'
            && ($(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'input' || $(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'input_with_additionalfield')
            && ($(element).parents('.tt-content-dialog').find('[name="data_type"]').val() === 'integer' || $(element).parents('.tt-content-dialog').find('[name="data_type"]').val() === 'decimal')) {
            rules_integrity_deviation = {
                integrity_deviation_percentage_value: {
                    required: true
                },
                integrity_deviation_down: {
                    requireFromGroup: [1, '.validation-group-deviation'],
                    digits: true,
                    min: 0
                },
                integrity_period_down: {
                    digits: true,
                    min: 0
                },
                integrity_deviation_up: {
                    requireFromGroup: [1, '.validation-group-deviation'],
                    digits: true,
                    min: 0
                },
                integrity_period_up: {
                    digits: true,
                    min: 0
                }
            }
            $.extend(rules, rules_integrity_deviation);
        }

        // Abhängigkeit
        if ($(element).find('[name="integrity_type"]').hasClass('select2-container') && $(element).find('[name="integrity_type"]').select2('val') === 'dependency') {
            if ($(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'input' || $(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'input_with_additionalfield') {
                if ($(element).parents('.tt-content-dialog').find('[name="data_type"]').val() === 'integer' || $(element).parents('.tt-content-dialog').find('[name="data_type"]').val() === 'decimal') {
                    rules_integrity_dependency_field = {
                        integrity_existing_value: {
                            requireFromGroup: [1, '.validation-group-dependency-field']
                        },
                        integrity_not_existing_value: {
                            requireFromGroup: [1, '.validation-group-dependency-field']
                        },
                        integrity_field_logical_from_field: {
                            requireFromGroup: [1, '.validation-group-dependency-field']
                        },
                        integrity_field_value_from: {
                            requireFromGroupWhenElementFilled: ['[name="integrity_field_logical_from_field"]', 1, '.validation-dependency-group-range-input-from'],
                            minLocale: 0,
                            validNormValueRange: true
                        },
                        integrity_field_value_from_field: {
                            requireFromGroupWhenElementFilled: ['[name="integrity_field_logical_from_field"]', 1, '.validation-dependency-group-range-input-from']
                        },
                        integrity_field_value_till: {
                            requireFromGroupWhenElementFilled: ['[name="integrity_field_logical_till_field"]', 1, '.validation-dependency-group-range-input-till'],
                            minLocale: 0,
                            validNormValueRange: true
                        },
                        integrity_field_value_till_field: {
                            requireFromGroupWhenElementFilled: ['[name="integrity_field_logical_till_field"]', 1, '.validation-dependency-group-range-input-till']
                        }
                    }
                    $.extend(rules, rules_integrity_dependency_field);
                } else {
                    rules_integrity_dependency_field = {
                        integrity_existing_value: {
                            requireFromGroup: [1, '.validation-group-dependency-field']
                        },
                        integrity_not_existing_value: {
                            requireFromGroup: [1, '.validation-group-dependency-field']
                        },
                        integrity_field_input: {
                            requireFromGroup: [1, '.validation-group-dependency-field'],
                            maxlength: 200
                        }
                    }
                    $.extend(rules, rules_integrity_dependency_field);
                }
            } else if ($(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'date_panel' || $(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'date_range') {
                rules_integrity_dependency_field = {
                    integrity_existing_value: {
                        requireFromGroup: [1, '.validation-group-dependency-field']
                    },
                    integrity_not_existing_value: {
                        requireFromGroup: [1, '.validation-group-dependency-field']
                    },
                    integrity_field_logical_from_date_field: {
                        requireFromGroup: [1, '.validation-group-dependency-field']
                    },
                    integrity_field_value_from_date_field: {
                        requiredWhenElementFilled: ['[name="integrity_field_logical_from_date_field"]']
                    },
                    integrity_field_value_from_date_range: {
                        digits: true,
                        min: 0,
                        requiredWhenElementFilled: ['[name="integrity_field_logical_from_date_field"]']
                    },
                    integrity_field_value_till_date_field: {
                        requiredWhenElementFilled: ['[name="integrity_field_logical_till_date_field"]']
                    },
                    integrity_field_value_till_date_range: {
                        digits: true,
                        min: 0,
                        requiredWhenElementFilled: ['[name="integrity_field_logical_till_date_field"]']
                    }
                }
                $.extend(rules, rules_integrity_dependency_field);
            } else {
                rules_integrity_dependency_field = {
                    integrity_existing_value: {
                        requireFromGroup: [1, '.validation-group-dependency-field']
                    },
                    integrity_not_existing_value: {
                        requireFromGroup: [1, '.validation-group-dependency-field']
                    },
                    integrity_field_list: {
                        requireFromGroup: [1, '.validation-group-dependency-field']
                    }
                }
                $.extend(rules, rules_integrity_dependency_field);
            }

            rules_integrity_dependency_depending_field = {
                integrity_depending_field: {
                    required: true
                },
                integrity_dependency_frequency: {
                    required: true
                }
            }
            $.extend(rules, rules_integrity_dependency_depending_field);

            var control_type = '';
            var data_type = '';

            var completeness_frequency = $(element).find('[name="integrity_dependency_frequency"]:checked').val();

            if (completeness_frequency == 'no') {
                if (!utils.isUndefined($(element).find('.tt-integrity-depending-field').select2('val')) && $(element).find('.tt-integrity-depending-field').select2('val') !== '') {
                    control_type = $(element).find('.tt-integrity-depending-field').select2('data')[0].controlType;
                    data_type = $(element).find('.tt-integrity-depending-field').select2('data')[0].dataType;
                }

                if (control_type === 'input' || control_type === 'input_with_additionalfield') {
                    if (data_type === 'integer' || data_type === 'decimal') {
                        rules_integrity_dependency_depending_field = {
                            integrity_existing_depending_value: {
                                requireFromGroup: [1, '.validation-group-dependency-depending-field']
                            },
                            integrity_not_existing_depending_value: {
                                requireFromGroup: [1, '.validation-group-dependency-depending-field']
                            },
                            integrity_depending_field_logical_from_field: {
                                requireFromGroup: [1, '.validation-group-dependency-depending-field']
                            },
                            integrity_depending_field_value_from: {
                                requireFromGroupWhenElementFilled: ['[name="integrity_depending_field_logical_from_field"]', 1, '.validation-depending-dependency-group-range-input-from'],
                                minLocale: 0,
                                validNormValueRange: true
                            },
                            integrity_depending_field_value_from_field: {
                                requireFromGroupWhenElementFilled: ['[name="integrity_depending_field_logical_from_field"]', 1, '.validation-depending-dependency-group-range-input-from']
                            },
                            integrity_depending_field_value_till: {
                                requireFromGroupWhenElementFilled: ['[name="integrity_depending_field_logical_till_field"]', 1, '.validation-depending-dependency-group-range-input-till'],
                                minLocale: 0,
                                validNormValueRange: true
                            },
                            integrity_depending_field_value_till_field: {
                                requireFromGroupWhenElementFilled: ['[name="integrity_depending_field_logical_till_field"]', 1, '.validation-depending-dependency-group-range-input-till']
                            }
                        }
                        $.extend(rules, rules_integrity_dependency_depending_field);
                    } else {
                        rules_integrity_dependency_depending_field = {
                            integrity_existing_depending_value: {
                                requireFromGroup: [1, '.validation-group-dependency-depending-field']
                            },
                            integrity_not_existing_depending_value: {
                                requireFromGroup: [1, '.validation-group-dependency-depending-field']
                            },
                            integrity_depending_field_input: {
                                requireFromGroup: [1, '.validation-group-dependency-depending-field'],
                                maxlength: 200
                            }
                        }
                        $.extend(rules, rules_integrity_dependency_depending_field);
                    }
                } else if (control_type === 'date_panel' || control_type === 'date_range') {
                    rules_integrity_dependency_depending_field = {
                        integrity_existing_depending_value: {
                            requireFromGroup: [1, '.validation-group-dependency-depending-field']
                        },
                        integrity_not_existing_depending_value: {
                            requireFromGroup: [1, '.validation-group-dependency-depending-field']
                        },
                        integrity_depending_field_logical_from_date_field: {
                            requireFromGroup: [1, '.validation-group-dependency-depending-field']
                        },

                        integrity_depending_field_value_from_date_field: {
                            requiredWhenElementFilled: ['[name="integrity_depending_field_logical_from_date_field"]']
                        },
                        integrity_depending_field_value_from_date_range: {
                            digits: true,
                            min: 0,
                            requiredWhenElementFilled: ['[name="integrity_depending_field_logical_from_date_field"]']
                        },
                        integrity_depending_field_value_till_date_field: {
                            requiredWhenElementFilled: ['[name="integrity_depending_field_logical_till_date_field"]']
                        },
                        integrity_depending_field_value_till_date_range: {
                            digits: true,
                            min: 0,
                            requiredWhenElementFilled: ['[name="integrity_depending_field_logical_till_date_field"]']
                        }
                    }
                    $.extend(rules, rules_integrity_dependency_depending_field);
                } else {
                    rules_integrity_dependency_depending_field = {
                        integrity_existing_depending_value: {
                            requireFromGroup: [1, '.validation-group-dependency-depending-field']
                        },
                        integrity_not_existing_depending_value: {
                            requireFromGroup: [1, '.validation-group-dependency-depending-field']
                        },
                        integrity_depending_field_list: {
                            requireFromGroup: [1, '.validation-group-dependency-depending-field']
                        }
                    }
                    $.extend(rules, rules_integrity_dependency_depending_field);
                }
            }
        }
	} else if (element[0].id === "table_data_views_display_restrictions_form" || element[0].id === "table_data_views_display_restrictions_create_form") {
		rules = {
			display_restriction_data_collection_type: {
			    required: true
            },
			display_restriction_from_date: {
				requireFromGroup: [1, '.display-restriction-date-field'],
                validDateRange: ['.tt-begin-display-restriction', '.tt-end-display-restriction']
			},
            display_restriction_till_date: {
				requireFromGroup: [1, '.display-restriction-date-field'],
                validDateRange: ['.tt-begin-display-restriction', '.tt-end-display-restriction']
			}
		};
    } else if (element[0].id === "settings_language_form") {
        rules = {
            default_language: {
                required: true
            }
        };
    } else if (element[0].id === "settings_import_export_form") {
        rules = {
            selected_date_format: {
                required: true
            },
            multiselect_existing_value: {
                required: true
            }
        };
    } else if (element[0].id === "freeze_data_form") {
        rules = {
            model: {
                required: true
            },
            year: {
                required: true
            }
        }
    } else if (element[0].id === "import_form") {
        rules = {
            model: {
                required: true
            },
            import_file_name: {
                required: true,
                validImportFile: true
            },
            separator: {
                importSeparatorsRequired: true
            },
            other_separator: {
                requiredWhenElementFilled: ['.tt-import-other-separator'],
                validText: 'a-zA-Z0-9',
                maxlength: 1
            },
            confirm_implausible_values: {
                requiredWhenElementFilled: ['.tt-import-implausible-values']
            }
        };
    } else if (element[0].id === "import_query_form") {
        rules = {
            model: {
                required: true
            },
            import_file_name: {
                required: true,
                validImportFile: true
            },
            separator: {
                importSeparatorsRequired: true
            },
            other_separator: {
                requiredWhenElementFilled: ['.tt-import-other-separator'],
                validText: 'a-zA-Z0-9',
                maxlength: 1
            }
        };
    } else if (element[0].id === "export_form") {
        rules = {
            file_format: {
                required: true
            },
            model: {
                required: true
            },
            table_export_facilities: {
                atLeastOneFacilityPatientToExport: 'table_export_facilities'
            },
            table_export_data_views: {
                atLeastOneDataViewToExport: true
            },
            patient_pseudonym: {
                requiredWhenElementFilled: ['[name="do_export_patient"]', '', 'form'],
                patientPseudonymExists: true
            },
            export_reason: {
                required: true
            },
            export_reason_other: {
                requiredWhenElementFilled: ['[name="export_reason"]', 'other', 'form']
            }
        };
    } else if (element[0].id === "database_export_form") {
        rules = {
            file_format: {
                required: true
            },
            table_database_export_facilities: {
                atLeastOneFacilityPatientToExport: 'table_database_export_facilities'
            },
            table_database_export_tables: {
                atLeastOneTableToDatabaseExport: true
            },
            patient_pseudonym: {
                requiredWhenElementFilled: ['[name="do_export_patient"]', '', 'form'],
                patientPseudonymExists: true
            },
            export_reason: {
                required: true
            },
            export_reason_other: {
                requiredWhenElementFilled: ['[name="export_reason"]', 'other', 'form']
            }
        };
    } else if (element[0].id === "delete_patient_finally_form") {
        rules = {
            pseudonym: {
                required: true,
                patientPseudonymExists: true
            }
        };
    } else if (element[0].id === "restore_patient_form") {
        rules = {
            pseudonym: {
                required: true,
                patientPseudonymExists: true
            },
            table_restore_patient_facilities: {
                atLeastOneFacilityToRestorePatient: true
            }
        };
    } else if (element[0].id === "table_agreement_list_form") {
        rules = {
            pseudonym: {
                required: true,
                patientPseudonymExists: true
            }
        };
    } else if (element[0].id === "table_patientlist_create_form") {
        rules = {
            patient_data_collection_model: {
                required: true
            },
            patient_begin_date: {
                required: true,
                maxDate: utils.stringToDate('today')
            }
        };
        jQuery.each($(element[0]).find('.tt-mandatory_field'), function(i, subelement) {
            if ($(subelement).attr('data-match-field') === 'patientname') {
                rules[$(subelement).attr('name')] = {requireFromGroup: [1, '.tt-create-patient-group']};
                rules['patient_pseudonym'] = {requireFromGroup: [1, '.tt-create-patient-group']};
            } else {
                rules[$(subelement).attr('name')] = {requiredWhenElementFilled: ['[data-match-field="patientname"]']};
            }
        });
    } else if (element[0].id === "table_patientlist_delete_form") {
        rules = {
            delete_reason: {
                required: true
            },
            delete_reason_other: {
                requiredWhenElementFilled: ['.tt-delete-reason-other']
            }
        };
    } else if (element[0].id === "table_patient_agreement_create_form") {
        rules = {
            agreement_type: {
                required: true,
                existingAgreement: ['.tt-begin-agreement']
            },
            agreement: {
                required: true
            },
            begin_date: {
                required: true,
                validDateRange: ['.tt-begin-agreement', '.tt-end-agreement'],
                maxDate: utils.stringToDate('today'),
                validDateDependingModels: true,
                validDateOtherDependingModels: true
            },
            end_date: {
                validDateRange: ['.tt-begin-agreement', '.tt-end-agreement'],
                maxDate: utils.stringToDate('today')
            }
        };

        if (($(element).find('[name="agreement"]:checked').val() === '3' || $(element).find('[name="agreement"]:checked').val() === '4' || $(element).find('[name="agreement"]:checked').is(':disabled'))
            && !$(element).find('[name="end_date"]').is(':disabled')) {
            rules_agreement = {
                end_date: {
                    required: true
                }
            }
            $.extend(rules, rules_agreement);
        }
    } else if (element[0].id === "table_patient_examination_create_form") {
        rules = {
            exam_date: {
                existingExamination: utils.stringToDate('today'),
                required: true,
                maxDate: utils.stringToDate('today')
            }
        }
    } else if (element[0].id === "staging_form") {
        rules = {
            backup_done: {
                required: true
            }
        }
    } else if (element[0].id === "table_merge_patients_1_form") {
        rules = {
            pseudonym_patient_1: {
                required: true,
                patientPseudonymExists: true,
                patientPseudonymNotSame: true
            },
            pseudonym_patient_2: {
                required: true,
                patientPseudonymExists: true,
                patientPseudonymNotSame: true
            },
            target_patient_1: {
                requireFromGroup: [1, '.target-patient-group']
            },
            target_patient_2: {
                requireFromGroup: [1, '.target-patient-group']
            }
        };
    } else if (element[0].id === "table_merge_patients_2_form") {
        rules = {
            table_merge_conflicts: {
                allConflictResolved: true
            }
        };
    } else if (element[0].id === "save_conflicts_form") {
        rules = {
            table_save_conflicts: {
                allSaveConflictResolved: true
            }
        };
    } else if (element[0].id === "table_news_detail_form") {
        rules = {
            news_title: {
                required: true
            },
            news_from_date: {
                required: true,
                validDateRange: ['.tt-from-date-news', '.tt-till-date-news']
            },
            news_till_date: {
                validDateRange: ['.tt-from-date-news', '.tt-till-date-news']
            }
        };
    } else if (element[0].id === "table_news_create_form") {
        rules = {
            news_title: {
                required: true
            },
            news_from_date: {
                required: true,
            }
        };
    } else if (element[0].id === "table_documents_detail_form") {
        rules = {
            documents_title: {
                required: true
            },
            documents_from_date: {
                required: true,
                validDateRange: ['.tt-from-date-documents', '.tt-till-date-documents']
            },
            documents_till_date: {
                validDateRange: ['.tt-from-date-documents', '.tt-till-date-documents']
            },
            documents_resource: {
                required: true
            }
        };
        var rules_resource = {};
        if ($(element).find('[name="documents_resource"]:checked').val() === 'file') {
            rules_resource = {
                document_filename: {
                    required: true
                }
            };
        } else if ($(element).find('[name="documents_resource"]:checked').val() === 'url') {
            rules_resource = {
                documents_url: {
                    required: true,
                    url: true
                }
            };
        }
        $.extend(rules, rules_resource);
    } else if (element[0].id === "table_documents_create_form") {
        rules = {
            documents_title: {
                required: true
            },
            documents_from_date: {
                required: true
            }
        };
    } else if (element[0].id === "email_compose_form") {
        rules = {
            mail_to: {
                required: true,
                validRecipient: true
            },
            subject: {
                required: true
            }
        };
    } else if (element[0].id === "email_completeness_form") {
        rules = {
            subject: {
                required: true
            }
        };
    } else if (element[0].id === "table_mails_create_folder_form") {
        rules = {
            new_folder_name: {
                required: true,
                maxlength: 255,
                validFolderName: true
            }
        };
    } else if (element[0].id === "table_audit_trail_form") {
		rules = {
			audit_trail_facility: {
				requireFromGroup: [1, '.search-group']
			},
			audit_trail_data_view_field: {
				requireFromGroup: [1, '.search-group']
			},
			audit_trail_tables_admin: {
				requireFromGroup: [1, '.search-group']
			}
		};
	} else if (element[0].id === "table_patient_administration_history_form") {
		rules = {
			patient_administration_history_user: {
				requireFromGroup: [1, '.search-group']
			},
			patient_administration_history_patient: {
				requireFromGroup: [1, '.search-group']
			},
			patient_administration_history_from_date: {
				requireFromGroup: [1, '.search-group']
			},
			patient_administration_history_to_date: {
				requireFromGroup: [1, '.search-group']
            }
		};
	} else if (element[0].id === "password_change_form") {
        rules = {
            previous_password: {
                required: true
            },
            password: {
                required: true,
                minlength: 8,
                minNonAlpha: 2
            },
            password_repetition: {
                required: true,
                equalTo: '[name="password"]'
            }
        };
    } else if (element[0].id === "table_monitoring_detail_form" || element[0].id === "table_monitoring_create_form") {
        rules = {
            monitoring_description: {
                required: true,
                maxlength: 255,
                uniqueMonitoring: true
            },
            monitoring_data_collection_types: {
                required: true
            },
            monitoring_age_from_value: {
                digits: true,
                min: 0
            },
            monitoring_age_till_value: {
                digits: true,
                min: 0
            },
            monitoring_restriction_period_value_from: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_period_logical_from"]', 1, '.validation-group-period-date-from'],
                validDateRange: ['[name="monitoring_restriction_period_value_from"]', '[name="monitoring_restriction_period_value_till"]']
            },
            monitoring_restriction_period_value_from_field: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_period_logical_from"]', 1, '.validation-group-period-date-from']
            },
            monitoring_restriction_period_value_from_date_range: {
                digits: true,
                min: 0,
                requiredWhenElementFilled: ['[name="monitoring_restriction_period_value_from_field"]']
            },
            monitoring_restriction_period_value_till: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_period_logical_till"]', 1, '.validation-group-period-date-till'],
                validDateRange: ['[name="monitoring_restriction_period_value_from"]', '[name="monitoring_restriction_period_value_till"]']
            },
            monitoring_restriction_period_value_till_field: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_period_logical_till"]', 1, '.validation-group-period-date-till']
            },
            monitoring_restriction_period_value_till_date_range: {
                digits: true,
                min: 0,
                requiredWhenElementFilled: ['[name="monitoring_restriction_period_value_till_field"]']
            },
            monitoring_restriction_weight_from: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_from_weight"]', 1, '.validation-group-weight-from'],
                minLocale: 0
            },
            monitoring_restriction_weight_from_field: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_from_weight"]', 1, '.validation-group-weight-from'],
                sameUnit: true
            },
            monitoring_restriction_weight_till: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_till_weight"]', 1, '.validation-group-weight-till'],
                minLocale: 0
            },
            monitoring_restriction_weight_till_field: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_till_weight"]', 1, '.validation-group-weight-till'],
                sameUnit: true
            },
            monitoring_restriction_bmi_from: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_from_bmi"]', 1, '.validation-group-bmi-from'],
                minLocale: 0
            },
            monitoring_restriction_bmi_from_field: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_from_bmi"]', 1, '.validation-group-bmi-from'],
                sameUnit: true
            },
            monitoring_restriction_bmi_till: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_till_bmi"]', 1, '.validation-group-bmi-till'],
                minLocale: 0
            },
            monitoring_restriction_bmi_till_field: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_till_bmi"]', 1, '.validation-group-bmi-till'],
                sameUnit: true
            },
            monitoring_restriction_bmi_percentile_from: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_from_bmi_percentile"]', 1, '.validation-group-bmi-percentile-from'],
                minLocale: 0
            },
            monitoring_restriction_bmi_percentile_from_field: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_from_bmi_percentile"]', 1, '.validation-group-bmi-percentile-from'],
                sameUnit: true
            },
            monitoring_restriction_bmi_percentile_till: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_till_bmi_percentile"]', 1, '.validation-group-bmi-percentile-till'],
                minLocale: 0
            },
            monitoring_restriction_bmi_percentile_till_field: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_till_bmi_percentile"]', 1, '.validation-group-bmi-percentile-till'],
                sameUnit: true
            },
            monitoring_restriction_fev1_norm_from: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_from_fev1_norm"]', 1, '.validation-group-fev1-norm-from'],
                minLocale: 0
            },
            monitoring_restriction_fev1_norm_from_field: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_from_fev1_norm"]', 1, '.validation-group-fev1-norm-from'],
                sameUnit: true
            },
            monitoring_restriction_fev1_norm_till: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_till_fev1_norm"]', 1, '.validation-group-fev1-norm-till'],
                minLocale: 0
            },
            monitoring_restriction_fev1_norm_till_field: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_logical_till_fev1_norm"]', 1, '.validation-group-fev1-norm-till'],
                sameUnit: true
            }
        };
    } else if (element[0].id === "table_monitoring_display_field_create_form") {
        rules = {
            monitoring_display_field: {
                required: true,
                existingMonitoringDisplayField: true
            }
        };
    } else if (element[0].id === "table_monitoring_display_fields_form") {
        rules = {
            monitoring_display_fields_table: {
                atLeastOneMonitoringDisplayField: true
            }
        };
    } else if (element[0].id === "table_monitoring_restrictions_form") {
        rules = {
            monitoring_restrictions_table: {
				atLeastOneMonitoringRestriction: true,
                validMonitoringRestrictionLogic: true
            }
        };
    } else if (element[0].id === "table_monitoring_restriction_create_form" || element[0].id === "table_monitoring_types_restriction_form") {

        // Allgemeine Angaben
        rules = {
            monitoring_restriction_data_view_field: {
                required: true
            },
            monitoring_restriction_description: {
                required: true,
                maxlength: 200,
                existingMonitoringRestriction: true,
                validText: '|#$'
            },
            monitoring_restriction_period_value_from: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_period_logical_from"]', 1, '.validation-group-period-date-from'],
                validDateRange: ['[name="monitoring_restriction_period_value_from"]', '[name="monitoring_restriction_period_value_till"]']
            },
            monitoring_restriction_period_value_from_field: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_period_logical_from"]', 1, '.validation-group-period-date-from']
            },
            monitoring_restriction_period_value_from_date_range: {
                digits: true,
                min: 0,
                requiredWhenElementFilled: ['[name="monitoring_restriction_period_value_from_field"]']
            },
            monitoring_restriction_later_period_value_from: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_period_logical_from"]', 1, '.validation-group-period-date-from']
            },
            monitoring_restriction_period_value_till: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_period_logical_till"]', 1, '.validation-group-period-date-till'],
                validDateRange: ['[name="monitoring_restriction_period_value_from"]', '[name="monitoring_restriction_period_value_till"]']
            },
            monitoring_restriction_period_value_till_field: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_period_logical_till"]', 1, '.validation-group-period-date-till']
            },
            monitoring_restriction_period_value_till_date_range: {
                digits: true,
                min: 0,
                requiredWhenElementFilled: ['[name="monitoring_restriction_period_value_till_field"]']
            },
            monitoring_restriction_later_period_value_till: {
                requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_period_logical_till"]', 1, '.validation-group-period-date-till']
            }
        };

        // Feld abhängige Angaben
        if ($(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'input' || $(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'input_with_additionalfield') {
            if ($(element).parents('.tt-content-dialog').find('[name="data_type"]').val() === 'integer' || $(element).parents('.tt-content-dialog').find('[name="data_type"]').val() === 'decimal') {
                rules_monitoring_restriction_field = {
                    monitoring_restriction_existing_value: {
                        requireFromGroup: [1, '.validation-group-monitoring-restriction']
                    },
                    monitoring_restriction_not_existing_value: {
                        requireFromGroup: [1, '.validation-group-monitoring-restriction']
                    },
                    monitoring_restriction_field_logical_from_numeric_field: {
                        requireFromGroup: [1, '.validation-group-monitoring-restriction']
                    },
                    monitoring_restriction_field_value_from: {
                        requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_from_numeric_field"]', 1, '.validation-group-range-input-from'],
                        minLocale: 0,
                        validNormValueRangeMonitoringRestriction: true
                    },
                    monitoring_restriction_field_value_from_field: {
                        requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_from_numeric_field"]', 1, '.validation-group-range-input-from']
                    },
                    monitoring_restriction_later_field_value_from: {
                        requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_from_numeric_field"]', 1, '.validation-group-range-input-from']
                    },
                    monitoring_restriction_field_value_till: {
                        requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_till_numeric_field"]', 1, '.validation-group-range-input-till'],
                        minLocale: 0,
                        validNormValueRangeMonitoringRestriction: true
                    },
                    monitoring_restriction_field_value_till_field: {
                        requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_till_numeric_field"]', 1, '.validation-group-range-input-till']
                    },
                    monitoring_restriction_later_field_value_till: {
                        requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_till_numeric_field"]', 1, '.validation-group-range-input-till']
                    }
                }
                $.extend(rules, rules_monitoring_restriction_field);
            } else {
                rules_monitoring_restriction_field = {
                    monitoring_restriction_existing_value: {
                        requireFromGroup: [1, '.validation-group-monitoring-restriction']
                    },
                    monitoring_restriction_not_existing_value: {
                        requireFromGroup: [1, '.validation-group-monitoring-restriction']
                    },
                    monitoring_restriction_field_logical_text_field: {
                        requireFromGroup: [1, '.validation-group-monitoring-restriction']
                    },
                    monitoring_restriction_field_input: {
                        requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_text_field"]', 1, '.validation-group-range-input'],
                        maxlength: 200,
                        validText: '|#$'
                    },
                    monitoring_restriction_later_field_input: {
                        requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_text_field"]', 1, '.validation-group-range-input']
                    }
                }
                $.extend(rules, rules_monitoring_restriction_field);
            }
        } else if ($(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'date_panel' || $(element).parents('.tt-content-dialog').find('[name="control_type"]').val() === 'date_range') {
            rules_monitoring_restriction_field = {
                monitoring_restriction_existing_value: {
                    requireFromGroup: [1, '.validation-group-monitoring-restriction']
                },
                monitoring_restriction_not_existing_value: {
                    requireFromGroup: [1, '.validation-group-monitoring-restriction']
                },
                monitoring_restriction_field_logical_from_date_field: {
                    requireFromGroup: [1, '.validation-group-monitoring-restriction']
                },
                monitoring_restriction_field_value_from_date: {
                    requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_from_date_field"]', 1, '.validation-group-range-date-from'],
                    validDateRange: ['[name="monitoring_restriction_field_value_from_date"]', '[name="monitoring_restriction_field_value_till_date"]']
                },
                monitoring_restriction_field_value_from_date_field: {
                    requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_from_date_field"]', 1, '.validation-group-range-date-from']
                },
                monitoring_restriction_field_value_from_date_range: {
                    digits: true,
                    min: 0,
                    requiredWhenElementFilled: ['[name="monitoring_restriction_field_value_from_date_field"]']
                },
                monitoring_restriction_later_from_date: {
                    requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_from_date_field"]', 1, '.validation-group-range-date-from']
                },
                monitoring_restriction_field_value_till_date: {
                    requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_till_date_field"]', 1, '.validation-group-range-date-till'],
                    validDateRange: ['[name="monitoring_restriction_field_value_from_date"]', '[name="monitoring_restriction_field_value_till_date"]']
                },
                monitoring_restriction_field_value_till_date_field: {
                    requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_till_date_field"]', 1, '.validation-group-range-date-till']
                },
                monitoring_restriction_field_value_till_date_range: {
                    digits: true,
                    min: 0,
                    requiredWhenElementFilled: ['[name="monitoring_restriction_field_value_till_date_field"]']
                },
                monitoring_restriction_later_till_date: {
                    requireFromGroupWhenElementFilled: ['[name="monitoring_restriction_field_logical_till_date_field"]', 1, '.validation-group-range-date-till']
                }
            }
            $.extend(rules, rules_monitoring_restriction_field);
        } else if ($(element).parents('.tt-content-dialog').find('[name="xontrol_type"]').val() === 'checkbox') {
            rules_monitoring_restriction_field = {
                monitoring_restriction_existing_value: {
                    requireFromGroup: [1, '.validation-group-monitoring-restriction']
                },
                monitoring_restriction_not_existing_value: {
                    requireFromGroup: [1, '.validation-group-monitoring-restriction']
                }
            }
            $.extend(rules, rules_monitoring_restriction_field);
        } else {
            rules_monitoring_restriction_field = {
                monitoring_restriction_existing_value: {
                    requireFromGroup: [1, '.validation-group-monitoring-restriction']
                },
                monitoring_restriction_not_existing_value: {
                    requireFromGroup: [1, '.validation-group-monitoring-restriction']
                },
                monitoring_restriction_field_list: {
                    requireFromGroup: [1, '.validation-group-monitoring-restriction']
                },
                monitoring_restriction_later_field_list: {
                    requireFromGroup: [1, '.validation-group-monitoring-restriction']
                }
            }
            $.extend(rules, rules_monitoring_restriction_field);
        }
    } else if (element[0].id === "table_completeness_create_form") {
        // Vollständigkeit Admin Bereich
        rules = {
            model: {
                required: true
            },
            from_date: {
                required: true
            },
            till_date: {
                required: true
            }
        }
    } else if (element[0].id === "table_aggregation_execution_1_form") {
		rules = {
			aggregation_execution_period_value_from: {
				required: true,
				validDateRange: ['[name="aggregation_execution_period_value_from"]', '[name="aggregation_execution_period_value_till"]'],
				validDateDependingExamDateFormat: ['[name="aggregation_execution_period_value_from"]', '[name="aggregation_execution_period_value_till"]', '[name="exam_date_formats"]', '[name="target_model"]']

			},
			aggregation_execution_period_value_till: {
				required: true,
				validDateDependingExamDateFormat: ['[name="aggregation_execution_period_value_from"]', '[name="aggregation_execution_period_value_till"]', '[name="exam_date_formats"]', '[name="target_model"]']
			},
			aggregation_execution_examination_value: {
				required: true,
				validAggregationExaminationDateRange: ['[name="aggregation_execution_period_value_from"]', '[name="aggregation_execution_examination_value"]', '[name="aggregation_execution_period_value_till"]']
			},
			facility_selection: {
				required: true
			},
			source_model: {
				required: true
            },
			target_model: {
				required: true,
				validModel: ['[name="source_model"]', '[name="target_model"]']

			}
		};
    } else if (element[0].id === "table_aggregation_execution_3_form" && $(element).find('[name="execute_button"]').val() === "preview") {

        rules = {
            facility_preview_selection: {
                required: true
            }
        }

    } else if (element[0].id === "table_aggregation_create_form" || element[0].id === "table_aggregation_definition_detail_form") {
        rules = {
            source_data_view_field: {
                requireFromGroup: [1, '.tt-aggregation-source-rule', '.tt-aggregation']
            },
            target_data_view_field: {
                requiredWhenElementFilled: ['[name="source_data_view_field"]']
            },
            source_data_view_period_table: {
                requireFromGroup: [1, '.tt-aggregation-source-rule', '.tt-aggregation']
            },
            target_data_view_period_table: {
                requiredWhenElementFilled: ['[name="source_data_view_period_table"]']
            },
			aggregation: {
			    required: true
            },
			aggregation_valid_from: {
				validDateRange: ['.tt-aggregation-from', '.tt-aggregation-till']
			},
			aggregation_valid_till: {
			    validDateRange: ['.tt-aggregation-from', '.tt-aggregation-till']
            },
			aggregation_position: {
				required: true,
				digits: true,
				min: 1
            },
            aggregation_period_field_conversions: {
                aggregationFieldConversionsRequiredWhenPeriodValueOrRowValue: true
            }
        }
    } else if (element[0].id === "table_devices_detail_form" || element[0].id === "table_devices_create_form") {
        rules = {
			username: {
			    required: true,
				validUsername: true,
                uniqueUsername: true
            },
            name: {
				required: true
            },
			password: {
				required: true,
				minlength: 8,
				minNonAlpha: 2
			},
			password_repetition_new: {
				equalTo: '#password_new'
			}
        }
    } else if (element[0].id === "table_patient_questionnaires_create_form") {
		rules = {
			questionnaire_device: {
				required: true
			}
		}
    } else if (element[0].id === "table_locked_period_form") {
        rules = {
            freeze_facility_data_locked_period_from: {
                required: true,
                validDateRange: ['.tt-locked-from', '.tt-locked-till'],
                overlappingPeriod: ['.tt-locked-from', '.tt-locked-till', '#table_locked_periods', 4, 5]
            },
            freeze_facility_data_locked_period_till: {
                required: true,
                validDateRange: ['.tt-locked-from', '.tt-locked-till'],
                overlappingPeriod: ['.tt-locked-from', '.tt-locked-till', '#table_locked_periods', 4, 5]
            }
        }
    } else if (element[0].id === "table_locked_patient_form") {
        rules = {
            freeze_facility_data_locked_patient: {
                required: true,
                existingLockedPseudonym: true
            }
        }
    } else if (element[0].id === "table_agreement_types_detail_form" || element[0].id === "table_agreement_types_create_form") {
        rules = {
            agreement_description: {
                required: true,
                uniqueAgreementDescription: true,
                maxlength: 100
            },
            agreement_valid_from: {
                required: true,
                maxDate: utils.stringToDate('today'),
                validDateRange: ['.tt-agreement-valid-from', '.tt-agreement-valid-till']
            },
            agreement_valid_till: {
                validDateRange: ['.tt-agreement-valid-from', '.tt-agreement-valid-till']
            },
            agreement_models: {
                required: true,
                agreementDataCollectionTypeOnlyInOneValidAgreement: true
            }
        };
    }

    return rules;
}

function addDynamicRules(element) {

	$(element).find('.tt-select-begin-date,.tt-select-end-date,.tt-transfer,select.tt-end-reason-selection,.tt-end-reason-other-text,.tt-select-questionnaire,.tt-select-language').each(function() {
		if ($(this).hasClass('tt-select-begin-date') || $(this).hasClass('tt-select-end-date')) {
			$(this).rules('add', {
				validDateRange: ['.tt-select-begin-date', '.tt-select-end-date', '.tt-transfer-data']
			});
		}
		if ($(this).hasClass('tt-transfer') || $(this).hasClass('tt-select-end-date')) {
			$(this).rules('add', {
				requireFromGroup: [1, '.tt-transfer-group', '.tt-transfer-data']
			});
		}
		if ($(this).hasClass('tt-end-reason-selection')) {
			$(this).rules('add', {
				requiredWhenElementFilled: ['.tt-select-end-date', '', '.tt-transfer-data'],
				messages: {
					requiredWhenElementFilled: trans('tripletrax.required_end_reason')
				}
			});
		}
		if ($(this).hasClass('tt-end-reason-other-text')) {
			var value = $(this).parents('.tt-transfer-data').find('.tt-end-reason-selection [data-show-other-end-reason="1"]').val();
			$(this).rules('add', {
				requiredWhenElementFilled: ['.tt-end-reason-selection', value, '.tt-transfer-data'],
				messages: {
					requiredWhenElementFilled: trans('tripletrax.required_end_reason_other')
				}
			});
		}
		if ($(this).hasClass('tt-select-questionnaire')) {
			$(this).rules('add', {
				requireFromGroup: [1, '.tt-select-questionnaire']
			});
        }
		if ($(this).hasClass('tt-select-language')) {
			$(this).rules('add', {
				requiredLanguage: true
			});
		}
	});
}

function addQuestionnairesRules(element) {

	$(element).find('[name]:not(hidden)').each(function() {
		$(this).rules('add', {
			required: true,
            messages: {
				required: Lang.get('device/content/questionnaires.required_question', [], $('#app_locale').val())
			}
		});
	});
}

function getMessages(element) {

    var messages = '';
    if (element[0].id === "table_data_views_detail_form") {
        messages = {
            name: {
                required: Lang.get('tripletrax.required_dataview_name'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.data_views_viewname'), "max": "{0}" })
            },
            desc: {
                required: Lang.get('tripletrax.required_dataview_desc')
            },
            match: {
                uniqueMatchField: Lang.get('tripletrax.unique_match_field'),
                remote: Lang.get('tripletrax.unique_match_field')
            },
            name_additionalfield_1: {
                required: Lang.get('tripletrax.required_dataview_name'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.data_views_viewname'), "max": "{0}" })
            },
            desc_additionalfield_1: {
                required: Lang.get('tripletrax.required_dataview_desc')
            },
            match_additionalfield_1: {
                uniqueMatchField: Lang.get('tripletrax.unique_match_field'),
                remote: Lang.get('tripletrax.unique_match_field')
            },
            name_additionalfield_2: {
                required: Lang.get('tripletrax.required_dataview_name'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.data_views_viewname'), "max": "{0}" })
            },
            desc_additionalfield_2: {
                required: Lang.get('tripletrax.required_dataview_desc')
            },
            match_additionalfield_2: {
                uniqueMatchField: Lang.get('tripletrax.unique_match_field'),
                remote: Lang.get('tripletrax.unique_match_field')
            },
            display: {
                required: Lang.get('tripletrax.required_dataview_display')
            },
            control_type: {
                existingControlTypeValues: Lang.get('tripletrax.required_control_type_values')
            },
            page_length: {
                required: Lang.get('tripletrax.required_dataview_page_length'),
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
			repetition: {
				required: Lang.get('tripletrax.required_dataview_repetition'),
				digits: Lang.get('tripletrax.positiv_integer'),
				min: Lang.get('tripletrax.positiv_integer')
			},
            column_width: {
                required: Lang.get('tripletrax.required_dataview_column_width'),
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            max_width: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            row_count: {
                required: Lang.get('tripletrax.required_dataview_row_count'),
                digits: Lang.get('tripletrax.positiv_integer_greater_null'),
                min: Lang.get('tripletrax.positiv_integer_greater_null')
            },
            control_type_additionalfield_1: {
                required: Lang.get('tripletrax.required_dataview_control_type'),
                existingControlTypeValues: Lang.get('tripletrax.required_control_type_values')
            },
            display_additionalfield_1: {
                required: Lang.get('tripletrax.required_dataview_display')
            },
            control_type_additionalfield_2: {
                required: Lang.get('tripletrax.required_dataview_control_type'),
                existingControlTypeValues: Lang.get('tripletrax.required_control_type_values')
            },
            display_additionalfield_2: {
                required: Lang.get('tripletrax.required_dataview_display')
            },
            table: {
                required: Lang.get('tripletrax.required_dataview_table'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.data_views_table'), "max": "{0}" }),
                uniqueTableNameAndTableType: Lang.get('tripletrax.unique_table_name_and_table_type'),
                remote: Lang.get('tripletrax.unique_table_name_and_table_type')
            },
            table_type: {
                required: Lang.get('tripletrax.required_dataview_table_type'),
                uniqueTableNameAndTableType: Lang.get('tripletrax.unique_table_name_and_table_type'),
                remote: Lang.get('tripletrax.unique_table_name_and_table_type')
            },
            format_fields: {
                requiredDateFormat: Lang.get('tripletrax.required_dataview_format_fields')
            },
            format_fields_additionalfield_1: {
                requiredDateFormat: Lang.get('tripletrax.required_dataview_format_fields')
            },
            format_fields_additionalfield_2: {
                requiredDateFormat: Lang.get('tripletrax.required_dataview_format_fields')
            },
            column: {
                required: Lang.get('tripletrax.required_dataview_column'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.data_views_column'), "max": "{0}" }),
                uniqueColumnNameInTable: Lang.get('tripletrax.unique_column_in_table'),
                remote: Lang.get('tripletrax.unique_column_in_table')
            },
            column_type: {
                required: Lang.get('tripletrax.required_dataview_column_type')
            },
            column_length: {
                required: Lang.get('tripletrax.required_dataview_column_length'),
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                max: Lang.get('tripletrax.max_length', {"max": "{0}"}),
                minLocale: Lang.get('tripletrax.positiv_float'),
                maxLocale: Lang.get('tripletrax.max_length', {"max": "{0}"}),
                validFloatDecimalPlaces: Lang.get('tripletrax.valid_float_decimal_places')
            },
            column_additionalfield_1: {
                required: Lang.get('tripletrax.required_dataview_column'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.data_views_column'), "max": "{0}" }),
                uniqueColumnNameInTable: Lang.get('tripletrax.unique_column_in_table'),
                remote: Lang.get('tripletrax.unique_column_in_table')
            },
            column_type_additionalfield_1: {
                required: Lang.get('tripletrax.required_dataview_column_type')
            },
            column_length_additionalfield_1: {
                required: Lang.get('tripletrax.required_dataview_column_length'),
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                max: Lang.get('tripletrax.max_length', {"max": "{0}"}),
                validFloatDecimalPlaces: Lang.get('tripletrax.valid_float_decimal_places')
            },
            column_additionalfield_2: {
                required: Lang.get('tripletrax.required_dataview_column'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.data_views_column'), "max": "{0}" }),
                uniqueColumnNameInTable: Lang.get('tripletrax.unique_column_in_table'),
                remote: Lang.get('tripletrax.unique_column_in_table')
            },
            column_type_additionalfield_2: {
                required: Lang.get('tripletrax.required_dataview_column_type')
            },
            column_length_additionalfield_2: {
                required: Lang.get('tripletrax.required_dataview_column_length'),
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                max: Lang.get('tripletrax.max_length', {"max": "{0}"}),
                validFloatDecimalPlaces: Lang.get('tripletrax.valid_float_decimal_places')
            },
            data_type: {
                required: Lang.get('tripletrax.required_dataview_data_type')
            },
            data_type_length: {
                required: Lang.get('tripletrax.required_dataview_data_type_length'),
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                max: Lang.get('tripletrax.max_length', {"max": "{0}"}),
                minLocale: Lang.get('tripletrax.positiv_float'),
                maxLocale: Lang.get('tripletrax.max_length', {"max": "{0}"})
            },
            data_type_additionalfield_1: {
                required: Lang.get('tripletrax.required_dataview_data_type')
            },
            data_type_length_additionalfield_1: {
                required: Lang.get('tripletrax.required_dataview_data_type_length'),
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                max: Lang.get('tripletrax.max_length', {"max": "{0}"})
            },
            data_type_additionalfield_2: {
                required: Lang.get('tripletrax.required_dataview_data_type')
            },
            data_type_length_additionalfield_2: {
                required: Lang.get('tripletrax.required_dataview_data_type_length'),
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                max: Lang.get('tripletrax.max_length', {"max": "{0}"})
            },
            no_complications_value: {
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.no_complications_value'), "max": "{0}" })
            },
            not_collected_value: {
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.not_collected_value'), "max": "{0}" })
            }
        }
    } else if (element[0].id === "table_aggregation_execution_1_form") {
        messages = {
			aggregation_execution_period_value_from: {
				required: Lang.get('tripletrax.required_aggregation_execution_period_value_from'),
				validDateRange: Lang.get('tripletrax.invalid_aggregation_execution_period_value_from')
            },
			aggregation_execution_period_value_till: {
				required: Lang.get('tripletrax.required_aggregation_execution_period_value_till')

			},
			aggregation_execution_examination_value: {
				required: Lang.get('tripletrax.required_aggregation_execution_examination_value')
			},
			facility_selection: {
				required: Lang.get('tripletrax.required_aggregation_execution_facility_selection')
            },
			source_model: {
				required: Lang.get('tripletrax.required_aggregation_execution_source_model')
            },
			target_model: {
				required: Lang.get('tripletrax.required_aggregation_execution_target_model'),
                validModel: Lang.get('tripletrax.invalid_aggregation_execution_model_name')
            }
        }
	} else if (element[0].id === "table_aggregation_execution_3_form") {
        messages = {
			facility_preview_selection: {
				required: Lang.get('tripletrax.required_aggregation_execution_preview')
			}
        }
    } else if (element[0].id === "table_patientlist_create_form") {
        messages = {
            patient_data_collection_model: {
                required: Lang.get('tripletrax.required_patient_data_collection_model')
            },
            patient_begin_date: {
                required: Lang.get('tripletrax.required_begin_date'),
                maxDate: Lang.get('tripletrax.date_in_the_future')
            },
            patient_end_date: {
                maxDate: Lang.get('tripletrax.date_in_the_future')
            }
        }
        if ($(element[0]).find('[data-match-field="patientname"]').length > 0) {
            messages[$(element[0]).find('[data-match-field="patientname"]').attr('name')] = { required: Lang.get('tripletrax.required_name') };
        }
        if ($(element[0]).find('[data-match-field="prename"]').length > 0) {
            messages[$(element[0]).find('[data-match-field="prename"]').attr('name')] = { requiredWhenElementFilled: Lang.get('tripletrax.required_prename') };
        }
        if ($(element[0]).find('[data-match-field="birth_name"]').length > 0) {
            messages[$(element[0]).find('[data-match-field="birth_name"]').attr('name')] = { requiredWhenElementFilled: Lang.get('tripletrax.required_birth_name') };
        }
        if ($(element[0]).find('[data-match-field="birth_city"]').length > 0) {
            messages[$(element[0]).find('[data-match-field="birth_city"]').attr('name')] = { requiredWhenElementFilled: Lang.get('tripletrax.required_birth_city') };
        }
        if ($(element[0]).find('[data-match-field="birth_date"]').length > 0) {
            messages[$(element[0]).find('[data-match-field="birth_date"]').attr('name')] = { requiredWhenElementFilled: Lang.get('tripletrax.required_birth_date') };
        }
        if ($(element[0]).find('[data-match-field="gender"]').length > 0) {
            messages[$(element[0]).find('[data-match-field="gender"]').attr('name')] = { requiredWhenElementFilled: Lang.get('tripletrax.required_gender') };
        }
        if ($(element[0]).find('[data-match-field="street"]').length > 0) {
            messages[$(element[0]).find('[data-match-field="street"]').attr('name')] = { requiredWhenElementFilled: Lang.get('tripletrax.required_street') };
        }
        if ($(element[0]).find('[data-match-field="city"]').length > 0) {
            messages[$(element[0]).find('[data-match-field="city"]').attr('name')] = { requiredWhenElementFilled: Lang.get('tripletrax.required_city') };
        }
        if ($(element[0]).find('[data-match-field="postal_code"]').length > 0) {
            messages[$(element[0]).find('[data-match-field="postal_code"]').attr('name')] = { requiredWhenElementFilled: Lang.get('tripletrax.required_postal_code') };
        }
	} else if (element[0].id === "table_devices_detail_form" || element[0].id === "table_devices_create_form") {
        messages = {
            username: {
                required: Lang.get('tripletrax.required_device_name'),
                uniqueUsername: Lang.get('tripletrax.devicename_exists')
            },
            name: {
                required: Lang.get('tripletrax.required_device_desc')
            },
            password: {
                required: Lang.get('tripletrax.required_password'),
                minlength: Lang.get('tripletrax.field_length', {"attribute": Lang.get('tripletrax.password'), "min": "{0}"})
            },
            password_repetition_new: {
                equalTo: Lang.get('tripletrax.wrong_password_repetition')
            },
            password_repetition_change: {
                equalTo: Lang.get('tripletrax.wrong_password_repetition')
            }
        }
    } else if (element[0].id === "database_export_form") {
        messages = {
            export_reason: {
                required: Lang.get('tripletrax.required_database_export_reason')
            },
            export_reason_other: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_database_export_reason_other')
            },
            file_format: {
                required: Lang.get('tripletrax.required_export_file_format')
            },
            patient_pseudonym: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_patient_pseudonym'),
                remote: Lang.get('tripletrax.not_existing_patient_pseudonym')
            }
        }
    } else {
        messages = {
            facility: {
                required: Lang.get('tripletrax.required_facility')
            },
            username: {
                required: Lang.get('tripletrax.required_username'),
                remote: Lang.get('tripletrax.username_exists')
            },
            firstname: {
                required: Lang.get('tripletrax.required_firstname')
            },
            name: {
                required: Lang.get('tripletrax.required_name')
            },
            email: {
                required: Lang.get('tripletrax.required_email'),
                email: Lang.get('tripletrax.invalid_email')
            },
            password_lifetime: {
                required: Lang.get('tripletrax.required_password_lifetime'),
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            password: {
                required: Lang.get('tripletrax.required_password'),
                minlength: Lang.get('tripletrax.field_length', { "attribute": Lang.get('tripletrax.password'), "min": "{0}" })
            },
            previous_password: {
                required: Lang.get('tripletrax.required_previous_password')
            },
            password_repetition: {
                required: Lang.get('tripletrax.required_password_repetition'),
                equalTo: Lang.get('tripletrax.wrong_password_repetition')
            },
            password_repetition_new: {
                equalTo: Lang.get('tripletrax.wrong_password_repetition')
            },
            password_repetition_change: {
                equalTo: Lang.get('tripletrax.wrong_password_repetition')
            },
            facilityname: {
                required: Lang.get('tripletrax.required_facilityname'),
                remote: Lang.get('tripletrax.facilityname_exists')
            },
            facilitycity: {
                required: Lang.get('tripletrax.required_facilitycity')
            },
            facilityid: {
                required: Lang.get('tripletrax.required_facilityid'),
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                remote: Lang.get('tripletrax.facilityid_exists')
            },
            contact_medical_email: {
                email: Lang.get('tripletrax.invalid_email')
            },
            contact_technical_email: {
                email: Lang.get('tripletrax.invalid_email')
            },
            rolename: {
                required: Lang.get('tripletrax.required_rolename'),
                remote: Lang.get('tripletrax.rolename_exists')
            },
            roledescription: {
                required: Lang.get('tripletrax.required_roledescription')
            },
            model: {
                required: Lang.get('tripletrax.required_model'),
                remote: Lang.get('tripletrax.model_exists')
            },
            agreement_description: {
                required: Lang.get('tripletrax.required_agreement_description'),
                remote: Lang.get('tripletrax.agreement_description_exists'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.agreement_description'), "max": "{0}" }),
            },
            agreement_models: {
                required: Lang.get('tripletrax.required_agreement_models')
            },
            agreement_valid_from: {
                required: Lang.get('tripletrax.required_agreement_valid_from'),
                maxDate: Lang.get('tripletrax.date_in_the_future')
            },
            year: {
                required: Lang.get('tripletrax.required_year')
            },
            examinationdate_format: {
                required: Lang.get('tripletrax.required_examinationdate_format')
            },
            depending_models: {
                required: Lang.get('tripletrax.required_depending_models')
            },
            abbreviation: {
                required: Lang.get('tripletrax.required_abbreviation'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.abbreviation'), "max": "{0}" }),
                remote: Lang.get('tripletrax.abbreviation_exists')
            },
            datacollectiontype: {
                required: Lang.get('tripletrax.required_datacollectiontype')
            },
            agreementtype: {
                required: Lang.get('tripletrax.required_agreementtype')
            },
            master_overview: {
                required: Lang.get('tripletrax.required_master_overview')
            },
            master_view: {
                required: Lang.get('tripletrax.required_master_view'),
                remote: Lang.get('tripletrax.master_view_match_fields_exist')
            },
            course_view_register: {
                required: Lang.get('tripletrax.required_course_view'),
                remote: Lang.get('tripletrax.course_view_match_fields_exist')
            },
            course_view_study_new: {
                required: Lang.get('tripletrax.required_course_view'),
                remote: Lang.get('tripletrax.course_view_match_fields_exist')
            },
            viewname: {
                required: Lang.get('tripletrax.required_viewname')
            },
            element: {
                required: Lang.get('tripletrax.required_element'),
                requiredWhenElementFilled: Lang.get('tripletrax.required_element')
            },
            control_type_value: {
                required: Lang.get('tripletrax.required_control_type_value'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.control_type_value'), "max": "{0}" })
            },
            value_in_database: {
                required: Lang.get('tripletrax.required_control_type_value_in_database'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.control_type_value_in_database'), "max": "{0}" })
            },
            document_description: {
                required: Lang.get('tripletrax.required_document_description')
            },
            document_filename: {
                required: Lang.get('tripletrax.required_document_filename')
            },
            monitoring_description: {
                required: Lang.get('tripletrax.monitoring_description_required'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.monitoring_description'), "max": "{0}" }),
                remote: Lang.get('tripletrax.monitoring_exists')
            },
            monitoring_data_collection_types: {
                required: Lang.get('tripletrax.monitoring_data_collection_types_required')
            },
            monitoring_age_from_value: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            monitoring_age_till_value: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            monitoring_display_field: {
                required: Lang.get('tripletrax.required_data_view_field')
            },
            unit: {
                required: Lang.get('tripletrax.required_unit'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.unit'), "max": "{0}" })
            },
            conversion_factor: {
                required: Lang.get('tripletrax.required_conversion_factor'),
                minLocale: Lang.get('tripletrax.positiv_float')
            },
            display_decimals: {
                required: Lang.get('tripletrax.required_display_decimals'),
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            integrity_description: {
                required: Lang.get('tripletrax.required_description'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.integrity_description'), "max": "{0}" })
            },
            integrity_integritytype: {
                required: Lang.get('tripletrax.required_integrity_type')
            },
            integrity_gender: {
                required: Lang.get('tripletrax.required_gender')
            },
            integrity_type: {
                required: Lang.get('tripletrax.required_type')
            },
            integrity_age_from_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            integrity_age_till_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            integrity_data_type: {
                required: Lang.get('tripletrax.required_data_type')
            },
            integrity_data_collection_type: {
                required: Lang.get('tripletrax.required_integrity_datacollectiontype')
            },
            integrity_data_view_field: {
                required: Lang.get('tripletrax.required_data_view_field')
            },
            integrity_length: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            integrity_value_from: {
                minLocale: Lang.get('tripletrax.positiv_float')
            },
            integrity_logical_from_field: {
                required: Lang.get('tripletrax.required_logic_operator')
            },
            integrity_logical_from_date_field: {
                required: Lang.get('tripletrax.required_logic_operator')
            },
            integrity_value_from_date_field: {
                required: Lang.get('tripletrax.required_date_field')
            },
            integrity_value_till_date_field: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_date_field')
            },
            integrity_field_value_from: {
                minLocale: Lang.get('tripletrax.positiv_float')
            },
            integrity_depending_field_value_from: {
                minLocale: Lang.get('tripletrax.positiv_float')
            },
            integrity_depending_field_value_till: {
                minLocale: Lang.get('tripletrax.positiv_float')
            },
            integrity_field_value_till: {
                minLocale: Lang.get('tripletrax.positiv_float')
            },
            integrity_field_value_from_date_field: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_date_field')
            },
            integrity_field_value_from_date_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                requiredWhenElementFilled: Lang.get('tripletrax.required_value_date_range')
            },
            integrity_field_input: {
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.value'), "max": "{0}" })
            },
            integrity_depending_field_value_from_date_field: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_date_field')
            },
            integrity_depending_field_value_from_date_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                requiredWhenElementFilled: Lang.get('tripletrax.required_value_date_range')
            },
            integrity_depending_field_input: {
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.value'), "max": "{0}" })
            },
            integrity_depending_field_value_till_date_field: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_date_field')
            },
            integrity_depending_field_value_till_date_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                requiredWhenElementFilled: Lang.get('tripletrax.required_value_date_range')
            },
            integrity_field_value_till_date_field: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_date_field')
            },
            integrity_field_value_till_date_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                requiredWhenElementFilled: Lang.get('tripletrax.required_value_date_range')
            },
            integrity_dependency_frequency: {
                required: Lang.get('tripletrax.required_frequency')
            },
            integrity_value_till: {
                minLocale: Lang.get('tripletrax.positiv_float')
            },
            integrity_value_from_date_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                required: Lang.get('tripletrax.required_value_date_range')
            },
            integrity_value_till_date_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                requiredWhenElementFilled: Lang.get('tripletrax.required_value_date_range')
            },
            integrity_deviation_percentage_value: {
                required: Lang.get('tripletrax.required_deviation_percentage_value')
            },
            integrity_deviation_down: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            integrity_period_down: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            integrity_deviation_up: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            integrity_period_up: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            integrity_depending_field: {
                required: Lang.get('tripletrax.required_depending_field')
            },
            default_language: {
                required: Lang.get('tripletrax.required_default_language')
            },
            selected_date_format: {
                required: Lang.get('tripletrax.required_selected_date_format')
            },
            multiselect_existing_value: {
                required: Lang.get('tripletrax.required_multiselect_existing_value')
            },
            completeness_data_view_field: {
                required: Lang.get('tripletrax.required_data_view_field')
            },
            completeness_description: {
                required: Lang.get('tripletrax.required_description')
            },
            completeness_frequency: {
                required: Lang.get('tripletrax.required_frequency')
            },
            completeness_age_from_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            completeness_age_till_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            given_period_radio: {
                required: Lang.get('tripletrax.required_given_period')
            },
            completeness_notification_radio: {
                required: Lang.get('tripletrax.required_completeness_notification')
            },
            period_active_patients: {
                required: Lang.get('tripletrax.required_period_active_patients'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            period_examinationlist_active_patients: {
                required: Lang.get('tripletrax.required_period_examinationlist_active_patients'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            period_examinationlist_inactive_patients: {
                required: Lang.get('tripletrax.required_period_examinationlist_inactive_patients'),
                min: Lang.get('tripletrax.positiv_integer')
            },
            import_file_name: {
                required: Lang.get('tripletrax.required_import_file')
            },
            other_separator: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_other_separator'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.separator_with_article'), "max": "{0}" })
            },
            confirm_implausible_values: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_confirm_implausible_values')
            },
            agreement_type: {
                required: Lang.get('tripletrax.required_data_collection_model')
            },
            begin_date: {
                required: Lang.get('tripletrax.required_begin_date'),
                maxDate: Lang.get('tripletrax.date_in_the_future')
            },
            end_date: {
                required: Lang.get('tripletrax.required_end_date'),
                maxDate: Lang.get('tripletrax.date_in_the_future')
            },
            agreement: {
                required: Lang.get('tripletrax.required_agreement')
            },
            exam_date: {
                required: Lang.get('tripletrax.required_date'),
                remote: Lang.get('tripletrax.examination_exists'),
                maxDate: Lang.get('tripletrax.date_in_the_future')
            },
            file_format: {
                required: Lang.get('tripletrax.required_export_file_format')
            },
            export_reason: {
                required: Lang.get('tripletrax.required_export_reason')
            },
            export_reason_other: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_export_reason_other')
            },
            patient_pseudonym: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_patient_pseudonym'),
                remote: Lang.get('tripletrax.not_existing_patient_pseudonym')
            },
            pseudonym: {
                required: Lang.get('tripletrax.required_patient_pseudonym'),
                remote: Lang.get('tripletrax.not_existing_patient_pseudonym')
            },
            delete_reason: {
                required: Lang.get('tripletrax.required_delete_reason')
            },
            delete_reason_other: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_delete_reason_other')
            },
            backup_done: {
                required: Lang.get('tripletrax.required_backup_done')
            },
            pseudonym_patient_1: {
                required: Lang.get('tripletrax.required_patient_pseudonym'),
                remote: Lang.get('tripletrax.not_existing_patient_pseudonym')
            },
            pseudonym_patient_2: {
                required: Lang.get('tripletrax.required_patient_pseudonym'),
                remote: Lang.get('tripletrax.not_existing_patient_pseudonym')
            },
            news_title: {
                required: Lang.get('tripletrax.required_news_title')
            },
            news_from_date: {
                required: Lang.get('tripletrax.required_news_from_date')
            },
            documents_title: {
                required: Lang.get('tripletrax.required_documents_title')
            },
            documents_resource: {
                required: Lang.get('tripletrax.required_documents_resource')
            },
            documents_url: {
                required: Lang.get('tripletrax.required_documents_url'),
                url: Lang.get('tripletrax.required_documents_valid_url')
            },
            documents_from_date: {
                required: Lang.get('tripletrax.required_documents_from_date')
            },
            mail_to: {
                required: Lang.get('tripletrax.required_recipient'),
                remote: Lang.get('tripletrax.invalid_recipient')
            },
            subject: {
                required: Lang.get('tripletrax.required_subject')
            },
            new_folder_name: {
                required: Lang.get('tripletrax.required_new_folder'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.folder_name'), "max": "{0}" }),
                remote: Lang.get('tripletrax.invalid_folder_name')
            },
            monitoring_restriction_data_view_field: {
                required: Lang.get('tripletrax.required_data_view_field')
            },
            monitoring_restriction_description: {
                required: Lang.get('tripletrax.monitoring_description_required'),
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.monitoring_description'), "max": "{0}" })
            },
            monitoring_restriction_field_value_from: {
                minLocale: Lang.get('tripletrax.positiv_float')
            },
            monitoring_restriction_field_value_till: {
                minLocale: Lang.get('tripletrax.positiv_float')
            },
            monitoring_restriction_field_input: {
                maxlength: Lang.get('tripletrax.field_max_length', { "attribute": Lang.get('tripletrax.value'), "max": "{0}" }),
                requiredWhenElementFilled: Lang.get('tripletrax.required_value')
            },
            monitoring_restriction_field_value_from_date_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                requiredWhenElementFilled: Lang.get('tripletrax.required_value_date_range')
            },
            monitoring_restriction_field_value_till_date_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                requiredWhenElementFilled: Lang.get('tripletrax.required_value_date_range')
            },
            monitoring_restriction_period_value_from: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_value_date_range')
            },
            monitoring_restriction_period_value_till: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_value_date_range')
            },
            monitoring_restriction_period_value_from_date_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                requiredWhenElementFilled: Lang.get('tripletrax.required_value_date_range')
            },
            monitoring_restriction_period_value_till_date_range: {
                digits: Lang.get('tripletrax.positiv_integer'),
                min: Lang.get('tripletrax.positiv_integer'),
                requiredWhenElementFilled: Lang.get('tripletrax.required_value_date_range')
            },
            monitoring_restriction_weight_from_field: {
                remote: Lang.get('tripletrax.monitoring_restriction_not_same_unit', {field: Lang.get('tripletrax.weight')})
            },
            monitoring_restriction_weight_till_field: {
                remote: Lang.get('tripletrax.monitoring_restriction_not_same_unit', {field: Lang.get('tripletrax.weight')})
            },
            monitoring_restriction_bmi_from_field: {
                remote: Lang.get('tripletrax.monitoring_restriction_not_same_unit', {field: Lang.get('tripletrax.bmi')})
            },
            monitoring_restriction_bmi_till_field: {
                remote: Lang.get('tripletrax.monitoring_restriction_not_same_unit', {field: Lang.get('tripletrax.bmi')})
            },
            monitoring_restriction_bmi_percentile_from_field: {
                remote: Lang.get('tripletrax.monitoring_restriction_not_same_unit', {field: Lang.get('tripletrax.bmi_percentile')})
            },
            monitoring_restriction_bmi_percentile_till_field: {
                remote: Lang.get('tripletrax.monitoring_restriction_not_same_unit', {field: Lang.get('tripletrax.bmi_percentile')})
            },
            monitoring_restriction_fev1_norm_from_field: {
                remote: Lang.get('tripletrax.monitoring_restriction_not_same_unit', {field: Lang.get('tripletrax.fev1_norm')})
            },
            monitoring_restriction_fev1_norm_till_field: {
                remote: Lang.get('tripletrax.monitoring_restriction_not_same_unit', {field: Lang.get('tripletrax.fev1_norm')})
            },
            from_date: {
                required: Lang.get('tripletrax.required_date')
            },
            till_date: {
                required: Lang.get('tripletrax.required_date')
            },
            display_restriction_data_collection_type: {
				required: Lang.get('tripletrax.required_model')
            },
            target_data_view_field: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_target_data_view_field')
            },
            target_data_view_period_table: {
                requiredWhenElementFilled: Lang.get('tripletrax.required_target_data_view_period_table')
            },
            aggregation: {
                required: Lang.get('tripletrax.required_aggregation')
            },
			aggregation_position: {
				required: Lang.get('tripletrax.required_position'),
				digits: Lang.get('tripletrax.positiv_integer_greater_null'),
				min: Lang.get('tripletrax.positiv_integer_greater_null')
            },
			questionnaire_device: {
				required: Lang.get('tripletrax.required_questionnaire_device')
            },
			language: {
				required: Lang.get('tripletrax.required_questionnaire_language')
			},
			device_roles: {
                required: Lang.get('tripletrax.required_device_roles')
            },
            freeze_facility_data_locked_period_from: {
                required: Lang.get('tripletrax.required_freeze_facility_data_locked_period_from')
            },
            freeze_facility_data_locked_period_till: {
                required: Lang.get('tripletrax.required_freeze_facility_data_locked_period_till')
            },
            freeze_facility_data_locked_patient: {
                required: Lang.get('tripletrax.required_freeze_facility_data_locked_patient')
            }
        }
    }

    return messages;
}

function getIgnore(element) {

    var ignore = ":hidden:not(select.tt-select2,input.tt-select2)";

    if (element[0].id === "table_users_roles_form") {
        ignore = ".select2-focusser,.select2-input";
    } else if (element[0].id === "table_data_views_integrities_form" || element[0].id === "table_data_views_integrities_create_form" || element[0].id === "table_data_views_restrictions_form" || element[0].id === "table_data_views_restrictions_create_form"
        || element[0].id === "table_data_views_detail_form" || element[0].id === "settings_language_form" || element[0].id === "settings_import_export_form" || element[0].id === "settings_form" || element[0].id === "user_settings_form"
        || element[0].id === "table_collection_type_integrities_form" || element[0].id === "table_data_collection_types_detail_master_views_form" || element[0].id === "table_monitoring_display_fields_form" || element[0].id === "table_monitoring_restrictions_form"
        || element[0].id === 'export_form' || element[0].id === "table_merge_patients_2_form" || element[0].id === "save_conflicts_form" || element[0].id === "email_completeness_form" || element[0].id === "restore_patient_form"
        || element[0].id === "table_data_views_display_restrictions_form" || element[0].id === "table_data_views_display_restrictions_create_form" || element[0].id === "table_patient_agreement_create_form" || element[0].id === "database_export_form"
        || element[0].id === "table_aggregation_definition_detail_form" || element[0].id === "table_aggregation_create_form") {
        ignore = "";
    } else if (element[0].id === "email_compose_form") {
        ignore = ".note-editor *";
    } else if ($(element[0]).hasClass('tt-view-form') && !views.isDevice()) {
        ignore = ".tt-view-input,.tt-view-textarea,.tt-view-combo,.tt-view-combo-multiselect,.tt-view-checkbox,.tt-view-radio";
    }

    return ignore;
}

function triggerValidation(element, checkForChanges, resetOldValue) {
    if ($(element).parents('form').length) {
        if (resetOldValue) {
            $(element).parents('form').validate().previousValue(element).old = '';
        }
        if (element.name in $(element).parents('form').validate().submitted) {
            $(element).parents('form').validate().element($(element));
        }
        if (checkForChanges) {
            $(element).parents('form').trigger('checkform.areYouSure');
        }
    }
}

function goToControl(controlName, tableType, tableName) {
    var parentControl = null;
	var questionnaire = utils.getQuestionnaire();
	var course = utils.getCourse();
	var master = utils.getMaster();
    if (master.find('[name="' + controlName + '"]').length || (!utils.isUndefined(tableName) && master.find('[data-database-table-name="' + tableName + '"]').length)) {
        parentControl = master;
        $('[href="#content-detail-master"]').tab('show');
    } else if (course.find('[name="' + controlName + '"]').length || (!utils.isUndefined(tableName) && course.find('[data-database-table-name="' + tableName + '"]').length)) {
        parentControl = course;
        $('[href="#content-detail-course"]').tab('show');
	} else if (!utils.isUndefined(questionnaire) && (questionnaire.find('[name="' + controlName + '"]').length || (!utils.isUndefined(tableName) && questionnaire.find('[data-database-table-name="' + tableName + '"]').length))) {
		parentControl = questionnaire;
		$('[href="#content-detail-questionnaires"]').tab('show');
	}

    if (parentControl !== null) {
        var controlTabPaneId = null;
        if (tableType === 'period_table' || tableType === 'period_facility_table') {
            controlTabPaneId = $($(parentControl.find('[data-database-table-name="' + tableName + '"]')[0]).parents('.tab-pane')[0]).attr('id');
        } else {
            controlTabPaneId = $($(parentControl.find('[name="' + controlName + '"],[data-database-table-name="' + controlName + '"]')[0]).parents('.tab-pane')[0]).attr('id');
        }
        utils.updateGlobals('controlNameForFocus', controlName);

        if ($('[href="#' + controlTabPaneId + '"]').parent().hasClass('active')) {
            views.showTab($('[href="#' + controlTabPaneId + '"]'), controlName, parentControl, tableName);
        } else {
            utils.updateGlobals('tableNameForFocus', tableName);
            utils.updateGlobals('parentControlForFocus', parentControl[0].id);
            utils.updateGlobals('controlTabPaneId', controlTabPaneId);
            $('[href="#' + controlTabPaneId + '"]').tab('show');
        }
    }
}


// Aufrufe ohne Ajax

function saveUserRole(element, form) {

    var roles = "";
    var role_ids = "";
    $("input:checked", element.find('.tt-datatable-dialog').dataTable().fnGetNodes()).each(function () {
        if (role_ids !== '') {
            role_ids += ",";
        }
        role_ids += $(this).val();

        if (roles !== '') {
            roles += ", ";
        }
        roles += this.getAttribute('data-text');
    });

    var select2 = element.find('.tt-select2').select2('data')[0];
    var selectedId = $("#content-detail").find('.tt-content-datatable').find('.tt-selected-pos');

    if (selectedId.val() === "") {
        $("#content-detail").find('.tt-content-datatable').find('.tt-datatable-detail').dataTable().fnAddData([
            select2.id,
            select2.text,
            roles,
            role_ids]
          );
    } else {
        $("#content-detail").find('.tt-content-datatable').find('.tt-datatable-detail').dataTable().fnUpdate([
            select2.id,
            select2.text,
            roles,
            role_ids],
            selectedId.val()
          );
    }
    $("#content-detail").find('.tt-content-datatable').find('.tt-datatable-detail').dataTable().$('tr.selected-row').removeClass('selected-row');
    $("#content-detail").find('.tt-content-datatable').find('.tt-delete').addClass('disabled');
    if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
        $("#content-detail").find('.tt-datatable-changes').val("changed");
        $("#content-detail").find('form').trigger('checkform.areYouSure');
    }

    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function saveFreezeFacilityDataLockedPeriod(element, form) {

    var id = parseInt($(form).find('[name="next_id"]').val()) - 1;
    $(form).find('[name="next_id"]').val(id);

	var locked_from = '';
	var from_date = $(form).find('[name="freeze_facility_data_locked_period_from"]').data('picker').getDate();
	if ($(form).find('[name="freeze_facility_data_locked_period_from"]').val() !== '' && !utils.isUndefined(from_date)) {
		locked_from = utils.dateToString(from_date);
	}
	var locked_till = '';
	var till_date = $(form).find('[name="freeze_facility_data_locked_period_till"]').data('picker').getDate();
	if ($(form).find('[name="freeze_facility_data_locked_period_till"]').val() !== '' && !utils.isUndefined(till_date)) {
		locked_till = utils.dateToString(till_date);
	}
	var selectedId = $(form).find('[name="selected_id"]');

	if (selectedId.val() === "") {
		$("#table_freeze_facility_data_locked_periods_form").find('.tt-content-datatable').find('.tt-datatable-detail').dataTable().fnAddData([
			id,
            locked_from + ',' + locked_till,
            utils.dateToString(new Date()), // Heute
            $("#content-detail").find('[name="auth_user"]').val(), // Ich
            locked_from,
            locked_till]
		);
	} else {
		var dataTable = $('#table_freeze_facility_data_locked_periods_form').find('.tt-content-datatable').find('.tt-datatable-detail').dataTable();
		var tr = dataTable.$('tr.selected-row');
		var aPos = dataTable.fnGetPosition(tr[0]);

		// Sichtbare Spalten
		dataTable.fnGetNodes(aPos).children[0].textContent = utils.dateToLocaleString(locked_from) + ' - ' + utils.dateToLocaleString(locked_till);
		dataTable.fnGetData(aPos)[1] = locked_from + ',' + locked_till;

        dataTable.fnGetNodes(aPos).children[1].textContent = utils.dateToLocaleString(new Date()); // Heute
		dataTable.fnGetData(aPos)[2] = utils.dateToString(new Date()); // Heute

        dataTable.fnGetNodes(aPos).children[2].textContent = $("#content-detail").find('[name="auth_user"]').val(); // Ich
		dataTable.fnGetData(aPos)[3] = $("#content-detail").find('[name="auth_user"]').val(); // Ich

        // Nicht sichtbare Spalten
        dataTable.fnGetData(aPos)[4] = locked_from;
        dataTable.fnGetData(aPos)[5] = locked_till;
	}

	$("#table_freeze_facility_data_locked_periods_form").find('.tt-content-datatable').find('.tt-datatable-detail').dataTable().$('tr.selected-row').removeClass('selected-row');
	$("#table_freeze_facility_data_locked_periods_form").find('.tt-content-datatable').find('.tt-delete').addClass('disabled');

	if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
		$("#content-detail").find('.tt-datatable-changes').val("changed");
		$("#content-detail").find('form').trigger('checkform.areYouSure');
	}

	element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function saveFreezeFacilityDataLockedPatient(element, form) {

    var id = parseInt($(form).find('[name="next_id"]').val()) - 1;
    $(form).find('[name="next_id"]').val(id);

    var patient_id = $(form).find('[name="freeze_facility_data_locked_patient"]').select2('data')[0].id;
    var patient_pseudonym = $(form).find('[name="freeze_facility_data_locked_patient"]').select2('data')[0].text;

    var selectedId = $(form).find('[name="selected_id"]');

    if (selectedId.val() === "") {
        $("#table_freeze_facility_data_locked_patients_form").find('.tt-content-datatable').find('.tt-datatable-detail').dataTable().fnAddData([
            id,
            patient_pseudonym,
            utils.dateToString(new Date()), // Heute
            $("#content-detail").find('[name="auth_user"]').val(), // Ich
            patient_id]
        );
    } else {
        var dataTable = $('#table_freeze_facility_data_locked_patients_form').find('.tt-content-datatable').find('.tt-datatable-detail').dataTable();
        var tr = dataTable.$('tr.selected-row');
        var aPos = dataTable.fnGetPosition(tr[0]);

        // Sichtbare Spalten
        dataTable.fnGetNodes(aPos).children[0].textContent = patient_pseudonym;
        dataTable.fnGetData(aPos)[1] = patient_pseudonym;

        dataTable.fnGetNodes(aPos).children[1].textContent = utils.dateToLocaleString(new Date()); // Heute
        dataTable.fnGetData(aPos)[2] = utils.dateToString(new Date()); // Heute

        dataTable.fnGetNodes(aPos).children[2].textContent = $("#content-detail").find('[name="auth_user"]').val(); // Ich
        dataTable.fnGetData(aPos)[3] = $("#content-detail").find('[name="auth_user"]').val(); // Ich

        // Nicht sichtbare Spalten
        dataTable.fnGetData(aPos)[4] = patient_id;
    }

    $("#table_freeze_facility_data_locked_patients_form").find('.tt-content-datatable').find('.tt-datatable-detail').dataTable().$('tr.selected-row').removeClass('selected-row');
    $("#table_freeze_facility_data_locked_patients_form").find('.tt-content-datatable').find('.tt-delete').addClass('disabled');

    if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
        $("#content-detail").find('.tt-datatable-changes').val("changed");
        $("#content-detail").find('form').trigger('checkform.areYouSure');
    }

    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function saveCollectionTypeMasterView(element, form) {

    var select2 = element.find('.tt-select2').select2('data')[0];
    var selectedId = $("#content-detail").find('.tt-content-datatable').find('.tt-selected-pos');

    $("#content-detail").find('.tt-content-datatable').find('.tt-datatable-detail-master-view').dataTable().fnAddData([
        '',
        select2.text,
        select2.id]
      );

    $("#content-detail").find('.tt-content-datatable').find('.tt-datatable-detail-master-view').dataTable().$('tr.selected-row').removeClass('selected-row');
    $("#content-detail").find('.tt-content-datatable').find('.tt-delete').addClass('disabled');
    if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
        $("#content-detail").find('.tt-datatable-changes').val("changed");
        $("#content-detail").find('form').trigger('checkform.areYouSure');
    }

    integrities.setIntegrityComboboxItems($('#table_collection_type_integrities_form'), '', true);

    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function saveCollectionTypeCourseViewRegister(element, form) {

    var select2 = element.find('.tt-select2').select2('data')[0];
    var selectedId = $("#content-detail").find('.tt-content-datatable').find('.tt-selected-pos');

    $("#content-detail").find('.tt-content-datatable').find('.tt-datatable-detail-course-view-register').dataTable().fnAddData([
        '',
        select2.text,
        select2.id]
      );

    $("#content-detail").find('.tt-content-datatable').find('.tt-datatable-detail-course-view-register').dataTable().$('tr.selected-row').removeClass('selected-row');
    $("#content-detail").find('.tt-content-datatable').find('.tt-delete').addClass('disabled');
    if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
        $("#content-detail").find('.tt-datatable-changes').val("changed");
        $("#content-detail").find('form').trigger('checkform.areYouSure');
    }

    integrities.setIntegrityComboboxItems($('#table_collection_type_integrities_form'), '', true);

    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function saveCollectionTypeQuestionnaire(element, form) {

	var select2 = element.find('.tt-select2').select2('data')[0];
	var selectedId = $("#content-detail").find('.tt-content-datatable').find('.tt-selected-pos');

	$("#content-detail").find('.tt-content-datatable').find('.tt-datatable-detail-questionnaire').dataTable().fnAddData([
		'',
		select2.text,
		select2.id]
	);

	$("#content-detail").find('.tt-content-datatable').find('.tt-datatable-detail-questionnaire').dataTable().$('tr.selected-row').removeClass('selected-row');
	$("#content-detail").find('.tt-content-datatable').find('.tt-delete').addClass('disabled');
	if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
		$("#content-detail").find('.tt-datatable-changes').val("changed");
		$("#content-detail").find('form').trigger('checkform.areYouSure');
	}

	integrities.setIntegrityComboboxItems($('#table_collection_type_integrities_form'), '', true);

	element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function saveCollectionTypeQuestionnaireProject(element, form) {

	var select2 = element.find('.tt-select2').select2('data')[0];
	var selectedId = $("#content-detail").find('.tt-content-datatable').find('.tt-selected-pos');

	$("#content-detail").find('.tt-content-datatable').find('.tt-datatable-detail-questionnaire-project').dataTable().fnAddData([
		'',
		select2.text,
		select2.id]
	);

	$("#content-detail").find('.tt-content-datatable').find('.tt-datatable-detail-questionnaire-project').dataTable().$('tr.selected-row').removeClass('selected-row');
	$("#content-detail").find('.tt-content-datatable').find('.tt-delete').addClass('disabled');
	if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
		$("#content-detail").find('.tt-datatable-changes').val("changed");
		$("#content-detail").find('form').trigger('checkform.areYouSure');
	}

	element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function addNewCollectionTypeCourseViewStudy(element, form) {

    var select2 = element.find('.tt-select2').select2('data')[0];

    var current_counter_id = 0;
    jQuery.each(element.parents('.tt-content').find('.dd-item'), function (i, val) {
        if (parseInt(val.getAttribute('data-id')) > current_counter_id) {
            current_counter_id = parseInt(val.getAttribute('data-id'));
        }
    });

    var current_counter_category = 0;
    if (element.parents('.tt-content').find('.dd').find('.dd-list').length) {
        jQuery.each(element.parents('.tt-content').find('.dd').find('.dd-list')[0].children, function (i, val) {
            var splitted_data = val.getAttribute('data-category').split("_");
            if (parseInt(splitted_data[1]) > current_counter_category) {
                current_counter_category = parseInt(splitted_data[1]);
            }
        });
    }

    var html = '<li class="dd-item" data-id="' + (current_counter_id + 1) + '" data-view-id="' + select2.id + '" data-type="" data-category="category_' + (current_counter_category + 1) + '"><div class="dd-handle tt-handle-first-level">' + select2.text + '</div></li>';
    $(html).appendTo("#dd_course_views .dd-list:first");

    if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
        $("#content-detail").find('.tt-datatable-changes').val("changed");
        $("#content-detail").find('form').trigger('checkform.areYouSure');
    }

    integrities.setIntegrityComboboxItems($('#table_collection_type_integrities_form'), '', true);

    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function saveCollectionTypeCourseViewStudy(element, form) {

    var id = element.parents('.tt-content').find('.tt-selected-id').val();

    $('.dd').find("[data-id='" + id + "']").find('.dd-list').remove();

    var html = '<ol class="dd-list"></ol>';
    var item = $('.dd').find("[data-id='" + id + "']");
    nestable.unsetNestableParent(item);

    $("input:checked", element.find('.tt-datatable-dialog').dataTable().fnGetNodes()).each(function () {

        $(html).appendTo(item);
        return false;
    });

    nestable.setNestableParent(item);

    var current_counter_id = 0;
    jQuery.each(element.parents('.tt-content').find('.dd-item'), function (i, val) {
        if (parseInt(val.getAttribute('data-id')) > current_counter_id) {
            current_counter_id = parseInt(val.getAttribute('data-id'));
        }
    });

    $("input:checked", element.find('.tt-datatable-dialog').dataTable().fnGetNodes()).each(function () {

        var html = '<li class="dd-item" data-id="' + (current_counter_id + 1) + '" data-view-id="' + $(this).val() + '"><div class="dd-handle">' + this.getAttribute('data-text') + '</div></li>';
        var item = $('.dd').find("[data-id='" + id + "']").find('.dd-list');

        $(html).appendTo(item);
        current_counter_id++;
    });

    $('.dd').find('.dd-handle').removeClass('dd-content-active');

    $("#content-detail").find('.tt-content-datatable').find('.tt-delete').addClass('disabled');
    $("#content-detail").find('.tt-content-datatable').find('.tt-update').addClass('disabled');
    $("#content-detail").find('.tt-content-datatable').find('.tt-set-start').addClass('disabled');

    if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
        $("#content-detail").find('.tt-datatable-changes').val("changed");
        $("#content-detail").find('form').trigger('checkform.areYouSure');
    }

    integrities.setIntegrityComboboxItems($('#table_collection_type_integrities_form'), '', true);

    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function saveDataViewControlType(element, form) {

    var id = parseInt($(form).find('[name="selected_id"]').val());
    var value = $(form).find('[name="control_type_value"]').val();
    var valueInDatabase = $(form).find('[name="value_in_database"]').val();
    var match = $(form).find('[name="control_type_value_match"]').select2('data');
    var inactive = $(form).find('[name="control_type_value_inactive"]').prop('checked');
    var scoreValue = $(form).find('[name="score_value"]').val();
	var aggregationValue = $(form).find('[name="aggregation_value"]').val();
    var caveText = $(form).find('[name="cave_text"]').val();
    var caveTextFormatting = '';
    jQuery.each($(form).find('[name="cave_text_formatting"]').select2('data'), function(k, format) {
        if (caveTextFormatting !== '') {
            caveTextFormatting += '|';
        }
        caveTextFormatting += format.id;
    });
    var caveTextColor = $(form).find('[name="cave_text_color"]').val();

    saveControlTypeValue(form, value, valueInDatabase, match, inactive, id, scoreValue, aggregationValue, caveText, caveTextFormatting, caveTextColor);

    $(form).parents('.modal-content').find('.tt-cancel-value-nestable').click();
}

function addNewMonitoringDisplayField(element) {

    var select2 = $(element).find('.tt-select2').select2('data')[0];
    var text = select2.text;
    var dataViewId = select2.id.split('|')[0];
    var dataViewName = select2.id.split('|')[1];

    var html = '';
    var item = $('#monitoring_display_fields_table').find('.dd-list')[0];

    html += '<li class="dd-item dd3-item">';
    html += '   <div class="dd-handle dd-dialog-handle dd3-handle">';
    html += '   </div>';
    html += '   <div class="dd3-content dd-dialog-content tt-monitoring-dd3-content" data-id="' + dataViewId + '|' + dataViewName + '" data-view-id="' + dataViewId + '" data-view-name="' + dataViewName + '" data-is-deleted="false">';
    html += '       <label class="dd3-content-label">' + text + '</label>';
    html += '   </div>';
    html += '</li>';

    $(html).appendTo(item);

    $('#monitoring_display_fields_table').parents('.tt-content-datatable').find('.tt-delete-monitoring-nestable').addClass('disabled');
    if ($('#monitoring_display_fields_table').parents('.tt-content-detail').find('.tt-datatable-changes').val() !== 'changed') {
        $('#monitoring_display_fields_table').parents('.tt-content-detail').find('.tt-datatable-changes').val('changed');
        $('#monitoring_display_fields_table').parents('.tt-content-detail').find('form').trigger('checkform.areYouSure');
    }

    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function addNewDataViewControlType(element, form) {

    var dialog = $('#table_data_views_control_type_dialog');

    var id = parseInt(dialog.find('[name="next_id"]').val()) - 1;
    dialog.find('[name="next_id"]').val(id);

    var value = $(form).find('[name="control_type_value"]').val();
    var valueInDatabase = $(form).find('[name="value_in_database"]').val();
    var match = $(form).find('[name="control_type_value_match"]').select2('data');
    var inactive = $(form).find('[name="control_type_value_inactive"]').prop('checked');
    var scoreValue = $(form).find('[name="score_value"]').val();
	var aggregationValue = $(form).find('[name="aggregation_value"]').val();
    var caveText = $(form).find('[name="cave_text"]').val();
    var caveTextFormatting = '';
    jQuery.each($(form).find('[name="cave_text_formatting"]').select2('data'), function(k, format) {
        if (caveTextFormatting !== '') {
            caveTextFormatting += '|';
        }
        caveTextFormatting += format.id;
    });
    var caveTextColor = $(form).find('[name="cave_text_color"]').val();
    var control_type = dialog.find('[name="control_type"]').val();

    //dialog.find('[name="list_values"]').val(dialog.find('[name="list_values"]').val() + '|' + value);
    //dialog.find('[name="list_values_in_database"]').val(dialog.find('[name="list_values_in_database"]').val() + '|' + valueInDatabase);

    dialog.find('.dd-list').find('.tt-button-nestable').addClass('hide');
    dialog.find('.dd-list').find('.dd3-content').removeClass('dd-content-active');

    dialog.find('.tt-save-value-nestable').addClass('disabled');
    dialog.find('.tt-delete-value-nestable').addClass('disabled');

    dialog.find('.widget-dialog-title').removeClass('hide');
    dialog.find('.widget-dialog-content').addClass('hide');

    var html = '';
    var item = dialog.find('.dd-list')[0];

    html += '<li class="dd-item dd3-item">';
    html += '   <div class="dd-handle dd-dialog-handle dd3-handle">';
    html += '   </div>';
    html += '   <div class="dd3-content dd-dialog-content" data-id="' + id + '" data-is-deleted="false">';
    html += '       <label class="dd3-content-label">' + value + ' (' + valueInDatabase + ')' + '</label>';

    if (control_type !== 'radio' && control_type != 'combo' && control_type != 'combo_multiselect') {
        html += '           <span class="tt-switch-nestable pull-right no-padding tt-button-nestable hide">';
        html += '               <label>' + trans('tripletrax.activate') + '</label>';
        html += '               <span class="onoffswitch">';
        html += '                   <input type="checkbox" name="activation_additionalfield_' + id + '" class="onoffswitch-checkbox" id="start_interval_' + id + '">';
        html += '                   <label class="onoffswitch-label" for="start_interval_' + id + '">';
        html += '                       <span class="onoffswitch-inner" data-swchon-text="' + trans('tripletrax.yes') + '" data-swchoff-text="' + trans('tripletrax.no') + '"></span>';
        html += '                       <span class="onoffswitch-switch"></span>';
        html += '                   </label>';
        html += '               </span>';
        html += '           </span>';
    }
    html += '   </div>';
    html += '</li>';

    $(html).appendTo(item);

    saveControlTypeValue(dialog.find('form'), value, valueInDatabase, match, inactive, id, scoreValue, aggregationValue, caveText, caveTextFormatting, caveTextColor);

    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function saveControlTypeValue(form, value, valueInDatabase, match, inactive, id, scoreValue, aggregationValue, caveText, caveTextFormatting, caveTextColor) {

    var contentElement = $(form).parents('.modal-content').find('[data-id="' + id + '"]');
    contentElement.data('value', value);
    contentElement.data('valueInDatabase', valueInDatabase);
    if (!utils.isUndefined(match)) {
        contentElement.data('match', match[0].id);
    } else {
        contentElement.data('match', '');
    }
    contentElement.data('inactive', inactive);
    contentElement.data('scoreValue', scoreValue);
	contentElement.data('aggregationValue', aggregationValue);
    contentElement.data('caveText', caveText);
    contentElement.data('caveTextFormatting', caveTextFormatting);
    contentElement.data('caveTextColor', caveTextColor);

    contentElement.find('.dd3-content-label').text(value + ' (' + valueInDatabase + ')');
    if (inactive) {
        contentElement.find('.dd3-content-label').addClass('dd3-content-label-inactive');
    } else {
        contentElement.find('.dd3-content-label').removeClass('dd3-content-label-inactive');
    }

    var value_input = '';
    var valueInDatabase_input = '';
    var aggregationValue_input = '';
    jQuery.each($(form).parents('.modal-content').find('.dd3-content'), function (i, val) {

        if (!utils.isUndefined(match) && $(val).data('match') === match.id) {
            $(val).find('.dd3-content-label-match').remove();
            if ($(val).data('id') === id) {
                $(val).find('.dd3-content-label').after('<span class="label label-info dd3-content-label-match">' + match.text + '</span>');
            } else {
                $(val).data('match', '');
            }
        } else if (utils.isUndefined(match) && $(val).data('id') === id) {
            $(val).find('.dd3-content-label-match').remove();
        }
        if (value_input !== '') {
            value_input += '|';
        }
        if (valueInDatabase_input !== '') {
            valueInDatabase_input += '|';
        }
		if (aggregationValue_input !== '') {
			aggregationValue_input += '|';
		}

        value_input += $(val).data('value');
        valueInDatabase_input += $(val).data('value-in-database');
		aggregationValue_input += $(val).data('aggregation-value');
    });

    $(form).parents('.modal-content').find('[name="list_values"]').val(value_input);
    $(form).parents('.modal-content').find('[name="list_values_in_database"]').val(valueInDatabase_input);
	$(form).parents('.modal-content').find('[name="list_aggregation_values"]').val(aggregationValue_input);
}

function saveUnit(element, form) {

    var unit = $(form).find('[name="unit"]').val();
    var conversion_factor = '';
    if ($(form).find('[name="conversion_factor"]').val() !== '') {
		conversion_factor = utils.stringToNumber($(form).find('[name="conversion_factor"]').val());
    }
    var conversion_formula = $(form).find('[name="conversion_formula"]').select2('val');
    var conversion_formula_desc = '';
    if (conversion_formula !== '') {
        conversion_formula_desc = $(form).find('[name="conversion_formula"]').select2('data')[0].text;
    }
    var display_decimals = $(form).find('[name="display_decimals"]').val();
    var tr = $(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable().$('tr.selected-row');
    var aPos = $(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable().fnGetPosition(tr[0]);

    $(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable().fnGetNodes(aPos).children[1].textContent = unit;
    $(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable().fnGetData(aPos)[2] = unit;

    if (conversion_formula !== '') {
		$(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable().fnGetNodes(aPos).children[2].textContent = conversion_formula_desc;
    } else {
		$(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable().fnGetNodes(aPos).children[2].textContent = conversion_factor;
    }
    $(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable().fnGetData(aPos)[3] = conversion_factor;
    $(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable().fnGetData(aPos)[5] = conversion_formula;
    $(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable().fnGetData(aPos)[6] = conversion_formula_desc;

    $(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable().fnGetNodes(aPos).children[3].textContent = display_decimals;
    $(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable().fnGetData(aPos)[4] = display_decimals;

    $(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable().fnStandingRedraw();

    $(form).parents('.modal-content').find('.tt-cancel-value-modal').click();
}

function addNewUnit(element, form) {

    var unit = $(form).find('[name="unit"]').val();
	var conversion_factor = '';
	if ($(form).find('[name="conversion_factor"]').val() !== '') {
		conversion_factor = utils.stringToNumber($(form).find('[name="conversion_factor"]').val());
	}
	var conversion_formula = $(form).find('[name="conversion_formula"]').select2('val');
	var conversion_formula_desc = '';
	if (conversion_formula !== '') {
		conversion_formula_desc = $(form).find('[name="conversion_formula"]').select2('data')[0].text;
	}
    var display_decimals = $(form).find('[name="display_decimals"]').val();

    if ($("#table_data_views_units").dataTable().fnGetNodes().length === 0) {
        $("#table_data_views_units").dataTable().fnAddData([
            '',
            '<label class="checkbox" style="width:20px"><input name="default_unit" type="checkbox" checked class="tt-checkbox-units"><i></i></label>',
            unit,
            conversion_factor,
            display_decimals,
			conversion_formula,
			conversion_formula_desc]
        );
    } else {
        $("#table_data_views_units").dataTable().fnAddData([
            '',
            '<label class="checkbox" style="width:20px"><input name="default_unit" type="checkbox" class="tt-checkbox-units"><i></i></label>',
            unit,
            conversion_factor,
            display_decimals,
			conversion_formula,
			conversion_formula_desc]
        );
    }

    $("#table_data_views_units").dataTable().$('tr.selected-row').removeClass('selected-row');
    $("#table_data_views_units_dialog").find('.tt-content-datatable').find('.tt-delete').addClass('disabled');

    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function saveOrAddNewDataCollectionTypeIntegrity(element, form) {

    var selectedId = $(form).find('[name="selected_id"]').val();

    var control_type = $('#table_collection_type_integrities_dialog').find('[name="control_type"]').val();
    var data_type = $('#table_collection_type_integrities_dialog').find('[name="data_type"]').val();

    // Allgemeine Angaben
    var splitted_data_view_id = $(form).find('[name="integrity_data_view_field"]').select2('val').split('|');
    var integrity_data_view_field_id = splitted_data_view_id[0];
    var integrity_data_view_field_name = splitted_data_view_id[1];
    var integrity_data_view_field_desc = $(form).find('[name="integrity_data_view_field"]').select2('data')[0].text;
    var integrity_description = $(form).find('[name="integrity_description"]').val();
    var integrity_valid_from = '';
	var valid_from = $(form).find('[name="integrity_valid_from"]').data('picker').getDate();
	if ($(form).find('[name="integrity_valid_from"]').val() !== '' && !utils.isUndefined(valid_from)) {
		integrity_valid_from = utils.dateToString(valid_from);
	}
	var integrity_valid_till = '';
	var valid_till = $(form).find('[name="integrity_valid_till"]').data('picker').getDate();
	if ($(form).find('[name="integrity_valid_till"]').val() !== '' && !utils.isUndefined(valid_till)) {
		integrity_valid_till = utils.dateToString(valid_till);
	}
    var integrity_integritytype = '';
    if (!utils.isUndefined($(form).find('[name="integrity_integritytype"]:checked')) && $(form).find('[name="integrity_integritytype"]:checked').length > 0) {
        integrity_integritytype = $(form).find('[name="integrity_integritytype"]:checked').val();
    }
    var integrity_gender = '';
    if (!utils.isUndefined($(form).find('[name="integrity_gender"]:checked')) && $(form).find('[name="integrity_gender"]:checked').length > 0) {
        integrity_gender = $(form).find('[name="integrity_gender"]:checked').val();
    }
    var integrity_type_id = '';
    var integrity_type_name = '';
    if (!utils.isUndefined($(form).find('[name="integrity_type"]').select2('data'))) {
        integrity_type_id = $(form).find('[name="integrity_type"]').select2('data')[0].id;
        integrity_type_name = $(form).find('[name="integrity_type"]').select2('data')[0].text;
    } else {
        integrity_type_name = trans('tripletrax.custom_rule');
    }
    var integrity_custom_rule = '';
    if (!utils.isUndefined($(form).find('[name="integrity_custom_rule"]').select2('data'))) {
        integrity_custom_rule = $(form).find('[name="integrity_custom_rule"]').select2('data')[0].id;
    }

    // Alter von
    var select_age_from_field = $(form).find('[name="integrity_age_from_field"]').select2('data')[0];
    var integrity_age_from_data_view_id = '0';
    var integrity_age_from_data_view_name = '';
    var integrity_age_from_plus_minus = '';
    var integrity_age_from_value = '0';
    var integrity_age_from_range = '';
    if (!utils.isUndefined(select_age_from_field) && select_age_from_field.text !== '' && $(form).find('[name="integrity_age_from_range"]').val() !== '') {
        integrity_age_from_data_view_id = select_age_from_field.id.split('|')[0];
        integrity_age_from_data_view_name = select_age_from_field.id.split('|')[1];

        integrity_age_from_plus_minus = '+';
        if ($(form).find('[name="integrity_age_from_plus_minus"]')[0].checked) {
            integrity_age_from_plus_minus = '-';
        }
        integrity_age_from_value = $(form).find('[name="integrity_age_from_range"]').val();
        integrity_age_from_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_age_from_range"]'));
    }

    // Alter bis
    var select_age_till_field = $(form).find('[name="integrity_age_till_field"]').select2('data')[0];
    var integrity_age_till_data_view_id = '0';
    var integrity_age_till_data_view_name = '';
    var integrity_age_till_plus_minus = '';
    var integrity_age_till_value = '0';
    var integrity_age_till_range = '';
    if (!utils.isUndefined(select_age_till_field) && select_age_till_field.text !== '' && $(form).find('[name="integrity_age_till_range"]').val() !== '') {
        integrity_age_till_data_view_id = select_age_till_field.id.split('|')[0];
        integrity_age_till_data_view_name = select_age_till_field.id.split('|')[1];

        integrity_age_till_plus_minus = '+';
        if ($(form).find('[name="integrity_age_till_plus_minus"]')[0].checked) {
            integrity_age_till_plus_minus = '-';
        }
        integrity_age_till_value = $(form).find('[name="integrity_age_till_range"]').val();
        integrity_age_till_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_age_till_range"]'));
    }

    var integrity_value = '';
    var integrity_completeness_frequency = '';
    var integrity_optional = '0';
    var integrity_mandatory_field = '0';
    var integrity_unit = '';
    var integrity_logical_operator_from = '';
    var integrity_value_from = '';
    var integrity_value_from_data_view_id = '0';
    var integrity_value_from_data_view_name = '';
    var integrity_value_from_up_down = '';
    var integrity_value_from_value = '';
    var integrity_value_from_range = '';
    var integrity_value_from_unit_1 = '';
    var integrity_value_from_unit_2 = '';
    var integrity_logical_operator_till = '';
    var integrity_value_till = '';
    var integrity_value_till_data_view_id = '0';
    var integrity_value_till_data_view_name = '';
    var integrity_value_till_up_down = '';
    var integrity_value_till_value = '';
    var integrity_value_till_range = '';
    var integrity_value_till_unit_1 = '';
    var integrity_value_till_unit_2 = '';
    var integrity_range_of_values = '';
    var integrity_deviation_percentage_value = '';
    var integrity_deviation_down = '-1';
    var integrity_period_down_value = '0';
    var integrity_period_down_range = '';
    var integrity_deviation_up = '-1';
    var integrity_period_up_value = '0';
    var integrity_period_up_range = '';
    var integrity_dep_value = '';
    var integrity_dep_unit = '';
    var integrity_dep_data_view_id = '0';
    var integrity_dep_data_view_name = '';
    var integrity_dep_logical_operator_from = '';
    var integrity_dep_value_from = '';
    var integrity_dep_value_from_data_view_id = '0';
    var integrity_dep_value_from_data_view_name = '';
    var integrity_dep_value_from_up_down = '';
    var integrity_dep_value_from_value = '';
    var integrity_dep_value_from_range = '';
    var integrity_dep_logical_operator_till = '';
    var integrity_dep_value_till = '';
    var integrity_dep_value_till_data_view_id = '0';
    var integrity_dep_value_till_data_view_name = '';
    var integrity_dep_value_till_up_down = '';
    var integrity_dep_value_till_value = '';
    var integrity_dep_value_till_range = '';
    var integrity_dep_range_of_values = '';

    // Vollständigkeit
    if (integrity_type_id === 'completeness') {

        if (!utils.isUndefined($(form).find('[name="completeness_frequency"]:checked')) && $(form).find('[name="completeness_frequency"]:checked').length > 0) {
            integrity_completeness_frequency = $(form).find('[name="completeness_frequency"]:checked').val();
        }
        if ($(form).find('[name="completeness_optional"]')[0].checked) {
            integrity_optional = '1';
        }
        if ($(form).find('[name="completeness_mandatory_field"]')[0].checked) {
            integrity_mandatory_field = '1';
        }
        jQuery.each($(form).find('[name="completeness_range_of_values"]').select2('data'), function (i, val) {
            if (integrity_range_of_values !== '') {
                integrity_range_of_values += '$';
            }
            integrity_range_of_values += val.id;
        });

    }

    // Wertebereich
    if (integrity_type_id === 'range') {

        if (control_type === 'input' || control_type === 'input_with_additionalfield') {

            // Wert von
            var select_logical_operator_from = $(form).find('[name="integrity_logical_from_field"]').select2('data')[0];
            if (!utils.isUndefined(select_logical_operator_from) && select_logical_operator_from.text !== '') {
                integrity_logical_operator_from = select_logical_operator_from.id;
            }
            integrity_value_from = utils.stringToNumber($(form).find('[name="integrity_value_from"]').val());
            integrity_unit = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_value_from"]'));
            var select_value_from_field = $(form).find('[name="integrity_value_from_field"]').select2('data')[0];
            if (!utils.isUndefined(select_value_from_field) && select_value_from_field.text !== '') {
                integrity_value_from_data_view_id = select_value_from_field.id.split('|')[0];
                integrity_value_from_data_view_name = select_value_from_field.id.split('|')[1];
            }
            var select_value_from_field_unit_1 = $(form).find('[name="integrity_value_from_field_unit_1"]').select2('data')[0];
            if (!utils.isUndefined(select_value_from_field_unit_1) && select_value_from_field_unit_1.text !== '') {
                integrity_value_from_unit_1 = select_value_from_field_unit_1.id;
            }
            var select_value_from_field_unit_2 = $(form).find('[name="integrity_value_from_field_unit_2"]').select2('data')[0];
            if (!utils.isUndefined(select_value_from_field_unit_2) && select_value_from_field_unit_2.text !== '') {
                integrity_value_from_unit_2 = select_value_from_field_unit_2.id;
            }

            // Wert bis
            var select_logical_operator_till = $(form).find('[name="integrity_logical_till_field"]').select2('data')[0];
            if (!utils.isUndefined(select_logical_operator_till) && select_logical_operator_till.text !== '') {
                integrity_logical_operator_till = select_logical_operator_till.id;
            }
            integrity_value_till = utils.stringToNumber($(form).find('[name="integrity_value_till"]').val());
            var select_value_till_field = $(form).find('[name="integrity_value_till_field"]').select2('data')[0];
            if (!utils.isUndefined(select_value_till_field) && select_value_till_field.text !== '') {
                integrity_value_till_data_view_id = select_value_till_field.id.split('|')[0];
                integrity_value_till_data_view_name = select_value_till_field.id.split('|')[1];
            }
            var select_value_till_field_unit_1 = $(form).find('[name="integrity_value_till_field_unit_1"]').select2('data')[0];
            if (!utils.isUndefined(select_value_till_field_unit_1) && select_value_till_field_unit_1.text !== '') {
                integrity_value_till_unit_1 = select_value_till_field_unit_1.id;
            }
            var select_value_till_field_unit_2 = $(form).find('[name="integrity_value_till_field_unit_2"]').select2('data')[0];
            if (!utils.isUndefined(select_value_till_field_unit_2) && select_value_till_field_unit_2.text !== '') {
                integrity_value_till_unit_2 = select_value_till_field_unit_2.id;
            }

        } else if (control_type === 'date_panel' || control_type === 'date_range') {

            // Wert von
            var select_logical_operator_from = $(form).find('[name="integrity_logical_from_date_field"]').select2('data')[0]
            if (!utils.isUndefined(select_logical_operator_from) && select_logical_operator_from.text !== '') {
                integrity_logical_operator_from = select_logical_operator_from.id;
            }
            var select_value_from_date_field = $(form).find('[name="integrity_value_from_date_field"]').select2('data')[0];
            if (!utils.isUndefined(select_value_from_date_field) && select_value_from_date_field.text !== '' && $(form).find('[name="integrity_value_from_date_range"]').val() !== '') {
                integrity_value_from_data_view_id = select_value_from_date_field.id.split('|')[0];
                integrity_value_from_data_view_name = select_value_from_date_field.id.split('|')[1];

                integrity_value_from_up_down = '+';
                if ($(form).find('[name="integrity_value_from_plus_minus"]')[0].checked) {
                    integrity_value_from_up_down = '-';
                }
                integrity_value_from_value = $(form).find('[name="integrity_value_from_date_range"]').val();
                integrity_value_from_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_value_from_date_range"]'));
            }

            // Wert bis
            var select_logical_operator_till = $(form).find('[name="integrity_logical_till_date_field"]').select2('data')[0];
            if (!utils.isUndefined(select_logical_operator_till) && select_logical_operator_till.text !== '') {
                integrity_logical_operator_till = select_logical_operator_till.id;
            }
            var select_value_till_date_field = $(form).find('[name="integrity_value_till_date_field"]').select2('data')[0];
            if (!utils.isUndefined(select_value_till_date_field) && select_value_till_date_field.text !== '' && $(form).find('[name="integrity_value_till_date_range"]').val() !== '') {
                integrity_value_till_data_view_id = select_value_till_date_field.id.split('|')[0];
                integrity_value_till_data_view_name = select_value_till_date_field.id.split('|')[1];

                integrity_value_till_up_down = '+';
                if ($(form).find('[name="integrity_value_till_plus_minus"]')[0].checked) {
                    integrity_value_till_up_down = '-';
                }
                integrity_value_till_value = $(form).find('[name="integrity_value_till_date_range"]').val();
                integrity_value_till_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_value_till_date_range"]'));
            }

        } else {

            jQuery.each($(form).find('[name="integrity_control_type"]').select2('data'), function (i, val) {
                if (integrity_range_of_values !== '') {
                    integrity_range_of_values += '$';
                }
                integrity_range_of_values += val.id;
            });

        }
    }

    // Abweichung
    if (integrity_type_id === 'deviation') {
        if ((control_type === 'input' || control_type === 'input_with_additionalfield') && (data_type === 'integer' || data_type === 'decimal')) {

            integrity_deviation_percentage_value = $(form).find('[name="integrity_deviation_percentage_value"]:checked');
            if (integrity_deviation_percentage_value.length) {
                integrity_deviation_percentage_value = integrity_deviation_percentage_value.val();
            } else {
                integrity_deviation_percentage_value = '';
            }

            // Abweichung nach hinten (zeitlich gesehen)
            integrity_deviation_down = $(form).find('[name="integrity_deviation_down"]').val();
            if (integrity_deviation_down !== '') {
                integrity_unit = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_deviation_down"]'));
                integrity_period_down_value = $(form).find('[name="integrity_period_down"]').val();
                integrity_period_down_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_period_down"]'));
            } else {
                integrity_deviation_down = '-1';
            }

            // Abweichung nach vorn (zeitlich gesehen)
            integrity_deviation_up = $(form).find('[name="integrity_deviation_up"]').val();
            if (integrity_deviation_up !== '') {
                integrity_period_up_value = $(form).find('[name="integrity_period_up"]').val();
                integrity_period_up_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_period_up"]'));
            } else {
                integrity_deviation_up = '-1';
            }

        } else {

            integrity_deviation_down = '0';
            integrity_deviation_up = '0';

        }
    }

    // Abhängigkeit
    if (integrity_type_id === 'dependency') {

        // Wert
        if ($(form).find('[name="integrity_existing_value"]')[0].checked) {

            integrity_value = 'existing';

        } else if ($(form).find('[name="integrity_not_existing_value"]')[0].checked) {

            integrity_value = 'not_existing';

        } else {

            if (control_type === 'input' || control_type === 'input_with_additionalfield') {

                if (data_type === 'integer' || data_type === 'decimal') {

                    // Wert von
                    var select_logical_operator_from = $(form).find('[name="integrity_field_logical_from_field"]').select2('data')[0];
                    if (!utils.isUndefined(select_logical_operator_from) && select_logical_operator_from.text !== '') {
                        integrity_logical_operator_from = select_logical_operator_from.id;
                    }
                    integrity_value_from = utils.stringToNumber($(form).find('[name="integrity_field_value_from"]').val());
                    integrity_unit = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_field_value_from"]'));
                    var select_value_from_field = $(form).find('[name="integrity_field_value_from_field"]').select2('data')[0];
                    if (!utils.isUndefined(select_value_from_field) && select_value_from_field.text !== '') {
                        integrity_value_from_data_view_id = select_value_from_field.id.split('|')[0];
                        integrity_value_from_data_view_name = select_value_from_field.id.split('|')[1];
                    }

                    // Wert bis
                    var select_logical_operator_till = $(form).find('[name="integrity_field_logical_till_field"]').select2('data')[0];
                    if (!utils.isUndefined(select_logical_operator_till) && select_logical_operator_till.text !== '') {
                        integrity_logical_operator_till = select_logical_operator_till.id;
                    }
                    integrity_value_till = utils.stringToNumber($(form).find('[name="integrity_field_value_till"]').val());
                    var select_value_till_field = $(form).find('[name="integrity_field_value_till_field"]').select2('data')[0];
                    if (!utils.isUndefined(select_value_till_field) && select_value_till_field.text !== '') {
                        integrity_value_till_data_view_id = select_value_till_field.id.split('|')[0];
                        integrity_value_till_data_view_name = select_value_till_field.id.split('|')[1];
                    }

                } else {

                    integrity_range_of_values = $(form).find('[name="integrity_field_input"]').val();

                }

            } else if (control_type === 'date_panel' || control_type === 'date_range') {

                // Wert von
                var select_logical_operator_from = $(form).find('[name="integrity_field_logical_from_date_field"]').select2('data')[0];
                if (!utils.isUndefined(select_logical_operator_from) && select_logical_operator_from.text !== '') {
                    integrity_logical_operator_from = select_logical_operator_from.id;
                }
                var select_value_from_date_field = $(form).find('[name="integrity_field_value_from_date_field"]').select2('data')[0];
                if (!utils.isUndefined(select_value_from_date_field) && select_value_from_date_field.text !== '' && $(form).find('[name="integrity_field_value_from_date_range"]').val() !== '') {
                    integrity_value_from_data_view_id = select_value_from_date_field.id.split('|')[0];
                    integrity_value_from_data_view_name = select_value_from_date_field.id.split('|')[1];

                    integrity_value_from_up_down = '+';
                    if ($(form).find('[name="integrity_field_value_from_plus_minus"]')[0].checked) {
                        integrity_value_from_up_down = '-';
                    }
                    integrity_value_from_value = $(form).find('[name="integrity_field_value_from_date_range"]').val();
                    integrity_value_from_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_field_value_from_date_range"]'));
                }

                // Wert bis
                var select_logical_operator_till = $(form).find('[name="integrity_field_logical_till_date_field"]').select2('data')[0];
                if (!utils.isUndefined(select_logical_operator_till) && select_logical_operator_till.text !== '') {
                    integrity_logical_operator_till = select_logical_operator_till.id;
                }
                var select_value_till_date_field = $(form).find('[name="integrity_field_value_till_date_field"]').select2('data')[0];
                if (!utils.isUndefined(select_value_till_date_field) && select_value_till_date_field.text !== '' && $(form).find('[name="integrity_field_value_till_date_range"]').val() !== '') {
                    integrity_value_till_data_view_id = select_value_till_date_field.id.split('|')[0];
                    integrity_value_till_data_view_name = select_value_till_date_field.id.split('|')[1];

                    integrity_value_till_up_down = '+';
                    if ($(form).find('[name="integrity_field_value_till_plus_minus"]')[0].checked) {
                        integrity_value_till_up_down = '-';
                    }
                    integrity_value_till_value = $(form).find('[name="integrity_field_value_till_date_range"]').val();
                    integrity_value_till_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_field_value_till_date_range"]'));
                }

            } else {

                jQuery.each($(form).find('[name="integrity_field_list"]').select2('data'), function (i, val) {
                    if (integrity_range_of_values !== '') {
                        integrity_range_of_values += '$';
                    }
                    integrity_range_of_values += val.id;
                });

            }

        }

        var integrity_depending_field = $(form).find('[name="integrity_depending_field"]').select2('data')[0];
        if (!utils.isUndefined(integrity_depending_field) && integrity_depending_field.text !== '') {
            integrity_dep_data_view_id = integrity_depending_field.id.split('|')[0];
            integrity_dep_data_view_name = integrity_depending_field.id.split('|')[1];
        }

        integrity_completeness_frequency = $(form).find('[name="integrity_dependency_frequency"]:checked').val();
        if ($(form).find('[name="integrity_dependency_optional"]')[0].checked) {
            integrity_optional = '1';
        }

        var dep_control_type = '';
        var dep_data_type = '';

        if (!utils.isUndefined($(form).find('[name="integrity_depending_field"]').select2('val')) && $(form).find('[name="integrity_depending_field"]').select2('val') !== '') {
            dep_control_type = $(form).find('[name="integrity_depending_field"]').select2('data')[0].controlType;
            dep_data_type = $(form).find('[name="integrity_depending_field"]').select2('data')[0].dataType;
        }

        if (integrity_completeness_frequency === 'no') {

            if ($(form).find('[name="integrity_existing_depending_value"]')[0].checked) {

                integrity_dep_value = 'existing';

            } else if ($(form).find('[name="integrity_not_existing_depending_value"]')[0].checked) {

                integrity_dep_value = 'not_existing';

            } else {

                if (dep_control_type === 'input' || dep_control_type === 'input_with_additionalfield') {

                    if (dep_data_type === 'integer' || dep_data_type === 'decimal') {

                        // Wert von
                        var dep_select_logical_operator_from = $(form).find('[name="integrity_depending_field_logical_from_field"]').select2('data')[0];
                        if (!utils.isUndefined(dep_select_logical_operator_from) && dep_select_logical_operator_from.text !== '') {
                            integrity_dep_logical_operator_from = dep_select_logical_operator_from.id;
                        }
                        integrity_dep_value_from = utils.stringToNumber($(form).find('[name="integrity_depending_field_value_from"]').val());
                        integrity_dep_unit = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_depending_field_value_from"]'));
                        var dep_select_value_from_field = $(form).find('[name="integrity_depending_field_value_from_field"]').select2('data')[0];
                        if (!utils.isUndefined(dep_select_value_from_field) && dep_select_value_from_field.text !== '') {
                            integrity_dep_value_from_data_view_id = dep_select_value_from_field.id.split('|')[0];
                            integrity_dep_value_from_data_view_name = dep_select_value_from_field.id.split('|')[1];
                        }

                        // Wert bis
                        var dep_select_logical_operator_till = $(form).find('[name="integrity_depending_field_logical_till_field"]').select2('data')[0];
                        if (!utils.isUndefined(dep_select_logical_operator_till) && dep_select_logical_operator_till.text !== '') {
                            integrity_dep_logical_operator_till = dep_select_logical_operator_till.id;
                        }
                        integrity_dep_value_till = utils.stringToNumber($(form).find('[name="integrity_depending_field_value_till"]').val());
                        var dep_select_value_till_field = $(form).find('[name="integrity_depending_field_value_till_field"]').select2('data')[0];
                        if (!utils.isUndefined(dep_select_value_till_field) && dep_select_value_till_field.text !== '') {
                            integrity_dep_value_till_data_view_id = dep_select_value_till_field.id.split('|')[0];
                            integrity_dep_value_till_data_view_name = dep_select_value_till_field.id.split('|')[1];
                        }

                    } else {

                        integrity_dep_range_of_values = $(form).find('[name="integrity_depending_field_input"]').val();

                    }

                } else if (dep_control_type === 'date_panel' || dep_control_type === 'date_range') {

                    // Wert von
                    var dep_select_logical_operator_from = $(form).find('[name="integrity_depending_field_logical_from_date_field"]').select2('data')[0];
                    if (!utils.isUndefined(dep_select_logical_operator_from) && dep_select_logical_operator_from.text !== '') {
                        integrity_dep_logical_operator_from = dep_select_logical_operator_from.id;
                    }
                    var dep_select_value_from_date_field = $(form).find('[name="integrity_depending_field_value_from_date_field"]').select2('data')[0];
                    if (!utils.isUndefined(dep_select_value_from_date_field) && dep_select_value_from_date_field.text !== '' && $(form).find('[name="integrity_depending_field_value_from_date_range"]').val() !== '') {
                        integrity_dep_value_from_data_view_id = dep_select_value_from_date_field.id.split('|')[0];
                        integrity_dep_value_from_data_view_name = dep_select_value_from_date_field.id.split('|')[1];

                        integrity_dep_value_from_up_down = '+';
                        if ($(form).find('[name="integrity_depending_field_value_from_plus_minus"]')[0].checked) {
                            integrity_dep_value_from_up_down = '-';
                        }
                        integrity_dep_value_from_value = $(form).find('[name="integrity_depending_field_value_from_date_range"]').val();
                        integrity_dep_value_from_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_depending_field_value_from_date_range"]'));
                    }

                    // Wert bis
                    var dep_select_logical_operator_till = $(form).find('[name="integrity_depending_field_logical_till_date_field"]').select2('data')[0];
                    if (!utils.isUndefined(dep_select_logical_operator_till) && dep_select_logical_operator_till.text !== '') {
                        integrity_dep_logical_operator_till = dep_select_logical_operator_till.id;
                    }
                    var dep_select_value_till_date_field = $(form).find('[name="integrity_depending_field_value_till_date_field"]').select2('data')[0];
                    if (!utils.isUndefined(dep_select_value_till_date_field) && dep_select_value_till_date_field.text !== '' && $(form).find('[name="integrity_depending_field_value_till_date_range"]').val() !== '') {
                        integrity_dep_value_till_data_view_id = dep_select_value_till_date_field.id.split('|')[0];
                        integrity_dep_value_till_data_view_name = dep_select_value_till_date_field.id.split('|')[1];

                        integrity_dep_value_till_up_down = '+';
                        if ($(form).find('[name="integrity_depending_field_value_till_plus_minus"]')[0].checked) {
                            integrity_dep_value_till_up_down = '-';
                        }
                        integrity_dep_value_till_value = $(form).find('[name="integrity_depending_field_value_till_date_range"]').val();
                        integrity_dep_value_till_range = utils.getValueFromInputWithDropDownField($(form).find('[name="integrity_depending_field_value_till_date_range"]'));
                    }

                } else {

                    jQuery.each($(form).find('[name="integrity_depending_field_list"]').select2('data'), function (i, val) {
                        if (integrity_dep_range_of_values !== '') {
                            integrity_dep_range_of_values += '$';
                        }
                        integrity_dep_range_of_values += val.id;
                    });

                }

            }
        } else {

            jQuery.each($(form).find('[name="integrity_depending_field_list"]').select2('data'), function (i, val) {
                if (integrity_dep_range_of_values !== '') {
                    integrity_dep_range_of_values += '$';
                }
                integrity_dep_range_of_values += val.id;
            });

        }
    }

    var dataTable = $('#table_data_collection_type_integrities').dataTable();

    if (selectedId !== '') {

        var tr = dataTable.$('tr.selected-row');
        var aPos = dataTable.fnGetPosition(tr[0]);

        // Sichtbare Spalten
        dataTable.fnGetNodes(aPos).children[0].textContent = integrity_data_view_field_desc;
        dataTable.fnGetData(aPos)[1] = integrity_data_view_field_desc;

        dataTable.fnGetNodes(aPos).children[1].textContent = integrity_description;
        dataTable.fnGetData(aPos)[2] = integrity_description;

        dataTable.fnGetNodes(aPos).children[2].textContent = integrity_type_name;
        dataTable.fnGetData(aPos)[3] = integrity_type_name;

        // Nicht sichtbare Spalten
        dataTable.fnGetData(aPos)[4] = integrity_type_id;
        dataTable.fnGetData(aPos)[5] = integrity_integritytype;
        dataTable.fnGetData(aPos)[6] = integrity_data_view_field_id;
        dataTable.fnGetData(aPos)[7] = integrity_gender;
        dataTable.fnGetData(aPos)[8] = integrity_custom_rule;
        dataTable.fnGetData(aPos)[9] = integrity_age_from_data_view_id;
        dataTable.fnGetData(aPos)[10] = integrity_age_from_data_view_name;
        dataTable.fnGetData(aPos)[11] = integrity_age_from_plus_minus;
        dataTable.fnGetData(aPos)[12] = integrity_age_from_value;
        dataTable.fnGetData(aPos)[13] = integrity_age_from_range;
        dataTable.fnGetData(aPos)[14] = integrity_age_till_data_view_id;
        dataTable.fnGetData(aPos)[15] = integrity_age_till_data_view_name;
        dataTable.fnGetData(aPos)[16] = integrity_age_till_plus_minus;
        dataTable.fnGetData(aPos)[17] = integrity_age_till_value;
        dataTable.fnGetData(aPos)[18] = integrity_age_till_range;
        dataTable.fnGetData(aPos)[19] = integrity_value;
        dataTable.fnGetData(aPos)[20] = integrity_completeness_frequency;
        dataTable.fnGetData(aPos)[21] = integrity_optional;
        dataTable.fnGetData(aPos)[22] = integrity_unit;
        dataTable.fnGetData(aPos)[23] = (integrity_value_from === '' && integrity_value_from_data_view_id === '0') ? '' : integrity_logical_operator_from;
        dataTable.fnGetData(aPos)[24] = integrity_value_from;
        dataTable.fnGetData(aPos)[25] = integrity_value_from_data_view_id;
        dataTable.fnGetData(aPos)[26] = integrity_value_from_data_view_name;
        dataTable.fnGetData(aPos)[27] = integrity_value_from_up_down;
        dataTable.fnGetData(aPos)[28] = integrity_value_from_value;
        dataTable.fnGetData(aPos)[29] = integrity_value_from_range;
        dataTable.fnGetData(aPos)[30] = (integrity_value_till === '' && integrity_value_till_data_view_id === '0') ? '' : integrity_logical_operator_till;
        dataTable.fnGetData(aPos)[31] = integrity_value_till;
        dataTable.fnGetData(aPos)[32] = integrity_value_till_data_view_id;
        dataTable.fnGetData(aPos)[33] = integrity_value_till_data_view_name;
        dataTable.fnGetData(aPos)[34] = integrity_value_till_up_down;
        dataTable.fnGetData(aPos)[35] = integrity_value_till_value;
        dataTable.fnGetData(aPos)[36] = integrity_value_till_range;
        dataTable.fnGetData(aPos)[37] = integrity_range_of_values;
        dataTable.fnGetData(aPos)[38] = integrity_deviation_percentage_value;
        dataTable.fnGetData(aPos)[39] = integrity_deviation_down;
        dataTable.fnGetData(aPos)[40] = integrity_period_down_value;
        dataTable.fnGetData(aPos)[41] = integrity_period_down_range;
        dataTable.fnGetData(aPos)[42] = integrity_deviation_up;
        dataTable.fnGetData(aPos)[43] = integrity_period_up_value;
        dataTable.fnGetData(aPos)[44] = integrity_period_up_range;
        dataTable.fnGetData(aPos)[45] = integrity_dep_value;
        dataTable.fnGetData(aPos)[46] = integrity_dep_unit;
        dataTable.fnGetData(aPos)[47] = integrity_dep_data_view_id;
        dataTable.fnGetData(aPos)[48] = integrity_dep_data_view_name;
        dataTable.fnGetData(aPos)[49] = (integrity_dep_value_from === '' && integrity_dep_value_from_data_view_id === '0') ? '' : integrity_dep_logical_operator_from;
        dataTable.fnGetData(aPos)[50] = integrity_dep_value_from;
        dataTable.fnGetData(aPos)[51] = integrity_dep_value_from_data_view_id;
        dataTable.fnGetData(aPos)[52] = integrity_dep_value_from_data_view_name;
        dataTable.fnGetData(aPos)[53] = integrity_dep_value_from_up_down;
        dataTable.fnGetData(aPos)[54] = integrity_dep_value_from_value;
        dataTable.fnGetData(aPos)[55] = integrity_dep_value_from_range;
        dataTable.fnGetData(aPos)[56] = (integrity_dep_value_till === '' && integrity_dep_value_till_data_view_id === '0') ? '' : integrity_dep_logical_operator_till;
        dataTable.fnGetData(aPos)[57] = integrity_dep_value_till;
        dataTable.fnGetData(aPos)[58] = integrity_dep_value_till_data_view_id;
        dataTable.fnGetData(aPos)[59] = integrity_dep_value_till_data_view_name;
        dataTable.fnGetData(aPos)[60] = integrity_dep_value_till_up_down;
        dataTable.fnGetData(aPos)[61] = integrity_dep_value_till_value;
        dataTable.fnGetData(aPos)[62] = integrity_dep_value_till_range;
        dataTable.fnGetData(aPos)[63] = integrity_dep_range_of_values;
        dataTable.fnGetData(aPos)[64] = integrity_mandatory_field;
        dataTable.fnGetData(aPos)[65] = integrity_valid_from;
        dataTable.fnGetData(aPos)[66] = integrity_valid_till;
        dataTable.fnGetData(aPos)[67] = integrity_value_from_unit_1;
        dataTable.fnGetData(aPos)[68] = integrity_value_from_unit_2;
        dataTable.fnGetData(aPos)[69] = integrity_value_till_unit_1;
        dataTable.fnGetData(aPos)[70] = integrity_value_till_unit_2;
		dataTable.fnGetData(aPos)[71] = integrity_data_view_field_name;

        dataTable.fnStandingRedraw();

    } else {

        dataTable.fnAddData([

            '-1',
            integrity_data_view_field_desc,
            integrity_description,
            integrity_type_name,
            integrity_type_id,
            integrity_integritytype,
            integrity_data_view_field_id,
            integrity_gender,
            integrity_custom_rule,
            integrity_age_from_data_view_id,
            integrity_age_from_data_view_name,
            integrity_age_from_plus_minus,
            integrity_age_from_value,
            integrity_age_from_range,
            integrity_age_till_data_view_id,
            integrity_age_till_data_view_name,
            integrity_age_till_plus_minus,
            integrity_age_till_value,
            integrity_age_till_range,
            integrity_value,
            integrity_completeness_frequency,
            integrity_optional,
            integrity_unit,
			(integrity_value_from === '' && integrity_value_from_data_view_id === '0') ? '' : integrity_logical_operator_from,
            integrity_value_from,
            integrity_value_from_data_view_id,
            integrity_value_from_data_view_name,
            integrity_value_from_up_down,
            integrity_value_from_value,
            integrity_value_from_range,
			(integrity_value_till === '' && integrity_value_till_data_view_id === '0') ? '' : integrity_logical_operator_till,
            integrity_value_till,
            integrity_value_till_data_view_id,
            integrity_value_till_data_view_name,
            integrity_value_till_up_down,
            integrity_value_till_value,
            integrity_value_till_range,
            integrity_range_of_values,
            integrity_deviation_percentage_value,
            integrity_deviation_down,
            integrity_period_down_value,
            integrity_period_down_range,
            integrity_deviation_up,
            integrity_period_up_value,
            integrity_period_up_range,
            integrity_dep_value,
            integrity_dep_unit,
            integrity_dep_data_view_id,
            integrity_dep_data_view_name,
			(integrity_dep_value_from === '' && integrity_dep_value_from_data_view_id === '0') ? '' : integrity_dep_logical_operator_from,
            integrity_dep_value_from,
            integrity_dep_value_from_data_view_id,
            integrity_dep_value_from_data_view_name,
            integrity_dep_value_from_up_down,
            integrity_dep_value_from_value,
            integrity_dep_value_from_range,
			(integrity_dep_value_till === '' && integrity_dep_value_till_data_view_id === '0') ? '' : integrity_dep_logical_operator_till,
            integrity_dep_value_till,
            integrity_dep_value_till_data_view_id,
            integrity_dep_value_till_data_view_name,
            integrity_dep_value_till_up_down,
            integrity_dep_value_till_value,
            integrity_dep_value_till_range,
            integrity_dep_range_of_values,
            integrity_mandatory_field,
			integrity_valid_from,
			integrity_valid_till,
			integrity_value_from_unit_1,
            integrity_value_from_unit_2,
            integrity_value_till_unit_1,
            integrity_value_till_unit_2,
			integrity_data_view_field_name]
        );

        dataTable.$('tr.selected-row').removeClass('selected-row');
        $('#table_data_collection_type_integrities').find('.tt-content-datatable').find('.tt-delete').addClass('disabled');
    }

    if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
        $("#content-detail").find('.tt-datatable-changes').val("changed");
        $("#content-detail").find('form').trigger('checkform.areYouSure');
    }

    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function saveOrAddNewMonitoringRestriction(element, form) {

    var selectedId = $(form).find('[name="selected_id"]').val();

    var control_type = $('#table_monitoring_restrictions_dialog').find('[name="control_type"]').val();
    var data_type = $('#table_monitoring_restrictions_dialog').find('[name="data_type"]').val();

    // Allgemeine Angaben
    var splitted_data_view_id = $(form).find('[name="monitoring_restriction_data_view_field"]').select2('val').split('|');
    var monitoring_restriction_data_view_id = splitted_data_view_id[0];
    var monitoring_restriction_data_view_name = splitted_data_view_id[1];
    var monitoring_restriction_description = $(form).find('[name="monitoring_restriction_description"]').val();

    // Darstellungszeitraum
    var monitoring_restriction_period_logical_operator_from = '';
    var monitoring_restriction_period_from_date = '';
    var monitoring_restriction_period_from_data_view_id = '';
    var monitoring_restriction_period_from_data_view_name = '';
    var monitoring_restriction_period_from_up_down = '';
    var monitoring_restriction_period_from_value = '';
    var monitoring_restriction_period_from_range = '';
    var monitoring_restriction_period_from_later = $(form).find('[name="monitoring_restriction_later_period_value_from"]')[0].checked ? '1' : '0';
    var select_logical_operator_from_period = $(form).find('[name="monitoring_restriction_period_logical_from"]').select2('data')[0];
    if (!utils.isUndefined(select_logical_operator_from_period) && select_logical_operator_from_period.text !== '') {
        monitoring_restriction_period_logical_operator_from = select_logical_operator_from_period.id;
        var select_value_from_period = $(form).find('[name="monitoring_restriction_period_value_from_field"]').select2('data')[0];
        if (!utils.isUndefined(select_value_from_period) && select_value_from_period.text !== '' && $(form).find('[name="monitoring_restriction_period_value_from_date_range"]').val() !== '') {
            monitoring_restriction_period_from_data_view_id = select_value_from_period.id.split('|')[0];
            monitoring_restriction_period_from_data_view_name = select_value_from_period.id.split('|')[1];

            monitoring_restriction_period_from_up_down = '+';
            if ($(form).find('[name="monitoring_restriction_period_value_from_plus_minus"]')[0].checked) {
                monitoring_restriction_period_from_up_down = '-';
            }
            monitoring_restriction_period_from_value = $(form).find('[name="monitoring_restriction_period_value_from_date_range"]').val();
            monitoring_restriction_period_from_range = utils.getValueFromInputWithDropDownField($(form).find('[name="monitoring_restriction_period_value_from_date_range"]'));
        } else {
            monitoring_restriction_period_from_date = utils.dateToString($(form).find('[name="monitoring_restriction_period_value_from"]').data('picker').getDate());
        }
    }

    var monitoring_restriction_period_logical_operator_till = '';
    var monitoring_restriction_period_till_date = '';
    var monitoring_restriction_period_till_data_view_id = '';
    var monitoring_restriction_period_till_data_view_name = '';
    var monitoring_restriction_period_till_up_down = '';
    var monitoring_restriction_period_till_value = '';
    var monitoring_restriction_period_till_range = '';
    var monitoring_restriction_period_till_later = $(form).find('[name="monitoring_restriction_later_period_value_till"]')[0].checked ? '1' : '0';
    var select_logical_operator_till_period = $(form).find('[name="monitoring_restriction_period_logical_till"]').select2('data')[0];
    if (!utils.isUndefined(select_logical_operator_till_period) && select_logical_operator_till_period.text !== '') {
        monitoring_restriction_period_logical_operator_till = select_logical_operator_till_period.id;
        var select_value_till_period = $(form).find('[name="monitoring_restriction_period_value_till_field"]').select2('data')[0];
        if (!utils.isUndefined(select_value_till_period) && select_value_till_period.text !== '' && $(form).find('[name="monitoring_restriction_period_value_till_date_range"]').val() !== '') {
            monitoring_restriction_period_till_data_view_id = select_value_till_period.id.split('|')[0];
            monitoring_restriction_period_till_data_view_name = select_value_till_period.id.split('|')[1];

            monitoring_restriction_period_till_up_down = '+';
            if ($(form).find('[name="monitoring_restriction_period_value_till_plus_minus"]')[0].checked) {
                monitoring_restriction_period_till_up_down = '-';
            }
            monitoring_restriction_period_till_value = $(form).find('[name="monitoring_restriction_period_value_till_date_range"]').val();
            monitoring_restriction_period_till_range = utils.getValueFromInputWithDropDownField($(form).find('[name="monitoring_restriction_period_value_till_date_range"]'));
        } else {
            monitoring_restriction_period_till_date = utils.dateToString($(form).find('[name="monitoring_restriction_period_value_till"]').data('picker').getDate());
        }
    }

    // Feld abhängige Angaben
    var monitoring_restriction_value = '';
    var monitoring_restriction_unit = '';
    var monitoring_restriction_range_of_values = '';
    var monitoring_restriction_logical_operator_from = '';
    var monitoring_restriction_value_from_string = '';
    var monitoring_restriction_value_from_decimal = '';
    var monitoring_restriction_value_from_date = '';
    var monitoring_restriction_value_from_data_view_id = '';
    var monitoring_restriction_value_from_data_view_name = '';
    var monitoring_restriction_value_from_up_down = '';
    var monitoring_restriction_value_from_value = '';
    var monitoring_restriction_value_from_range = '';
    var monitoring_restriction_logical_operator_till = '';
    var monitoring_restriction_value_till_decimal = '';
    var monitoring_restriction_value_till_date = '';
    var monitoring_restriction_value_till_data_view_id = '';
    var monitoring_restriction_value_till_data_view_name = '';
    var monitoring_restriction_value_till_up_down = '';
    var monitoring_restriction_value_till_value = '';
    var monitoring_restriction_value_till_range = '';
    var monitoring_restriction_value_from_later = '0';
    var monitoring_restriction_value_till_later = '0';

    // Wert
    if ($(form).find('[name="monitoring_restriction_existing_value"]')[0].checked) {

        monitoring_restriction_value = 'existing';

    } else if ($(form).find('[name="monitoring_restriction_not_existing_value"]')[0].checked) {

        monitoring_restriction_value = 'not_existing';

    } else {

        if (control_type === 'input' || control_type === 'input_with_additionalfield') {

            if (data_type === 'integer' || data_type === 'decimal') {

                // Wert von
                var select_logical_operator_from = $(form).find('[name="monitoring_restriction_field_logical_from_numeric_field"]').select2('data')[0];
                if (!utils.isUndefined(select_logical_operator_from) && select_logical_operator_from.text !== '') {
                    monitoring_restriction_logical_operator_from = select_logical_operator_from.id;
                }
                monitoring_restriction_value_from_decimal = utils.stringToNumber($(form).find('[name="monitoring_restriction_field_value_from"]').val());
                monitoring_restriction_unit = utils.getValueFromInputWithDropDownField($(form).find('[name="monitoring_restriction_field_value_from"]'));
                var select_value_from_field = $(form).find('[name="monitoring_restriction_field_value_from_field"]').select2('data')[0];
                if (!utils.isUndefined(select_value_from_field) && select_value_from_field.text !== '') {
                    monitoring_restriction_value_from_data_view_id = select_value_from_field.id.split('|')[0];
                    monitoring_restriction_value_from_data_view_name = select_value_from_field.id.split('|')[1];
                }
                monitoring_restriction_value_from_later = $(form).find('[name="monitoring_restriction_later_field_value_from"]')[0].checked ? '1' : '0';

                // Wert bis
                var select_logical_operator_till = $(form).find('[name="monitoring_restriction_field_logical_till_numeric_field"]').select2('data')[0];
                if (!utils.isUndefined(select_logical_operator_till) && select_logical_operator_till.text !== '') {
                    monitoring_restriction_logical_operator_till = select_logical_operator_till.id;
                }
                monitoring_restriction_value_till_decimal = utils.stringToNumber($(form).find('[name="monitoring_restriction_field_value_till"]').val());
                var select_value_till_field = $(form).find('[name="monitoring_restriction_field_value_till_field"]').select2('data')[0];
                if (!utils.isUndefined(select_value_till_field) && select_value_till_field.text !== '') {
                    monitoring_restriction_value_till_data_view_id = select_value_till_field.id.split('|')[0];
                    monitoring_restriction_value_till_data_view_name = select_value_till_field.id.split('|')[1];
                }
                monitoring_restriction_value_till_later = $(form).find('[name="monitoring_restriction_later_field_value_till"]')[0].checked ? '1' : '0';

            } else {

                var select_logical_operator = $(form).find('[name="monitoring_restriction_field_logical_text_field"]').select2('data')[0];
                if (!utils.isUndefined(select_logical_operator) && select_logical_operator.text !== '') {
                    monitoring_restriction_logical_operator_from = select_logical_operator.id;
                }
                monitoring_restriction_value_from_string = $(form).find('[name="monitoring_restriction_field_input"]').val();
                monitoring_restriction_value_from_later = $(form).find('[name="monitoring_restriction_later_field_input"]')[0].checked ? '1' : '0';

            }

        } else if (control_type === 'date_panel' || control_type === 'date_range') {

            // Wert von
            var select_logical_operator_from = $(form).find('[name="monitoring_restriction_field_logical_from_date_field"]').select2('data')[0];
            if (!utils.isUndefined(select_logical_operator_from) && select_logical_operator_from.text !== '') {
                monitoring_restriction_logical_operator_from = select_logical_operator_from.id;
                var select_value_from_date_field = $(form).find('[name="monitoring_restriction_field_value_from_date_field"]').select2('data')[0];
                if (!utils.isUndefined(select_value_from_date_field) && select_value_from_date_field.text !== '' && $(form).find('[name="monitoring_restriction_field_value_from_date_range"]').val() !== '') {
                    monitoring_restriction_value_from_data_view_id = select_value_from_date_field.id.split('|')[0];
                    monitoring_restriction_value_from_data_view_name = select_value_from_date_field.id.split('|')[1];

                    monitoring_restriction_value_from_up_down = '+';
                    if ($(form).find('[name="monitoring_restriction_field_value_from_plus_minus"]')[0].checked) {
                        monitoring_restriction_value_from_up_down = '-';
                    }
                    monitoring_restriction_value_from_value = $(form).find('[name="monitoring_restriction_field_value_from_date_range"]').val();
                    monitoring_restriction_value_from_range = utils.getValueFromInputWithDropDownField($(form).find('[name="monitoring_restriction_field_value_from_date_range"]'));
                } else {
                    monitoring_restriction_value_from_date = utils.dateToString($(form).find('[name="monitoring_restriction_field_value_from_date"]').data('picker').getDate());
                }
                monitoring_restriction_value_from_later = $(form).find('[name="monitoring_restriction_later_from_date"]')[0].checked ? '1' : '0';
            }

            // Wert bis
            var select_logical_operator_till = $(form).find('[name="monitoring_restriction_field_logical_till_date_field"]').select2('data')[0];
            if (!utils.isUndefined(select_logical_operator_till) && select_logical_operator_till.text !== '') {
                monitoring_restriction_logical_operator_till = select_logical_operator_till.id;
                var select_value_till_date_field = $(form).find('[name="monitoring_restriction_field_value_till_date_field"]').select2('data')[0];
                if (!utils.isUndefined(select_value_till_date_field) && select_value_till_date_field.text !== '' && $(form).find('[name="monitoring_restriction_field_value_till_date_range"]').val() !== '') {
                    monitoring_restriction_value_till_data_view_id = select_value_till_date_field.id.split('|')[0];
                    monitoring_restriction_value_till_data_view_name = select_value_till_date_field.id.split('|')[1];

                    monitoring_restriction_value_till_up_down = '+';
                    if ($(form).find('[name="monitoring_restriction_field_value_till_plus_minus"]')[0].checked) {
                        monitoring_restriction_value_till_up_down = '-';
                    }
                    monitoring_restriction_value_till_value = $(form).find('[name="monitoring_restriction_field_value_till_date_range"]').val();
                    monitoring_restriction_value_till_range = utils.getValueFromInputWithDropDownField($(form).find('[name="monitoring_restriction_field_value_till_date_range"]'));
                } else {
                    monitoring_restriction_value_till_date = utils.dateToString($(form).find('[name="monitoring_restriction_field_value_till_date"]').data('picker').getDate());
                }
                monitoring_restriction_value_till_later = $(form).find('[name="monitoring_restriction_later_till_date"]')[0].checked ? '1' : '0';
            }

        } else if (control_type !== 'checkbox') {

            if ($(form).find('[name="monitoring_restriction_not_field_list"]')[0].checked) {
                monitoring_restriction_value = 'not';
            }
            monitoring_restriction_value_from_later = $(form).find('[name="monitoring_restriction_later_field_list"]')[0].checked ? '1' : '0';

            jQuery.each($(form).find('[name="monitoring_restriction_field_list"]').select2('data'), function (i, val) {
                if (monitoring_restriction_range_of_values !== '') {
                    monitoring_restriction_range_of_values += '$';
                }
                monitoring_restriction_range_of_values += val.id;
            });

        }
    }

    if (form.id === "table_monitoring_types_restriction_form") {
        var controlElement = $('#dd_monitoring_restrictions').find('[data-id="' + selectedId + '"]');

        // Allgemeine Angaben
        controlElement.data('rangeOfValues', monitoring_restriction_range_of_values);
        controlElement.data('unit', monitoring_restriction_unit);

        // Wert von
        controlElement.data('valueFromLogicalOperator', monitoring_restriction_logical_operator_from);
        controlElement.data('valueFromDecimal', monitoring_restriction_value_from_decimal);
        controlElement.data('valueFromString', monitoring_restriction_value_from_string);
        controlElement.data('valueFromDate', monitoring_restriction_value_from_date);
        controlElement.data('valueFromViewId', monitoring_restriction_value_from_data_view_id);
        controlElement.data('valueFromViewName', monitoring_restriction_value_from_data_view_name);
        controlElement.data('valueFromUpDown', monitoring_restriction_value_from_up_down);
        controlElement.data('valueFromValue', monitoring_restriction_value_from_value);
        controlElement.data('valueFromRange', monitoring_restriction_value_from_range);

        // Wert bis
        controlElement.data('valueTillLogicalOperator', monitoring_restriction_logical_operator_till);
        controlElement.data('valueTillDecimal', monitoring_restriction_value_till_decimal);
        controlElement.data('valueTillDate', monitoring_restriction_value_till_date);
        controlElement.data('valueTillViewId', monitoring_restriction_value_till_data_view_id);
        controlElement.data('valueTillViewName', monitoring_restriction_value_till_data_view_name);
        controlElement.data('valueTillUpDown', monitoring_restriction_value_till_up_down);
        controlElement.data('valueTillValue', monitoring_restriction_value_till_value);
        controlElement.data('valueTillRange', monitoring_restriction_value_till_range);

        // Darstellungszeitraum
        controlElement.data('periodFromLogicalOperator', monitoring_restriction_period_logical_operator_from);
        controlElement.data('periodFromDate', monitoring_restriction_period_from_date);
        controlElement.data('periodFromViewId', monitoring_restriction_period_from_data_view_id);
        controlElement.data('periodFromViewName', monitoring_restriction_period_from_data_view_name);
        controlElement.data('periodFromUpDown', monitoring_restriction_period_from_up_down);
        controlElement.data('periodFromValue', monitoring_restriction_period_from_value);
        controlElement.data('periodFromRange', monitoring_restriction_period_from_range);
        controlElement.data('periodTillLogicalOperator', monitoring_restriction_period_logical_operator_till);
        controlElement.data('periodTillDate', monitoring_restriction_period_till_date);
        controlElement.data('periodTillViewId', monitoring_restriction_period_till_data_view_id);
        controlElement.data('periodTillViewName', monitoring_restriction_period_till_data_view_name);
        controlElement.data('periodTillUpDown', monitoring_restriction_period_till_up_down);
        controlElement.data('periodTillValue', monitoring_restriction_period_till_value);
        controlElement.data('periodTillRange', monitoring_restriction_period_till_range);

        controlElement.find('.tt-monitoring-restriction-editable').removeClass('txt-color-crimson').addClass('txt-color-green');
    } else {
        if (selectedId !== '') {

            var controlElement = $('#monitoring_restrictions_table').find('[data-id="' + selectedId + '"]');

            controlElement[0].textContent = monitoring_restriction_description;

            // Allgemeine Angaben
            controlElement.data('viewId', monitoring_restriction_data_view_id);
            controlElement.data('viewName', monitoring_restriction_data_view_name);
            controlElement.data('description', monitoring_restriction_description);
            controlElement.data('value', monitoring_restriction_value);
            controlElement.data('rangeOfValues', monitoring_restriction_range_of_values);
            controlElement.data('unit', monitoring_restriction_unit);

            // Wert von
            controlElement.data('valueFromLogicalOperator', monitoring_restriction_logical_operator_from);
            controlElement.data('valueFromDecimal', monitoring_restriction_value_from_decimal);
            controlElement.data('valueFromString', monitoring_restriction_value_from_string);
            controlElement.data('valueFromDate', monitoring_restriction_value_from_date);
            controlElement.data('valueFromViewId', monitoring_restriction_value_from_data_view_id);
            controlElement.data('valueFromViewName', monitoring_restriction_value_from_data_view_name);
            controlElement.data('valueFromUpDown', monitoring_restriction_value_from_up_down);
            controlElement.data('valueFromValue', monitoring_restriction_value_from_value);
            controlElement.data('valueFromRange', monitoring_restriction_value_from_range);
            controlElement.data('valueFromLater', monitoring_restriction_value_from_later);

            // Wert bis
            controlElement.data('valueTillLogicalOperator', monitoring_restriction_logical_operator_till);
            controlElement.data('valueTillDecimal', monitoring_restriction_value_till_decimal);
            controlElement.data('valueTillDate', monitoring_restriction_value_till_date);
            controlElement.data('valueTillViewId', monitoring_restriction_value_till_data_view_id);
            controlElement.data('valueTillViewName', monitoring_restriction_value_till_data_view_name);
            controlElement.data('valueTillUpDown', monitoring_restriction_value_till_up_down);
            controlElement.data('valueTillValue', monitoring_restriction_value_till_value);
            controlElement.data('valueTillRange', monitoring_restriction_value_till_range);
            controlElement.data('valueTillLater', monitoring_restriction_value_till_later);

            // Darstellungszeitraum
            controlElement.data('periodFromLogicalOperator', monitoring_restriction_period_logical_operator_from);
            controlElement.data('periodFromDate', monitoring_restriction_period_from_date);
            controlElement.data('periodFromViewId', monitoring_restriction_period_from_data_view_id);
            controlElement.data('periodFromViewName', monitoring_restriction_period_from_data_view_name);
            controlElement.data('periodFromUpDown', monitoring_restriction_period_from_up_down);
            controlElement.data('periodFromValue', monitoring_restriction_period_from_value);
            controlElement.data('periodFromRange', monitoring_restriction_period_from_range);
            controlElement.data('periodFromLater', monitoring_restriction_period_from_later);
            controlElement.data('periodTillLogicalOperator', monitoring_restriction_period_logical_operator_till);
            controlElement.data('periodTillDate', monitoring_restriction_period_till_date);
            controlElement.data('periodTillViewId', monitoring_restriction_period_till_data_view_id);
            controlElement.data('periodTillViewName', monitoring_restriction_period_till_data_view_name);
            controlElement.data('periodTillUpDown', monitoring_restriction_period_till_up_down);
            controlElement.data('periodTillValue', monitoring_restriction_period_till_value);
            controlElement.data('periodTillRange', monitoring_restriction_period_till_range);
            controlElement.data('periodTillLater', monitoring_restriction_period_till_later);

        } else {

            var counter = -1;
            jQuery.each($('#monitoring_restrictions_table').find('.dd3-content'), function (i, val) {
                if ($(val).data('id') < 0) {
                    counter = counter - 1;
                }
            });

            var html = '';
            var list = $('#monitoring_restrictions_table').find('.dd-list')[0];

            html += '<li class="dd-item dd3-item">';
            html += '   <div class="dd-handle dd-dialog-handle dd3-handle">';
            html += '   </div>';
            html += '   <div class="dd3-content dd-dialog-content tt-monitoring-dd3-content" data-id="' + counter + '" data-view-id="' + monitoring_restriction_data_view_id + '" data-view-name="' + monitoring_restriction_data_view_name + '" data-description="' + monitoring_restriction_description + '" data-value="' + monitoring_restriction_value + '" data-range-of-values="' + monitoring_restriction_range_of_values + '" data-unit="' + monitoring_restriction_unit
                + '" data-value-from-logical-operator="' + monitoring_restriction_logical_operator_from + '" data-value-from-string="' + monitoring_restriction_value_from_string + '" data-value-from-decimal="' + monitoring_restriction_value_from_decimal + '" data-value-from-date="' + monitoring_restriction_value_from_date + '" data-value-from-view-id="' + monitoring_restriction_value_from_data_view_id + '" data-value-from-view-name="' + monitoring_restriction_value_from_data_view_name
                + '" data-value-from-up-down="' + monitoring_restriction_value_from_up_down + '" data-value-from-value="' + monitoring_restriction_value_from_value + '" data-value-from-range="' + monitoring_restriction_value_from_range + '" data-value-till-logical-operator="' + monitoring_restriction_logical_operator_till + '" data-value-till-decimal="' + monitoring_restriction_value_till_decimal + '" data-value-till-date="' + monitoring_restriction_value_till_date
                + '" data-value-till-view-id="' + monitoring_restriction_value_till_data_view_id + '" data-value-till-view-name="' + monitoring_restriction_value_till_data_view_name + '" data-value-till-up-down="' + monitoring_restriction_value_till_up_down + '" data-value-till-value="' + monitoring_restriction_value_till_value + '" data-value-till-range="' + monitoring_restriction_value_till_range
                + '" data-period-from-logical-operator="' + monitoring_restriction_period_logical_operator_from + '" data-period-from-date="' + monitoring_restriction_period_from_date + '" data-period-till-logical-operator="' + monitoring_restriction_period_logical_operator_till + '" data-period-till-date="' + monitoring_restriction_period_till_date
                + '" data-value-from-later="' + monitoring_restriction_value_from_later + '" data-value-till-later="' + monitoring_restriction_value_till_later + '" data-period-from-later="' + monitoring_restriction_period_from_later + '" data-period-till-later="' + monitoring_restriction_period_till_later
                + '" data-period-from-view-id="' + monitoring_restriction_period_from_data_view_id + '" data-period-from-view-name="' + monitoring_restriction_period_from_data_view_name + '" data-period-from-up-down="' + monitoring_restriction_period_from_up_down + '" data-period-from-value="' + monitoring_restriction_period_from_value + '" data-period-from-range="' + monitoring_restriction_period_from_range
                + '" data-period-till-view-id="' + monitoring_restriction_period_till_data_view_id + '" data-period-till-view-name="' + monitoring_restriction_period_till_data_view_name + '" data-period-till-up-down="' + monitoring_restriction_period_till_up_down + '" data-period-till-value="' + monitoring_restriction_period_till_value + '" data-period-till-range="' + monitoring_restriction_period_till_range
                + '" data-is-deleted="false">';
            html += '       <label class="dd3-content-label">' + monitoring_restriction_description + '</label>';
            html += '   </div>';
            html += '</li>';

            $(html).appendTo(list);

        }

        $('#monitoring_restrictions_table').parents('.tt-content-datatable').find('.tt-delete-monitoring-nestable').addClass('disabled');
        if ($('#monitoring_restrictions_table').parents('.tt-content-detail').find('.tt-datatable-changes').val() !== 'changed') {
            $('#monitoring_restrictions_table').parents('.tt-content-detail').find('.tt-datatable-changes').val('changed');
            $('#monitoring_restrictions_table').parents('.tt-content-detail').find('form').trigger('checkform.areYouSure');
        }

    }
    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function saveOrAddNewDataViewDisplayRestriction(element, form, newDisplayRestriction) {

	var display_restriction_data_collection_type_id = $(form).find('[name="display_restriction_data_collection_type"]').select2('data')[0].id;
	var display_restriction_data_collection_type_name = $(form).find('[name="display_restriction_data_collection_type"]').select2('data')[0].text;
	var display_restriction_from_date = '';
	var from_date = $(form).find('[name="display_restriction_from_date"]').data('picker').getDate();
	if ($(form).find('[name="display_restriction_from_date"]').val() !== '' && !utils.isUndefined(from_date)) {
		display_restriction_from_date = utils.dateToString(from_date);
    }
	var display_restriction_till_date = '';
	var till_date = $(form).find('[name="display_restriction_till_date"]').data('picker').getDate();
	if ($(form).find('[name="display_restriction_till_date"]').val() !== '' && !utils.isUndefined(till_date)) {
		display_restriction_till_date = utils.dateToString(till_date);
	}

	var display_restriction_repetition_column_field = $(form).find('[name="display_restriction_repetition_column"]').select2('data')[0];
	var display_restriction_repetition_column = '';
	if (!utils.isUndefined(display_restriction_repetition_column_field) && display_restriction_repetition_column_field.text !== '' && $(form).find('[name="display_restriction_repetition_column"]').val() !== '') {
		display_restriction_repetition_column = display_restriction_repetition_column_field.id;
	}

	if (newDisplayRestriction) {

		var table = $("#table_data_views_display_restrictions");
		var dialog = $("#table_data_views_display_restrictions_dialog");

		table.dataTable().fnAddData([

			'',
			display_restriction_data_collection_type_name,
			display_restriction_from_date,
			display_restriction_till_date,
			display_restriction_data_collection_type_id,
            display_restriction_repetition_column,
            '']
		);

		table.dataTable().$('tr.selected-row').removeClass('selected-row');
		dialog.find('.tt-content-datatable').find('.tt-delete').addClass('disabled');

		element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();

	} else {

		var dataTable = $(form).parents('.modal-content').find('.tt-datatable-dialog').dataTable();
		var tr = dataTable.$('tr.selected-row');
		var aPos = dataTable.fnGetPosition(tr[0]);

		// Sichtbare Spalten
		dataTable.fnGetNodes(aPos).children[0].textContent = display_restriction_data_collection_type_name;
		dataTable.fnGetData(aPos)[1] = display_restriction_data_collection_type_name;

		if (display_restriction_from_date === '') {
			dataTable.fnGetNodes(aPos).children[1].textContent = '';
        } else {
			dataTable.fnGetNodes(aPos).children[1].textContent = utils.dateToLocaleString(display_restriction_from_date);
        }
		dataTable.fnGetData(aPos)[2] = display_restriction_from_date;

		if (display_restriction_till_date === '') {
			dataTable.fnGetNodes(aPos).children[2].textContent = '';
		} else {
			dataTable.fnGetNodes(aPos).children[2].textContent = utils.dateToLocaleString(display_restriction_till_date);
		}
		dataTable.fnGetData(aPos)[3] = display_restriction_till_date;

		// Nicht sichtbare Spalten
		dataTable.fnGetData(aPos)[4] = display_restriction_data_collection_type_id;
		dataTable.fnGetData(aPos)[5] = display_restriction_repetition_column;

		dataTable.fnStandingRedraw();

		$(form).parents('.modal-content').find('.tt-cancel-value-modal').click();
	}

}

function setActionForSavingAgreement(form, action) {
    var agreement_id = '0';
    if ($(form).find('.tt-selected-id').val() !== '') {
        agreement_id = $(form).find('.tt-selected-id').val();
    }

    action = action.replace('agreement/0', 'agreement/' + agreement_id);
    action = action.replace('patient/0', 'patient/' + views.getPatientId());

    return action;
}

function checkForTransferDataViewFields(url) {

	return $.Deferred(function(defer) {
		ajax.ajaxCallDeferred(url, 'GET', null, false)
			.done(function (data) {
				if (ajax.ajaxSucceeded(data)) {
                    if (data.length > 0) {
						utils.setHtmlData($('#table_patient_examination_transfer_dialog').find('.content-dialog'), data, true);
						addDynamicRules($('#table_patient_examination_transfer_form'));
						defer.resolve(false);
					} else {
						defer.resolve(true);
                    }
				} else {
					defer.reject();
				}
			})
			.fail(function () {
				defer.reject();
			});
	}).promise();
}

function saveExamination(element, form, transferData, tabArray) {

    var newExaminationDate = $(form).find('[name="exam_date"]').data('picker').getDate();
    var newExaminationTime = $(form).find('[name="exam_time"]').val().split(':');

    if (newExaminationTime.length > 0 && newExaminationTime[0] !== '') {
        newExaminationDate = moment(newExaminationDate).add(parseInt(newExaminationTime[0]), 'hours').toDate();
    }
    if (newExaminationTime.length > 1 && newExaminationTime[1] !== '') {
        newExaminationDate = moment(newExaminationDate).add(parseInt(newExaminationTime[1]), 'minutes').toDate();
    }

    var table = $('#table_patient_examination').DataTable();
    var doCancelViews = true;
    if ($('#table_patient_examination').find('tr[id="0"]').length) {
        doCancelViews = false;
        table.row($('#table_patient_examination').find('tr[id="0"]')).remove();
    }
    var data = {id: 0, examinationdate: newExaminationDate, facility_id: views.getFacilityId(), examinationdate_format: utils.getExaminationDateFormat()};
    $('#table_patient_examination').find('thead th').each(function (i) {
        if (!utils.isUndefined($(this).data().columnName)) {
            var columnName = $(this).data().columnName;
            data[columnName] = '';
        }
    });
    data['locked_patient'] = null;

    table.row.add(data).draw();

    setExaminationSelectionList();
    setCourseContentVisible(true);

    $('#table_patient_examination').DataTable().page.jumpToData(0, 0);
    if (doCancelViews) {
        changes.cancelViews(false, true);
    } else {
        $('.tt-nav-content-article').find('.tt-selected-examination-date').val(utils.dateToTimeString(newExaminationDate));
        changes.setSelectedExamination(false, 0);
    }
    changes.tableSingleClick($('#table_patient_examination').find('tr[id="0"]')).done(function() {

		setQuestionnaireContentVisible(Object.keys(views.getQuestionnaires()).length > 0);

        element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
        if (!utils.isUndefined(transferData)) {
			$('.tt-nav-content-article').find('.tt-selected-examination-id').data('transfer_examination_data', transferData);
		}
		if (!utils.isUndefined(tabArray)) {
			$('.tt-nav-content-article').find('.tt-selected-examination-id').data('tab_transfer_data', tabArray);
		}
        if ($('[href="#content-detail-course"]').length) {
            $('[href="#content-detail-course"]').click();
        }
    });
}

function changeExamination(element, form, data) {

    if (data.length > 0) {

        var text = '';
        for (var i = 0; i < data.length; i++) {
            var dataText = data[i].split('$');
            text += "<span class='txt-color-orangeDark'><strong>" + dataText[0] + ':</strong></span> ' + views.getIntegrityText(dataText[1].split('|'))[1].trim().substring(5) + '<br>';
        }

        $.SmartMessageBox({
            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_exam', {"examination": "<span class='txt-color-orangeDark'><strong>" + utils.dateToLocaleTimeString(views.getExaminationDate()) + "</strong></span>"}),
            content: Lang.get('tripletrax.change_examination_possible_desc') + '<br><br>' + text,
            buttons: '[' + Lang.get('tripletrax.ok') + ']'
        }, function (ButtonPressed) {
        });

        element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
    } else {
        var examDate = getExaminationDateFromForm(form).split(' ');
        ajax.ajaxCallDeferred("doc/patient/patient/examination/" + views.getExaminationId() + "/facility/" + views.getFacilityId() + "/model/" + views.getModelId() + "/patient/" + views.getPatientId(), "POST", 'exam_date=' + examDate[0] + '&exam_time=' + examDate[1], false).done(function(data) {

            if (ajax.ajaxSucceeded(data)) {

                setExaminationList(false).done(function () {
                    var examinationId = $('.tt-nav-content-article').find('.tt-selected-examination-id').val();
                    var course = utils.getCourse();
                    var questionnaire = utils.getQuestionnaire();

                    $('#table_patient_examination').DataTable().page.jumpToData(parseInt(examinationId), 0);
                    $('#table_patient_examination').find('tr[id="' + examinationId + '"]').addClass('selected-row');
                    $('.tt-nav-content-article').find('.tt-selected-examination-date').val(examDate[0] + ' ' + examDate[1]);

					course.find('.tt-select-examination-dropdown').find('li').removeClass('active');
					course.find('.tt-select-examination-dropdown').find('li[data-examination-id="' + examinationId + '"]').addClass('active');
					course.find('.tt-select-examination').find('span').html(utils.getExaminationDateString(moment(examDate[0] + ' ' + examDate[1])._d, utils.getExaminationDateFormat()) + '&nbsp;');

					if (!utils.isUndefined(questionnaire)) {
						questionnaire.find('.tt-select-examination-dropdown').find('li').removeClass('active');
						questionnaire.find('.tt-select-examination-dropdown').find('li[data-examination-id="' + examinationId + '"]').addClass('active');
						questionnaire.find('.tt-select-examination').find('span').html(utils.getExaminationDateString(moment(examDate[0] + ' ' + examDate[1])._d, utils.getExaminationDateFormat()) + '&nbsp;');
					}

                    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
                });
            }
        });
    }
}

function setExaminationList(resetExamination) {
    return $.Deferred(function(defer) {

        patients.loadExaminationList(views.getPatientId(), views.getPatientIsActive(), views.getPatientIsLocked(), $('#table_patient_examination').dataTable().data().tableUrl)
            .done(function (data) {
                if (ajax.ajaxSucceeded(data)) {
                    var examinationData = patients.getExaminationList(data);
                    $('#table_patient_examination').dataTable().api().clear().rows.add(examinationData).draw();

                    if (resetExamination) {
                        utils.getCourse().find('.tt-doc-pane.data-loaded').removeClass('data-loaded');
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', []);
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data', '');
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('previous_examination_data', '');
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_facility_id', '');
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_locked', null);
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').val('');
                        $('.tt-nav-content-article').find('.tt-selected-examination-date').val('');

                        $('#table_patient_examination').parents('.tt-content-datatable').find('.tt-delete').addClass('disabled');
                    }

                    setExaminationSelectionList();

                    // "Neue Untersuchung"-Button nur aktiv setzen, wenn das Recht für die ausgewählte Datenerhebungsart dazu besteht
                    if (!$('#content-detail-patientlist').find('.tt-create-examination').hasClass('no-rights') && !views.getPatientIsLocked()) {
                        if (views.getModelId() > 0) {
                            if (views.getModelId() + '-create_examination-all_rights' in utils.GLOBALS.rights && utils.GLOBALS.rights[views.getModelId() + '-create_examination-all_rights'] == 1) {
                                $('#content-detail-patientlist').find('.tt-create-examination').removeClass('disabled');
                                $('#content-detail-patientlist').find('.tt-create-examination').removeAttr('disabled');
                            } else {
                                $('#content-detail-patientlist').find('.tt-create-examination').addClass('disabled');
                                $('#content-detail-patientlist').find('.tt-create-examination').prop('disabled', 'disabled');
                            }
                        }
                    } else {
                        $('#content-detail-patientlist').find('.tt-create-examination').addClass('disabled');
                        $('#content-detail-patientlist').find('.tt-create-examination').prop('disabled', 'disabled');
                    }

                    // Wenn eine Untersuchung direkt ausgewählt werden soll, auf den ersten Tab der Untersuchung springen
                    if (!utils.isUndefined(utils.GLOBALS.examinationToShow) && utils.GLOBALS.examinationToShow !== '') {

                        $('#table_patient_examination').DataTable().page.jumpToData(utils.GLOBALS.examinationToShow, 0);
                        $('#table_patient_examination').find('tr[id="' + utils.GLOBALS.examinationToShow + '"]').addClass('selected-row');
                        $('#table_patient_examination').find('tr[id="' + utils.GLOBALS.examinationToShow + '"]').find('td')[1].click();
                        $('#table_patient_examination').find('tr[id="' + utils.GLOBALS.examinationToShow + '"]').find('td')[1].click();

                        utils.updateGlobals('examinationToShow', null);
                    }

                    defer.resolve();
                } else {
                    defer.reject();
                }
            })
            .fail(function() {
                defer.reject();
            });
    }).promise();
}

function setExaminationSelectionList() {

    var examinationData = $('#table_patient_examination').dataTable().api().rows({1: 'desc'}).data();

    var course = utils.getCourse();
    var questionnaire = utils.getQuestionnaire();
	course.find('.tt-select-examination-dropdown').empty();
	if (!utils.isUndefined(questionnaire)) {
		questionnaire.find('.tt-select-examination-dropdown').empty();
	}
    jQuery.each(examinationData, function(i, val) {

		if ($('[name="limit_examination_list_completeness_selections"]').is(':checked')) {

			var selection = $('[name="show_patients_incomplete_course_data_year"]').select2('val');
			if (selection === 'past_year' && moment(val.examinationdate) < moment().subtract(1, 'years')) {
				return true;
			} else if (selection === 'current_year' && moment(val.examinationdate).year() !== moment().year()) {
				return true;
			} else if (selection === 'last_year' && moment(val.examinationdate).year() !== moment().year() - 1) {
				return true;
			}
		}

        var html =
            '<li data-examination-id="' + val.id + '">' +
            '<a>' + utils.getExaminationDateString(val.examinationdate, val.examinationdate_format) + '</a>' +
            '</li>';
		course.find('.tt-select-examination-dropdown').append(html);
		if (!utils.isUndefined(questionnaire)) {
			questionnaire.find('.tt-select-examination-dropdown').append(html);
		}
    });
}

function setQuestionnaireSelectionList() {

	var questionnaires = views.getQuestionnaires();
	var previousValue = $('.tt-questionnaire-project').val();

	if (Object.keys(questionnaires).length > 0) {

		var setPreviousValue = false;
		var data = [];
		data.push({ id: "0", text: trans('tripletrax.all_questionnaires') });

		for (var id in questionnaires) {
			if (id == previousValue) {
				setPreviousValue = true;
			}
			data.push({ id: id, text: questionnaires[id]['model'] });
		}

		reinitializeSelect2($('.tt-questionnaire-project-group'), 'input-sm tt-select2 no-padding tt-questionnaire-project tt-combo-multiselect', 'data-allow-clear="false"', data, false);

		if (!setPreviousValue) {
			previousValue = "0";
		}
		$('.tt-questionnaire-project').val(previousValue).trigger('change.select2');
	}
}

function setReportSelectionList() {

	var questionnaires = views.getQuestionnaires();
	var previousValue = $('.tt-select-patient-report').val();
	var reports = {};
	if ($('.tt-content-detail').find('[name="reports"]').length > 0) {
        reports = $('.tt-content-detail').find('[name="reports"]').val();
        reports = $.parseJSON(reports);
    }

	if (Object.keys(questionnaires).length > 0) {

		var setPreviousValue = false;
		var data = [];

		if (reports.length > 0) {
			for (var id in reports) {
				if ('doc/patient/reports/' + reports[id]['name'] === previousValue) {
					setPreviousValue = true;
				}
				data.push({ id : 'doc/patient/reports/' + reports[id]['name'], text: trans('tripletrax.' + reports[id]['name']) });
			}
		}

		for (var id in questionnaires) {
		    var dataViews = '';
			if ('doc/patient/reports/questionnaires/' + id === previousValue) {
				setPreviousValue = true;
			}
			data.push({ id: 'doc/patient/reports/questionnaires/' + id, text: questionnaires[id]['model'] });
		}

		reinitializeSelect2($('.tt-select-patient-report-group'), 'input-sm tt-select2 no-padding tt-select-patient-report', 'data-allow-clear="false"', data, false);

		if (!setPreviousValue) {
			previousValue = "0";
		}
		$('.tt-select-patient-report').val(previousValue).trigger('change.select2');
	}
}

function setMasterContentVisible(state) {

	var master = utils.getMaster();
    if (state) {
		master.find('.tt-no-selection').addClass('hide');
		master.find('.tt-content-master').removeClass('hide');
        $('[href="#content-detail-master"]').removeAttr('disabled').removeClass('disabled');
    } else {
		master.find('.tt-no-selection').removeClass('hide');
        if (views.getModelId() > 0) {
			master.find('.tt-no-selection').find('.title-doc').text(trans('tripletrax.select_patient'));
        } else {
			master.find('.tt-no-selection').find('.title-doc').text(trans('tripletrax.select_model'));
        }
		master.find('.tt-content-master').addClass('hide');
        $('[href="#content-detail-master"]').attr('disabled', 'disabled').addClass('disabled');
    }
}

function setCourseContentVisible(state) {

	var course = utils.getCourse();
    if (state) {
		course.find('.tt-no-selection').addClass('hide');
		course.find('.tt-content-course').removeClass('hide');
        $('[href="#content-detail-course"]').removeAttr('disabled').removeClass('disabled');
    } else {
		course.find('.tt-no-selection').removeClass('hide');
		course.find('.tt-content-course').addClass('hide');
        $('[href="#content-detail-course"]').attr('disabled', 'disabled').addClass('disabled');
    }
}

function setQuestionnaireContentVisible(state) {

	var questionnaire = utils.getQuestionnaire();
	if (!utils.isUndefined(questionnaire)) {
		if (state) {
			questionnaire.find('.tt-no-selection').addClass('hide');
			questionnaire.find('.tt-content-questionnaires').removeClass('hide');
			$('[href="#content-detail-questionnaires"]').removeAttr('disabled').removeClass('disabled');

			var dataTable = $('#table_patient_examination').dataTable();
			var aPos = dataTable.fnGetPosition($('#table_patient_examination').find('.selected-row')[0]);
			var aData = dataTable.fnGetData(aPos);
			var showTab = true;

			$.each(questionnaire.find('.tt-doc-tab'), function (i, tab) {
				var tabName = $(tab).attr('href').split('#')[1];
				$(tab).addClass('hide');
				questionnaire.find('#' + tabName).addClass('hide');
				if (tabName in aData) {
					if (aData[tabName].split('|')[1] === 'existing') {
						$(tab).removeClass('hide');
						questionnaire.find('#' + tabName).removeClass('hide');
						if (showTab) {
							$(tab).tab('show');
							showTab = false;
						}
					}
				}
				if (showTab) {
					questionnaire.find('.tab-content .title-center').removeClass('hide');
                } else {
					questionnaire.find('.tab-content .title-center').addClass('hide');
                }
			});

		} else {
			questionnaire.find('.tt-no-selection').removeClass('hide');
			questionnaire.find('.tt-content-questionnaires').addClass('hide');
			$('[href="#content-detail-questionnaires"]').attr('disabled', 'disabled').addClass('disabled');
		}
	}
}

function setReportsContentVisible(state) {

    if (state) {
        $('#content-detail-reports').find('.tt-no-selection').addClass('hide');
        $('#content-detail-reports').find('.tt-content-reports').removeClass('hide');
        $('[href="#content-detail-reports"]').removeAttr('disabled').removeClass('disabled');
    } else {
        $('#content-detail-reports').find('.tt-no-selection').removeClass('hide');
        if (views.getModelId() > 0) {
            $('#content-detail-reports').find('.tt-no-selection').find('.title-doc').text(trans('tripletrax.select_patient'));
        } else {
            $('#content-detail-reports').find('.tt-no-selection').find('.title-doc').text(trans('tripletrax.select_model'));
        }
        $('#content-detail-reports').find('.tt-content-reports').addClass('hide');
        $('[href="#content-detail-reports"]').attr('disabled', 'disabled').addClass('disabled');
    }
}

function setCompletenessContentVisible(state) {

	if (state) {
		$('#content-detail-completeness').find('.tt-no-selection').addClass('hide');
		$('#content-detail-completeness').find('.tt-content-completeness').removeClass('hide');
		$('[href="#content-detail-completeness"]').removeAttr('disabled').removeClass('disabled');
	} else {
		$('#content-detail-completeness').find('.tt-no-selection').removeClass('hide');
		$('#content-detail-completeness').find('.tt-content-completeness').addClass('hide');
		$('[href="#content-detail-completeness"]').attr('disabled', 'disabled').addClass('disabled');
	}
}

function setResolvedSaveConflicts() {

    // was wenn keine Untersuchung ausgewählt wurde?
    if ($('#table_save_conflicts').length) {

        var databaseData = $.parseJSON($('#save_conflicts_dialog').find('[name="database_data"]').val());
        var matchFields = $.parseJSON($('#save_conflicts_dialog').find('[name="match_fields"]').val());
        var existingPatientData = $.parseJSON($('#save_conflicts_dialog').find('[name="existing_patient_data"]').val());
        var existingExaminationData = null;
        if (views.isExaminationSelected() && $('#save_conflicts_dialog').find('[name="existing_examination_data"]').val() !== '') {
            existingExaminationData = $.parseJSON($('#save_conflicts_dialog').find('[name="existing_examination_data"]').val());
        }

        jQuery.each($('#table_save_conflicts').dataTable().fnGetNodes(), function (i, val) {

            var dataArray = [];
            if ($(val).find('.selected-cell').index() === 0) {
                dataArray = $.parseJSON($('#table_save_conflicts').dataTable().fnGetData(i)[2]);
            } else if ($(val).find('.selected-cell').index() === 1) {
                dataArray = $.parseJSON($('#table_save_conflicts').dataTable().fnGetData(i)[3]);
            }

            if ($(val).find('.selected-cell').index() === 1) {

                // Nur wenn die Daten der eigenen Änderung übernommen werden sollen, müssen diese hier ersetzt werden
                for (var key in dataArray) {

                    var keyFormat = key + '_format';
                    if (key.indexOf("__") >= 0) {
                        var name = key.substring(0, key.indexOf("__"));
                        var name_appendix = key.substring(key.indexOf("__"));
                        keyFormat = name + '_format' + name_appendix;
                    }

                    jQuery.each(databaseData, function (array_key, array_value) {
                        //if (key in array_value) {
                            array_value[key] = dataArray[key].split('§§')[0];
                            if (dataArray[key].split('§§')[1] !== '') {
                                array_value[keyFormat] = dataArray[key].split('§§')[1];
                            }
                        //}
                    });
                }
            }

            // wenn es sich um Radiobuttons mit Liste oder Akkordeon handelt, so müssen die Einträge entfernt werden, wenn die Liste bzw. das Akkordeon nicht aktiviert ist
            var listItemNames = [];
            var tableName = '';
            if (Object.keys(dataArray).length === 1) {
                var key = Object.keys(dataArray)[0];
                var value = dataArray[key].replace('§§', '');

                if ($('#content').find('[name="' + key + '"]').parents('.tt-radio-list').length) {

                    var dataActivation = 0;
                    if (value !== '' && $('#content').find('[name="' + key + '"][value="' + value + '"]').length) {
                        dataActivation = $('#content').find('[name="' + key + '"][value="' + value + '"]').data().activation;
                    }

                    if (dataActivation === 0) {
                        var table = $('#content').find('[name="' + key + '"]').parents('.tt-content-datatable').find('[data-database-table-name]');
                        tableName = $(table).data().databaseTableName;
                        listItemNames = $(table).data().listItemNames.split('|');
                    }

                } else if ($('#content').find('[name="' + key + '"]').parents('.tt-radio-accordion').length) {

                    var dataActivation = 0;
                    if (value !== '' && $('#content').find('[name="' + key + '"][value="' + value + '"]').length) {
                        dataActivation = $('#content').find('[name="' + key + '"][value="' + value + '"]').data().activation;
                    }

                    if (dataActivation === 0) {
                        var table = $('#content').find('[name="' + key + '"]').parents('.tt-accordion').find('[data-database-table-name]');
                        tableName = $(table).data().databaseTableName;
                        listItemNames = $(table).data().listItemNames.split('|');
                    }

                }

                if (listItemNames.length > 0) {
                    jQuery.each(listItemNames, function (i, item) {
                        jQuery.each(databaseData, function (array_key, array_value) {
                            jQuery.each(array_value, function (item_key, item_value) {
                                if (item_key.indexOf(item) === 0 || item_key.indexOf(tableName + '_rowid') === 0) {
                                    delete array_value[item_key];
                                }
                            });
                        });
                    });
                }
            }
        });

        var newData = databaseData['0000-00-00'];
        if (views.isExaminationSelected()) {
            newData = jQuery.extend({}, databaseData['0000-00-00'], databaseData[views.getExaminationDate()]);
        }

        // IDAT-Daten hinzufügen
        var aPos = $('#table_patientlist').dataTable().fnGetPosition($('#table_patientlist').find('tr[id="' + views.getPatientId() + '"]')[0]);
        var aData = $('#table_patientlist').dataTable().fnGetData(aPos);
        newData = patients.mergePatientAndIDATData(aData, newData, matchFields);

        // Array mit den aktuellen Daten neu setzen
        if (views.isExaminationSelected()) {
            $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', newData);
        } else {
            $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data', newData);
        }

        // bestehende Daten neu setzen
        $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data', patients.mergePatientAndIDATData(aData, existingPatientData, matchFields));
        if (views.isExaminationSelected()) {
            $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data', existingExaminationData);
        }

        // für alle Tabs, die die Klasse data-loaded besitzen, die Daten setzen
        jQuery.each($('#content').find('.tt-doc-pane.data-loaded'), function (i, tab) {

            var isOwnFacility = true;
            if ($(tab).parents('#content-detail-course').length) {
                isOwnFacility = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_facility_id').toString() === views.getFacilityId().toString();
            }

            patients.setData($(tab), newData, true, false, true, isOwnFacility, false);
        });

        // Dialog schließen
        $('#save_conflicts_dialog').find('.tt-dialog-cancel').click();

        // erneut speichern
        $('#content').find('.tt-save-views')[0].click();
    }
}


// Aufrufe mit Ajax

function freezeData(data, form) {

    if (data === '') {
        var action = form.action.substr(0, form.action.indexOf('/check'));
        var formData = new FormData(form);
        ajax.ajaxCallExtended(action, form.method, formData, false, false, false, null, null, function (data) {

            // "Daten einfrieren"-Button wieder aktiv setzen
            if (access.getRight($('#content').find('.tt-save'), 'all_rights') > 0) {
                $('#content').find('.tt-save').removeClass('disabled');
                $('#content').find('.tt-save').prop('disabled', '');
            }

            $('.tt-please-wait-freeze-data').addClass('hide');

            var year = $(form).find('[name="year"]').select2('data')[0].text;
            var model = $(form).find('[name="model"]').select2('data')[0].text;

            if (data === 'OK') {
                $('.alert-block').find('.data-frozen').html(trans('tripletrax.data_frozen_desc', {model: model, year: year}));
                $('.tt-data-frozen-ok').removeClass('hide');
            } else {
                $('.alert-block').find('.data-frozen-error').html(trans('tripletrax.data_frozen_fail_desc', {model: model, year: year}));
                $('.tt-data-frozen-fail').removeClass('hide');
            }
        });
    } else {
        $.SmartMessageBox({
            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.freeze_data_database_existing_title'),
            content: Lang.get('tripletrax.freeze_data_database_existing_desc'),
            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
        }, function (ButtonPressed) {
            if (ButtonPressed === Lang.get('tripletrax.yes')) {
                var action = form.action.substr(0, form.action.indexOf('/check'));
                var formData = new FormData(form);
                ajax.ajaxCallExtended(action, form.method, formData, false, false, false, null, null, function (data) {

                    // "Daten einfrieren"-Button wieder aktiv setzen
                    if (access.getRight($('#content').find('.tt-save'), 'all_rights') > 0) {
                        $('#content').find('.tt-save').removeClass('disabled');
                        $('#content').find('.tt-save').prop('disabled', '');
                    }

                    $('.tt-please-wait-freeze-data').addClass('hide');

                    var year = $(form).find('[name="year"]').select2('data')[0].text;
                    var model = $(form).find('[name="model"]').select2('data')[0].text;

                    if (data === 'OK') {
                        $('.alert-block').find('.data-frozen').html(trans('tripletrax.data_frozen_desc', {model: model, year: year}));
                        $('.tt-data-frozen-ok').removeClass('hide');
                    } else {
                        $('.alert-block').find('.data-frozen-error').html(trans('tripletrax.data_frozen_fail_desc', {model: model, year: year}));
                        $('.tt-data-frozen-fail').removeClass('hide');
                    }
                });
            } else {
                // "Daten einfrieren"-Button wieder aktiv setzen
                if (access.getRight($('#content').find('.tt-save'), 'all_rights') > 0) {
                    $('#content').find('.tt-save').removeClass('disabled');
                    $('#content').find('.tt-save').prop('disabled', '');
                }

                $('.tt-please-wait-freeze-data').addClass('hide');
            }
        });
    }
}

function importData(data, form) {

    $('.tt-please-wait-file-check').addClass('hide');

    if (data === '') {

        // Überprüfung erfolgreich, der Import wird durchgeführt
        $('.tt-file-check-ok').removeClass('hide');

        var action = $(form).find('[name="import_action"]').val() + '/1';
        data = new FormData(form);

        if ($(form).find('[name="import_action"]').val() === 'admin/import/preview' || $(form).find('[name="import_action"]').val() === 'admin/import_query/preview') {
            $('.tt-import-progress-text').text(trans('tripletrax.please_wait_import_preview'));
            $('.tt-please-wait-import-preview').removeClass('hide');
            $('.tt-section-import-preview-progress').removeClass('hide');
        } else if ($(form).find('[name="import_action"]').val() === 'admin/import/import' || $(form).find('[name="import_action"]').val() === 'admin/import_query/import')  {
            $('.tt-import-progress-text').text(trans('tripletrax.please_wait_import'));
            $('.tt-please-wait-import').removeClass('hide');
            $('.tt-section-import-progress').removeClass('hide');
        }

        doImport(action, data, form);

    } else {

        // Überprüfung fehlgeschlagen, Import wird nicht durchgeführt
        $('.alert-danger').find('.import-error').html(data);
        $('.tt-file-check-fail').removeClass('hide');

        if (access.getRight($('#content').find('.tt-save'), 'all_rights') > 0) {
            $('#content').find('.tt-save').removeClass('disabled');
            $('#content').find('.tt-save').prop('disabled', '');
        }
    }
}

function doImport(action, originalData, form) {

    if (form.id === "import_form") {
        utils.updateGlobals('importRunning', true);
    } else if (form.id === "import_query_form") {
        utils.updateGlobals('importQueryRunning', true);
    }

    ajax.ajaxCallExtended(action, 'POST', originalData, false, false, false, null, null, function (data) {

        if (data.length === 0 || data[0] === 'wait') {

            if (data.length > 0) {
                $('.tt-import-progress').attr('aria-valuenow', data[1]);
                $('.tt-import-progress').attr('data-transitiongoal', data[1]);

                $('.tt-import-progress').progressbar({
                    display_text: 'fill'
                });
                if (data[2] > 0) {
                    $('.tt-import-progress-text').text(trans('tripletrax.import_progress', {x: data[2], all: data[3]}));
                }
            }

            setTimeout(function() {
                action = action.substring(0, action.lastIndexOf('/'));
                doImport(action + '/0', originalData, form);
            }, 5000);

        } else {

            if (form.id === "import_form") {
                utils.updateGlobals('importRunning', false);
            } else if (form.id === "import_query_form") {
                utils.updateGlobals('importQueryRunning', false);
            }

            $('.tt-please-wait-import').addClass('hide');
            $('.tt-section-import-progress').addClass('hide');
            $('.tt-please-wait-import-preview').addClass('hide');
            $('.tt-section-import-preview-progress').addClass('hide');

            var protocolText = '';

            jQuery.each(data, function (i, val) {

                if (val !== 'end' && val !== 'error') {
                    if (val === '<br/>' || val === '<hr class="tt-line-import-protocol" style="border-style: dashed; size: 1px;">') {
                        //$('.tt-import-report').html($('.tt-import-report').html() + val);
                        protocolText += val;
                    } else {
                        //$('.tt-import-report').html($('.tt-import-report').html() + val + '<br/>');
                        protocolText += val + '<br/>';
                    }
                }
            });

            $('.tt-import-report').html($('.tt-import-report').html() + protocolText);

            if (access.getRight($('#content').find('.tt-save'), 'all_rights') > 0) {
                $('#content').find('.tt-save').removeClass('disabled');
                $('#content').find('.tt-save').prop('disabled', '');

                $('#content').find('.tt-save-report').removeClass('disabled');
                $('#content').find('.tt-save-report').prop('disabled', '');
            }
        }
    });
}

function doAggregation(action, originalData) {

	utils.updateGlobals('aggregationRunning', true);

	ajax.ajaxCall(action, 'POST', originalData, false, function (data) {

		if (data.length === 0 || data[0] === 'wait') {

			if (data.length > 0) {
			    if (data[8] > 0) {
					$('.tt-aggregation-progress').attr('aria-valuenow', data[8]);
					$('.tt-aggregation-progress').attr('data-transitiongoal', data[8]);

					$('.tt-aggregation-progress').progressbar({
						display_text: 'fill'
					});
					if (data[9] > 0) {
						$('.tt-aggregation-progress-text').text(trans('tripletrax.aggregation_import_progress', {x: data[9], all: data[10]}));
					}
                } else {
					$('.tt-aggregation-progress').attr('aria-valuenow', data[1]);
					$('.tt-aggregation-progress').attr('data-transitiongoal', data[1]);

					$('.tt-aggregation-progress').progressbar({
						display_text: 'fill'
					});
					if (data[2] > 0) {
						$('.tt-aggregation-progress-text').text(trans('tripletrax.aggregation_progress', {x: data[2], all: data[3]}));
					}
				}

				$('.tt-aggregation-facility-progress').attr('aria-valuenow', data[4]);
				$('.tt-aggregation-facility-progress').attr('data-transitiongoal', data[4]);

				$('.tt-aggregation-facility-progress').progressbar({
					display_text: 'fill'
				});
				if (data[5] > 0) {
					$('.tt-aggregation-facility-progress-text').text(trans('tripletrax.aggregation_facility_progress', {x: data[5], all: data[6], facility: data[7]}));
				}
			}

			var timeOut = 1000;
			if (data.length > 8 && data[8] > 0) {
			    timeOut = 5000;
            }
			setTimeout(function() {
				doAggregation(action, originalData);
			}, timeOut);

		} else {

			utils.updateGlobals('aggregationRunning', false);

			$('.tt-please-wait-aggregation').addClass('hide');
			$('.tt-section-aggregation-progress').addClass('hide');

			var protocolText = '';

			jQuery.each(data, function (i, val) {

				if (val === 'end') {
					protocolText += '<b><font color="#96bf48">' + trans('tripletrax.aggregation_succeeded') + '</font></b><br>';
				} else if (val === 'error') {
					protocolText += '<b><font color="#DB4A67">' + trans('tripletrax.aggregation_failed') + '</font></b><br>';
				} else {
					if (val === '<br/>' || val === '<br>') {
						protocolText += val;
					} else if (val.split('|').length > 3) {
						protocolText += views.getPatientDisplayName(val.split('|')[1], '', '', val.split('|')[2], val.split('|')[3], null, null, null) + '<br>';
					} else {
						protocolText += val + '<br>';
                    }
				}
			});
			$('.tt-aggregation-report').html(protocolText);

			$('#content').find('.tt-save-report').removeClass('disabled');
			$('#content').find('.tt-save-report').prop('disabled', '');
		}
	});
}

function doMerge(form, data, originalData) {

    if (data !== 'wait' && data !== 'FAILS') {
        utils.setHtmlData($("#content"), data, true);
        return;
    }

    var action = form.action;
    action = action.substring(0, action.lastIndexOf('/')) + '/0';

    ajax.ajaxCall(action, 'POST', originalData, false, function (data) {

        if (data === 'wait') {

            setTimeout(function() {
                doMerge(form, data, originalData);
            }, 5000);

        } else {

            if (data !== 'FAILS') {
                utils.setHtmlData($("#content"), data, true);
            }
        }
    });

}

function doExport(form, data, originalData) {

    if (data !== 'wait' && data !== 'FAILS') {
        downloadExportFiles(data, form);
        return;
    }

    var action = form.action;
    action = action.substring(0, action.lastIndexOf('/')) + '/0';

    ajax.ajaxCall(action, 'POST', originalData, false, function (data) {

        if (data === 'wait') {

            setTimeout(function() {
                doExport(form, data, originalData);
            }, 5000);

        } else {

            if (data !== 'FAILS') {
                downloadExportFiles(data, form);
            }
        }
    });
}

function saveIDATDataToCSV(data, form) {

    return $.Deferred(function (defer) {

        var idatPatientsArray = {};

        // Datei mit IDAT-Daten erstellen, wenn IDAT-Daten exportiert werden sollen und die Daten auch angezeigt werden dürfen
        if ($(form).find('[name="export_idat"]:checked').length > 0 && access.showPatientsAnonymized() === 0) {

            patients.loadIDATPatientListWithPseudonym(data).done(function (idatData) {

                // Match-Fields definieren und aus IDAT-Patienten-Liste entfernen
                var matchFields = idatData[idatData.length - 2];
                var matchFieldDescriptions = idatData[idatData.length - 1];
                idatData.pop();
                idatData.pop();

                // Zu exportierende Datenfelder definieren
                var formData = utils.getSerializedFormData(form);
                formData = addExportTreeItems(form, formData);
                var dataViewsArray = ['patientname', 'prename', 'birth_date', 'gender', 'street', 'postal_code', 'city', 'birth_name', 'birth_city'];
                var showHeader = '';
                var fileFormat = '';
                $.each(formData.split("&"), function (i, val) {
                    if (/^show_header/.test(val)) {
                        showHeader = val.split("=")[1];
                    } else if (/^file_format/.test(val)) {
                        fileFormat = val.split("=")[1];
                    }
                });

                var headerText = '';
                var text = '';

                // Spaltenüberschriften hinzufügen, falls gewählt
                if (showHeader === 'on') {

                    var headerTextDescription = '';
                    var headerTextName = '';

                    $.each(dataViewsArray, function (i, field) {
                        if (field in matchFieldDescriptions) {
                            headerTextDescription += matchFieldDescriptions[field] + ';';
                        }
                    });

                    if (headerTextDescription !== '') {
                        headerTextDescription = trans('tripletrax.pseudonym') + ';' + headerTextDescription;
                    }

                    $.each(dataViewsArray, function (i, field) {
                        if (field in matchFields) {
                            headerTextName += matchFields[field] + ';';
                        }
                    });

                    if (headerTextName !== '') {
                        headerTextName = 'pseudonym;' + headerTextName;
                    }

                    if (headerTextName !== '' && headerTextDescription !== '') {
                        headerText = headerTextDescription + '\r\n' + headerTextName;
                    }
                }

                text = headerText;

                var genderMatchValues = $('#gender_values').data().matchValues;

                $.each(idatData, function (i, idat) {

                    var patient = {};
                    patient["pseudonym"] = idat["ids"][0]["idString"];
                    patient["patientname"] = idat["fields"]["nachname"];
                    patient["prename"] = idat["fields"]["vorname"];
                    patient["birth_date"] = convertDateValue(idat["fields"]["geburtsjahr"] + '-' + ('00' + idat["fields"]["geburtsmonat"]).substr(idat["fields"]["geburtsmonat"].length) + '-' + ('00' + idat["fields"]["geburtstag"]).substr(idat["fields"]["geburtstag"].length));
                    patient["birth_date_format"] = 'full';
                    patient["gender"] = idat["fields"]["geschlecht"];
                    if (patient["gender"] === 'M' && !utils.isUndefined(genderMatchValues["male"])) {
                        patient["gender"] = genderMatchValues["male"];
                    } else if (patient["gender"] === 'W' && !utils.isUndefined(genderMatchValues["female"])) {
                        patient["gender"] = genderMatchValues["female"];
                    }
                    patient["street"] = idat["fields"]["strasse"];
                    patient["postal_code"] = idat["fields"]["plz"];
                    patient["city"] = idat["fields"]["ort"];
                    patient["birth_name"] = idat["fields"]["geburtsname"];
                    patient["birth_city"] = idat["fields"]["geburtsort"];

                    idatPatientsArray[patient["pseudonym"]] = patient;

                    if (text !== '') {
                        text += '\r\n';
                    }

                    var patientText = '';
                    $.each(dataViewsArray, function (i, field) {
                        if (/ /.test(patient[field]) || /;/.test(patient[field]) || /"/.test(patient[field])) {
                            patientText += '"' + patient[field].replace('"', '""') + '";';
                        } else {
                            patientText += patient[field] + ';';
                        }
                    });

                    if (patientText !== '') {
                        text += patient["pseudonym"] + ';';
                        text += patientText;
                    }
                });

                if (text !== '' && text !== headerText) {
                    text = '\ufeff' + text;
                    var blob = new Blob([text], {type: "text/plain;charset=utf-8"});
                    saveAs(blob, "idat.csv");
                }

                defer.resolve(idatPatientsArray);
            });
        } else if (form.id === 'monitoring_form') {
            var tableData = $(form).find('table').DataTable().data();
            $.each(tableData, function(key, tableRow) {
                var row = $.extend({}, tableRow);

                if ($(form).find('table')[0].id !== 'table_monitoring_patientlist') {
                    $.each($(form).find('thead th'), function (i, column) {
                        var formatColumn = column.dataset.fieldName + '_format';

                        if (column.dataset.controlType === 'date_panel' || column.dataset.controlType === 'date_range') {
                            row[column.dataset.fieldName] = utils.dateToLocaleString(row[column.dataset.fieldName]);
                        } else if (column.dataset.dataType === 'decimal') {
                            if (utils.isUndefined(row[column.dataset.fieldName]) || row[column.dataset.fieldName] === '') {
                                row[column.dataset.fieldName] = '';
                            } else if (formatColumn in row && !utils.isUndefined(row[formatColumn]) && row[formatColumn] !== '') {
                                var returnValue = utils.numberToString(parseFloat(row[column.dataset.fieldName]));
                                var labUnits = $(column).data().labUnits;
                                jQuery.each(labUnits, function (unit, displayDecimals) {
                                    if (full[formatColumn] === unit) {

                                        returnValue = utils.numberToString(parseFloat(data), parseInt(displayDecimals)) + ' ' + full[formatColumn];
                                    }
                                });
                                row[column.dataset.fieldName] = returnValue;
                            }

                        } else if (!utils.isUndefined(column.dataset.controlValues) && Object.keys($(column).data().controlValues).length > 0) {
                            var returnValue = '';
                            if (!utils.isUndefined(row[column.dataset.fieldName])) {
                                var savedControlValues = row[column.dataset.fieldName].toString().split('|');
                                var controlValues = $(column).data().controlValues;
                                jQuery.each(savedControlValues, function (i, savedControlValue) {
                                    jQuery.each(controlValues, function (controlValueInDatabase, controlValue) {
                                        if (savedControlValue === controlValueInDatabase) {
                                            if (returnValue !== '') {
                                                returnValue += ', ';
                                            }
                                            returnValue += controlValue;
                                        }
                                    });
                                });
                            }
                            row[column.dataset.fieldName] = returnValue;
                        }

                        if (formatColumn in row && !utils.isUndefined(row[formatColumn]) && row[formatColumn] !== '' && utils.isFormatValue(row[formatColumn])) {
                            row[formatColumn] = trans('tripletrax.' + row[formatColumn] + '_value');
                        }
                    });
                }
                idatPatientsArray[row['pseudonym']] = row;
            });
            defer.resolve(idatPatientsArray);
        } else {
            defer.resolve(idatPatientsArray);
        }

    }).promise();
}

function downloadExportFiles(data, form) {

    if (data.length === 0) {

        // Export-Button wieder aktiv setzen
        $('#content').find('.tt-save').removeClass('disabled');
        $('#content').find('.tt-save').prop('disabled', '');

        // Ordner mit Dateien auf PUBLIC wieder löschen
        ajax.ajaxCall($('.tt-save-export-file').data().buttonUrl + "/delete/" + $(form).find('[name="export_time_stamp"]').val(), "POST", null, false, function (data) {

            $(form).parents('.tt-content-detail').find('.tt-please-wait-export').addClass('hide');

            $.SmartMessageBox({
                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.not_existing_export_data'),
                content: Lang.get('tripletrax.not_existing_export_data_desc'),
                buttons: '[' + Lang.get('tripletrax.ok') + ']'
            }, function (ButtonPressed) {
            });
        });

    } else {
        saveIDATDataToCSV(data, form).done(function (idatPatientsArray) {

            // Dateien herunterladen
            if ($('.tt-save-export-file').length > 0) {
                ajax.ajaxCall($('.tt-save-export-file').data().buttonUrl + "/" + $(form).find('[name="export_time_stamp"]').val(), "GET", null, false, function (data) {

                    if (data === 'not_existing') {

                        // Export-Button wieder aktiv setzen
                        $('#content').find('.tt-save,.tt-export-monitoring-result').removeClass('disabled');
                        $('#content').find('.tt-save,.tt-export-monitoring-result').prop('disabled', '');

                        $(form).parents('.tt-content-detail').find('.tt-please-wait-export').addClass('hide');

                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.not_existing_export_file'),
                            content: Lang.get('tripletrax.not_existing_export_file_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                    } else {

                        ajax.ajaxCall($('.tt-save-export-file').data().buttonUrl + "/files/" + $(form).find('[name="export_time_stamp"]').val(), "GET", null, false, function (data) {

                            // Alle Dateien herunterladen
                            $.each(data, function (i, file) {

                                if (($(form).find('[name="export_idat"]:checked').length > 0 && access.showPatientsAnonymized() === 0) || form.id === 'monitoring_form') {
                                    var monitoringId = '';
                                    if (form.id === 'monitoring_form') {
                                        monitoringId = $(form).find('[name="monitoring_title"]').val();
                                    }
                                    setTimeout(function () {
                                        openWindow('admin/export/download_idat/' + file + '/' + $(form).find('[name="export_time_stamp"]').val(), 'POST', {idatPatients: idatPatientsArray, exportTableIds: $(form).find('[name="export_table_ids"]:checked').length > 0, isMonitoringExport: (form.id === 'monitoring_form'), monitoringId: monitoringId}, '_blank', $('[name="csrf-token"]').attr('content'));
                                    }, i * 1000);
                                } else {
                                    window.open('admin/export/download/' + file + '/' + $(form).find('[name="export_time_stamp"]').val(), '_blank');
                                }
                            });

                            // Export-Button wieder aktiv setzen
                            $('#content').find('.tt-save,.tt-export-monitoring-result').removeClass('disabled');
                            $('#content').find('.tt-save,.tt-export-monitoring-result').prop('disabled', '');

                            $(form).parents('.tt-content-detail').find('.tt-please-wait-export').addClass('hide');

                            if (!($(form).find('[name="export_idat"]:checked').length > 0 && access.showPatientsAnonymized() === 0) && form.id !== 'monitoring_form') {
                                setTimeout(function () {
                                    // Ordner mit Dateien auf PUBLIC wieder löschen
                                    ajax.ajaxCall($('.tt-save-export-file').data().buttonUrl + "/delete/" + $(form).find('[name="export_time_stamp"]').val(), "POST", null, false, function (data) {
                                    });
                                }, 1000);
                            }

                            if (form.id !== 'monitoring_form') {
                                changes.reloadTable('#table_export_history', 'admin/export/history/datatable');
                            }
                        });
                    }
                });
            } else {

                // Export-Button wieder aktiv setzen
                $('#content').find('.tt-save,.tt-export-monitoring-result').removeClass('disabled');
                $('#content').find('.tt-save,.tt-export-monitoring-result').prop('disabled', '');

                $(form).parents('.tt-content-detail').find('.tt-please-wait-export').addClass('hide');

                $.SmartMessageBox({
                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.not_existing_export_file'),
                    content: Lang.get('tripletrax.not_existing_export_file_desc'),
                    buttons: '[' + Lang.get('tripletrax.ok') + ']'
                }, function (ButtonPressed) {
                });
            }
        });
    }
}

function openWindow(url, method, data, target, csrfToken) {

    var form = document.createElement('form');
    form.action = url;
    form.method = method;
    form.target = target || '_self';
    if (data) {
        for (var key in data) {
            var input = document.createElement('textarea');
            input.name = key;
            input.value = typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key];
            form.appendChild(input);
        }
    }
    var meta = document.createElement('input');
    meta.name = '_token';
    meta.value = csrfToken;
    form.appendChild(meta);

    form.style.display = 'none';
    document.body.appendChild(form);

    form.submit();
    form.remove();
}

function deletePatientFinally(data, form) {

    if (data === '') {

        // Patient ist in keiner Einrichtung mehr zugeordnet
        doDeletePatientFinally(null, form);

    } else {

        // Patient ist in mindestens einer Einrichtung noch zugeordnet
        $('#delete_patient_finally_dialog').find('[name="pseudonym"]').val($(form).find('[name="pseudonym"]').val());
        $('#delete_patient_finally_dialog').find('[name="agreement_facilities"]').html('');

        var facilities = '';
        for (var key in data) {
            facilities += '- ' + data[key] + ' [' + key + ']</br>';
        }

        $('#delete_patient_finally_dialog').find('[name="agreement_facilities"]').html(facilities);
        $('#delete_patient_finally_dialog').modal("show");
    }
}

function doDeletePatientFinally(form, parentForm) {

    var action = parentForm.action + '/' + $(parentForm).find('[name="pseudonym"]').val();

    ajax.ajaxCallExtended(action, parentForm.method, null, false, false, false, null, null, function (data) {

        $(parentForm).find('[name="pseudonym"]').val('');

        if (data === '') {
            $(parentForm).find('.tt-patient-finally-deleted').removeClass('hide');
        } else {
            $('.alert-danger').find('.delete-patient-finally-error').html(data);
            $(parentForm).find('.tt-patient-finally-not-deleted').removeClass('hide');
        }

        if (form !== null) {
            $(form).parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
        }
    });
}

function loadAuditTrail(form, data, originalData) {

    if (data !== 'wait' && data !== 'FAILS') {
        showAuditTrailSearchResults(data);
        return;
    }

    var action = form.action;
    action = action.substring(0, action.lastIndexOf('/')) + '/0';

    ajax.ajaxCall(action, 'GET', originalData, false, function (data) {

        if (data === 'wait') {

            setTimeout(function() {
                loadAuditTrail(form, data, originalData);
            }, 500);

        } else {

            if (data !== 'FAILS') {
                showAuditTrailSearchResults(data);
            }
        }
    });
}

function showAuditTrailSearchResults(data) {

    $('#table_audit_trail').dataTable().api().clear().rows.add(data).draw();

    $('.tt-audit-trail-results').removeClass('hide');
    $('.tt-please-wait-audit-trail').addClass('hide');

    $('#content').find('.tt-save').removeClass('disabled');
    $('#content').find('.tt-save').prop('disabled', '');
}


// Zusätzliche Daten anhängen

function addDataUsers(data) {

    // Einträge der Tabelle manuell hinzufügen
    data = data + "&facility_roles=";
    jQuery.each($('#table_users_roles').dataTable().fnGetData(), function (i, val) {

        if (i > 0) {
            data = data + "|";
        }

        data = data + val[0];
        data = data + "-" + val[3];
    });

    return data;
}

function addDataFreezeFacilityData(data) {

    // Einträge der Tabelle der geseprrten Zeiträume hinzufügen
    data = data + "&locked_periods=";
    jQuery.each($('#table_locked_periods').dataTable().fnGetData(), function (i, val) {

        if (i > 0) {
            data = data + "|";
        }

        // die Angaben zu "Gesperrt am" und "Gesperrt durch" werden an dieser Stelle nicht benötigt,
        // da diese bei Aktualisierung der Daten auf "Heute" bzw. auf "Mich" gesetzt werden!
        data = data + val[0] + '#' + val[4] + '#' + val[5];
    });

    // Einträge der Tabelle der geseperrten Patienten hinzufügen
    data = data + "&locked_patients=";
    jQuery.each($('#table_locked_patients').dataTable().fnGetData(), function (i, val) {

        if (i > 0) {
            data = data + "|";
        }

        // die Angaben zu "Gesperrt am" und "Gesperrt durch" werden an dieser Stelle nicht benötigt,
        // da diese bei Aktualisierung der Daten auf "Heute" bzw. auf "Mich" gesetzt werden!
        data = data + val[0] + '#' + val[4];
    });

    return data;
}

function addDataRoles(data) {

    // Einträge der Rechte-Tabelle manuell hinzufügen
    var data1 = data.substring(data.indexOf('role_data_collection_types'));

    if (data1.indexOf('&') >= 0) {
        data1 = data1.substring(data1.indexOf('&'));
        data = data.substring(0, data.indexOf(data1));
    }
    data = data + "&role_rights=";

    jQuery.each($('#table_role_rights').dataTable().fnGetNodes(), function (i, val) {

        if (i > 0) {
            data = data + "|";
        }

        var current_data = "";

        jQuery.each(val.children, function (j, val_child) {

            if (current_data !== "") {
                current_data = current_data + ",";
            }

            if (j > 0) {
                if (!utils.isUndefined(val_child.childNodes[0].children[0])) {
                    if (val_child.childNodes[0].children[0].checked) {
                        current_data = current_data + val_child.childNodes[0].children[0].name + ".1";
                    } else {
                        current_data = current_data + val_child.childNodes[0].children[0].name + ".0";
                    }
                }
            }
        });

        if (current_data !== "") {
            data = data + $('#table_role_rights').dataTable().fnGetData(i)[12] + "__" + $('#table_role_rights').dataTable().fnGetData(i)[13] + "//" + $('#table_role_rights').dataTable().fnGetData(i)[19] + "//" + $('#table_role_rights').dataTable().fnGetData(i)[14];
            data = data + "--" + current_data;
        }
    });

    return data;
}

function addDataMonitoring(data) {

    // Einträge der anzuzeigenden Felder manuell hinzufügen
    if ($('#monitoring_display_fields_table').length) {
        var displayFields = '';
        data = data + "&monitoring_display_fields=";
        jQuery.each($('#monitoring_display_fields_table').find('.dd3-content'), function (i, val) {

            if (!$(val).data('isDeleted')) {
                if (displayFields !== '') {
                    displayFields = displayFields + "|";
                }

                displayFields = displayFields + $(val).data('viewId')
                    + '#' + $(val).data('viewName');
            }
        });
        data = data + displayFields;
    }

    // Einträge der Einschränkungen manuell hinzufügen
    var restrictionData = '';
    jQuery.each($('#monitoring_restrictions_table').find('.dd3-content'), function (i, val) {

        if (!$(val).data('isDeleted')) {
            if (restrictionData !== '') {
                restrictionData = restrictionData + "|";
            }

            restrictionData = restrictionData + $(val).data('id')
                + '#' + $(val).data('viewId')
                + '#' + $(val).data('viewName')
                + '#' + $(val).data('description')
                + '#' + $(val).data('value')
                + '#' + $(val).data('rangeOfValues')
                + '#' + $(val).data('unit')
                + '#' + $(val).data('valueFromLogicalOperator')
                + '#' + $(val).data('valueFromDecimal')
                + '#' + $(val).data('valueFromString')
                + '#' + $(val).data('valueFromDate')
                + '#' + $(val).data('valueFromViewId')
                + '#' + $(val).data('valueFromViewName')
                + '#' + $(val).data('valueFromUpDown')
                + '#' + $(val).data('valueFromValue')
                + '#' + $(val).data('valueFromRange')
                + '#' + $(val).data('valueTillLogicalOperator')
                + '#' + $(val).data('valueTillDecimal')
                + '#' + $(val).data('valueTillDate')
                + '#' + $(val).data('valueTillViewId')
                + '#' + $(val).data('valueTillViewName')
                + '#' + $(val).data('valueTillUpDown')
                + '#' + $(val).data('valueTillValue')
                + '#' + $(val).data('valueTillRange')
                + '#' + $(val).data('periodFromLogicalOperator')
                + '#' + $(val).data('periodFromDate')
                + '#' + $(val).data('periodTillLogicalOperator')
                + '#' + $(val).data('periodTillDate')
                + '#' + $(val).data('valueFromLater')
                + '#' + $(val).data('valueTillLater')
                + '#' + $(val).data('periodFromLater')
                + '#' + $(val).data('periodTillLater')
                + '#' + $(val).data('isDeleted')
                + '#' + $(val).data('periodFromViewId')
                + '#' + $(val).data('periodFromViewName')
                + '#' + $(val).data('periodFromUpDown')
                + '#' + $(val).data('periodFromValue')
                + '#' + $(val).data('periodFromRange')
                + '#' + $(val).data('periodTillViewId')
                + '#' + $(val).data('periodTillViewName')
                + '#' + $(val).data('periodTillUpDown')
                + '#' + $(val).data('periodTillValue')
                + '#' + $(val).data('periodTillRange');
        }
    });

    data += '&' + jQuery.param({ monitoring_restrictions: restrictionData });

    restrictionData = null;

    return data;
}

function addAgreementType(data) {

    // Einträge der Dokumente manuell hinzufügen
    data = data + "&agreement_documents=";
    jQuery.each($('#table_agreement_type_documents').dataTable().fnGetData(), function (i, val) {

        if (i > 0) {
            data = data + "|";
        }

        data = data + val[0];
        data = data + "--" + val[1];
        data = data + "--" + val[2];
    });

    return data;
}

function addDataCollectionType(data) {

    // Aktivierung der farblichen Differenzierung der Häkchensymbole
    data = data + "&colored_completeness_activated=";
    data = data + $('[name="colored_completeness_activated"]').val();

    // Einträge der Stammdatensichten manuell hinzufügen
    data = data + "&master_views=";
    jQuery.each($('#table_data_collection_type_master_views').dataTable().fnGetData(), function (i, val) {

        if (i > 0) {
            data = data + "|";
        }

        data = data + val[0];
        data = data + "-" + val[2];
    });

    // Einträge der Verlaufsansichten (Register) manuell hinzufügen
    data = data + "&course_views_register=";
    jQuery.each($('#table_data_collection_type_course_views_register').dataTable().fnGetData(), function (i, val) {

        if (i > 0) {
            data = data + "|";
        }

        data = data + val[0];
        data = data + "-" + val[2];
    });

	// Einträge der Fragebögen manuell hinzufügen
	data = data + "&questionnaires=";
	jQuery.each($('#table_data_collection_type_questionnaires').dataTable().fnGetData(), function (i, val) {

		if (i > 0) {
			data = data + "|";
		}

		data = data + val[0];
		data = data + "-" + val[2];
	});

	// Einträge der Fragebogen-Projekte manuell hinzufügen
	data = data + "&questionnaire_projects=";
	jQuery.each($('#table_data_collection_type_questionnaire_projects').dataTable().fnGetData(), function (i, val) {

		if (i > 0) {
			data = data + "|";
		}

		data = data + val[0];
		data = data + "-" + val[2];
	});

    // Einträge der Verlaufsansichten (Studie) manuell hinzufügen
    var start_id = -1;
    var dd_item = $('.dd').find('.tt-start-view').parents('.dd-item')[0];
    if (!utils.isUndefined(dd_item)) {
        start_id = dd_item.getAttribute('data-id');
    };

    data = data + "&course_views_study=";
    jQuery.each($('#dd_course_views').nestable('serialize'), function (i, val) {

        if (i > 0) {
            data = data + "|";
        }

        data = data + val.viewId;

        if (String(val.id) === start_id) {
            data = data + "!";
        }

        if (!utils.isUndefined(val.children)) {
            data = data + "-";

            jQuery.each(val.children, function (j, child) {
                if (j > 0) {
                    data = data + ",";
                }

                data = data + child.viewId;
            });
        }
    });

    // Einträge der Integritäten manuell hinzufügen
    var integrityData = '';
    jQuery.each($('#table_data_collection_type_integrities').dataTable().fnGetData(), function (i, val) {

        if (i > 0) {
            integrityData = integrityData + "|";
        }

        integrityData += val[0] + '#' + val[1] + '#' + val[2] + '#' + val[4] + '#' + val[5] + '#' + val[6] + '#' + val[7]
            + '#' + val[8] + '#' + val[9] + '#' + val[10] + '#' + val[11] + '#' + val[12] + '#' + val[13] + '#' + val[14] + '#' + val[15]
            + '#' + val[16] + '#' + val[17] + '#' + val[18] + '#' + val[19] + '#' + val[20] + '#' + val[21] + '#' + val[22] + '#' + val[23]
            + '#' + val[24] + '#' + val[25] + '#' + val[26] + '#' + val[27] + '#' + val[28] + '#' + val[29] + '#' + val[30] + '#' + val[31]
            + '#' + val[32] + '#' + val[33] + '#' + val[34] + '#' + val[35] + '#' + val[36] + '#' + val[37] + '#' + val[38] + '#' + val[39]
            + '#' + val[40] + '#' + val[41] + '#' + val[42] + '#' + val[43] + '#' + val[44] + '#' + val[45] + '#' + val[46] + '#' + val[47]
            + '#' + val[48] + '#' + val[49] + '#' + val[50] + '#' + val[51] + '#' + val[52] + '#' + val[53] + '#' + val[54] + '#' + val[55]
            + '#' + val[56] + '#' + val[57] + '#' + val[58] + '#' + val[59] + '#' + val[60] + '#' + val[61] + '#' + val[62] + '#' + val[63]
            + '#' + val[64] + '#' + val[65] + '#' + val[66] + '#' + val[67] + '#' + val[68] + '#' + val[69] + '#' + val[70] + '#' + val[71];

    });

    data += '&' + jQuery.param({ integrities: integrityData });

    integrityData = null;

    return data;
}

function addExportTreeItems(form, data) {

    // Einträge der Einrichtungen-Tabelle manuell hinzufügen
    data = data + "&facilities=";
    var facilities = "";
    $("input:checked", $(form).find('#table_export_facilities').dataTable().fnGetNodes()).each(function () {

        if (facilities !== '') {
            facilities += "|";
        }
        facilities += $(this).parents('tr')[0].getAttribute('data-tt-id');
    });
    data = data + facilities;

    data = data + "&existing_facilities=";
    var existing_facilities = "";
    $.each($(form).find('#table_export_facilities').dataTable().fnGetNodes(), function (i, item) {

        if (existing_facilities !== '') {
            existing_facilities += "|";
        }
        existing_facilities += item.getAttribute('data-tt-id');
    });
    data = data + existing_facilities;

    // Einträge der Datenfelder-Tabelle manuell hinzufügen
    data = data + "&data_views=";
    var data_views = "";
    $("input:checked", $(form).find('#table_export_data_views').dataTable().fnGetNodes()).each(function () {

        if (data_views !== '') {
            data_views += "|";
        }
        data_views += $(this).parents('tr')[0].getAttribute('data-tt-name');
    });
    data = data + data_views;

    return data;
}

function addDatabaseExportTreeItems(form, data) {

    // Einträge der Einrichtungen-Tabelle manuell hinzufügen
    data = data + "&facilities=";
    var facilities = "";
    $("input:checked", $(form).find('#table_database_export_facilities').dataTable().fnGetNodes()).each(function () {

        if (facilities !== '') {
            facilities += "|";
        }
        facilities += $(this).parents('tr')[0].getAttribute('data-tt-id');
    });
    data = data + facilities;

    data = data + "&existing_facilities=";
    var existing_facilities = "";
    $.each($(form).find('#table_database_export_facilities').dataTable().fnGetNodes(), function (i, item) {

        if (existing_facilities !== '') {
            existing_facilities += "|";
        }
        existing_facilities += item.getAttribute('data-tt-id');
    });
    data = data + existing_facilities;

    // Einträge der Datenbanktabellen-Tabelle manuell hinzufügen
    data = data + "&datatables=";
    var tables = "";
    $("input:checked", $(form).find('#table_database_export_tables').dataTable().fnGetNodes()).each(function () {

        if (tables !== '') {
            tables += "|";
        }
        tables += $(this).parents('tr')[0].getAttribute('data-tt-table');
    });
    data = data + tables;

    return data;
}

function addRestorePatientItems(form) {

    // Einträge der Einrichtungen-Tabelle manuell hinzufügen
    var data = "&facilities=";
    var facilities = "";
    $("input:checked", $(form).find('#table_restore_patient_facilities').dataTable().fnGetNodes()).each(function (i, val) {

        if (facilities !== '') {
            facilities += "|";
        }
        facilities += $(this).parents('tr')[0].id;
    });
    data = data + facilities;

    return data;
}

function addDataSettings() {

    var data = '';

    // Sprach-Einstellungen
    data = data + "&selected_languages=" + $('#settings_language_form').find('[name="selected_languages"]').val();
    data = data + "&default_language=" + $('#settings_language_form').find('[name="default_language"]').val();

    // Import- / Export-Einstellungen
    data = data + "&selected_date_format=" + $('#settings_import_export_form').find('[name="selected_date_format"]').val();
    data = data + "&multiselect_existing_value=" + $('#settings_import_export_form').find('[name="multiselect_existing_value"]').val();
    jQuery.each($('#table_settings_format_mapping').dataTable().fnGetData(), function (i, val) {

        data = data + "&mapped_format_" + val[3] + "=" + $('#settings_import_export_form').find('[name="mapped_format_' + val[3] + '"]').val();
    });

    // Allgemeine Einstellungen
    var saveRequest = 0;
    if ($('#settings_form').find('[name="save_request"]').is(':checked')) {
        saveRequest = 1;
    }
    data = data + "&save_request=" + saveRequest;
    var optionalExaminationTime = 0;
    if ($('#settings_form').find('[name="optional_examination_time"]').is(':checked')) {
        optionalExaminationTime = 1;
    }
    data = data + "&optional_examination_time=" + optionalExaminationTime;
    if (!utils.isUndefined($('#settings_form').find('[name="contacts_for_deleted_patients"]').val())) {
        data = data + "&contacts_for_deleted_patients=" + $('#settings_form').find('[name="contacts_for_deleted_patients"]').val().join('|');
    } else {
        data = data + "&contacts_for_deleted_patients=";
    }

	if (!utils.isUndefined($('#settings_form').find('[name="contacts_for_system_events"]').val())) {
		data = data + "&contacts_for_system_events=" + $('#settings_form').find('[name="contacts_for_system_events"]').val().join('|');
	} else {
		data = data + "&contacts_for_system_events=";
	}

    $('.tt-lung-function-settings:checked,.tt-percentile-function-settings:checked').each(function () {
        data = data + "&" + $(this)[0].name + "=" + $(this).val();
    });

    // E-Mail-Einstellungen
	data = data + "&mail_default_message=" + encodeURIComponent($('#settings_mail_message').summernote('code'));

    return data;
}

function addDataUserSettings() {

    var data = {};


    var showCompletenessOnStart = 0;
    if ($('#user_options_form').find('[name="show_completeness_on_start"]').is(':checked')) {
        showCompletenessOnStart = 1;
    }
    data['show_completeness_on_start'] = showCompletenessOnStart;

    return data;
}

function addDataOptions() {

    var data = {};

    // Einstellungen Benutzer
    var saveRequest = 0;
    if ($('#user_options_form').find('[name="save_request"]').is(':checked')) {
        saveRequest = 1;
    }
    data['save_request'] = saveRequest;

    var showAgreementBlock = 0;
    if ($('#user_options_form').find('[name="show_agreement_block"]').is(':checked')) {
        showAgreementBlock = 1;
    }
    data['show_agreement_block'] = showAgreementBlock;

    var cancelPatientSearch = 0;
    if ($('#user_options_form').find('[name="cancel_patient_search"]').is(':checked')) {
        cancelPatientSearch = 1;
    }
    data['cancel_patient_search'] = cancelPatientSearch;

    var accordionsAlwaysExpanded = 0;
    if ($('#user_options_form').find('[name="accordions_always_expanded"]').is(':checked')) {
        accordionsAlwaysExpanded = 1;
    }
    data['accordions_always_expanded'] = accordionsAlwaysExpanded;

    var liveCompletenessCheck = 0;
    if ($('#user_options_form').find('[name="live_completeness_check"]').is(':checked')) {
        liveCompletenessCheck = 1;
    }
    data['live_completeness_check'] = liveCompletenessCheck;

    var showActivityOnStart = 0;
    if ($('#user_options_form').find('[name="show_activity_tab_on_start"]').is(':checked')) {
        showActivityOnStart = 1;
    }
    data['show_activity_tab_on_start'] = showActivityOnStart;

    var showCompletenessOnStart = 0;
    if ($('#user_options_form').find('[name="show_completeness_on_start"]').is(':checked')) {
        showCompletenessOnStart = 1;
    }
    data['show_completeness_on_start'] = showCompletenessOnStart;

    data['default_number_of_rows_patientlist'] = $('#user_options_form').find('[name="default_number_of_rows_patientlist"]:checked').val();
    data['default_number_of_rows_examinationlist'] = $('#user_options_form').find('[name="default_number_of_rows_examinationlist"]:checked').val();
    data['default_report'] = $('#user_options_form').find('[name="default_report"]').select2('val');

    // Einstellungen Einrichtung
    $('.tt-lung-function-settings:checked,.tt-percentile-function-settings:checked').each(function () {
        data[$(this)[0].name] = $(this).val();
    });

    data['facility_units'] = "";
    var counter = 0;
    $("input:checked", $('#table_options_default_unit').dataTable().fnGetNodes()).each(function () {

        if (counter > 0) {
            data['facility_units'] += '||';
        }

        data['facility_units'] = data['facility_units'] + $(this)[0].name.split('|')[0] + '#' + $(this)[0].name.split('|')[1] + '#' + $(this)[0].value;
        counter++;

    });

    data['facility_patterns'] = {};
    var name = '';
    $(".tt-select2", $('#table_options_pattern').dataTable().fnGetNodes()).each(function () {

        var parent = $(this).parent();
        var element = $(this);

        // Falls die Comobox noch nicht initialisiert ist, hier noch machen, damit die Daten ausgelesen werden können
        if (!$(this).hasClass('select2-container')) {
            initialize.initializeSelect2($(this));
            element = $(parent.find('.tt-select2')[0]);
        }

        if (!utils.isUndefined(element[0].name)) {

            name = element[0].name;
            data['facility_patterns'][name] = [];
            jQuery.each(element.select2('data'), function (i, value) {

                data['facility_patterns'][name].push(value.id);
            });
        }
    });

	$('.tt-select-language,.tt-select-questionnaire').each(function () {
	    if ($(this).hasClass('tt-select-language') || $(this).is(':checked')) {
			data[$(this)[0].name] = $(this).val();
		} else {
			data[$(this)[0].name] = '';
        }
	});

    return data;
}

function addResolvedMergeConflicts(data) {
    var assumedData = '';
    var notAssumedData = '';
    var notAssumedDataDeletedPatient = '';

    var patNrMerge = '';
    var patNrDelete = '';

    var splittedData = data.split('&');
    if (jQuery.inArray('target_patient_1=on', splittedData) > -1) {
        jQuery.each(splittedData, function (i, val) {
            var splittedVal = val.split('=');
            if (splittedVal[0] === 'pseudonym_patient_1') {
                patNrMerge = splittedVal[1];
            } else if (splittedVal[0] === 'pseudonym_patient_2') {
                patNrDelete = splittedVal[1];
            }
        });
    } else if (jQuery.inArray('target_patient_2=on', splittedData) > -1) {
        jQuery.each(splittedData, function (i, val) {
            var splittedVal = val.split('=');
            if (splittedVal[0] === 'pseudonym_patient_1') {
                patNrDelete = splittedVal[1];
            } else if (splittedVal[0] === 'pseudonym_patient_2') {
                patNrMerge = splittedVal[1];
            }
        });
    }

    // Einträge der Konflikte-Tabelle manuell hinzufügen
    if ($('#table_merge_conflicts').length) {
        jQuery.each($('#table_merge_conflicts').dataTable().fnGetNodes(), function (i, val) {

            if ($(val).find('.selected-cell').index() === 1) {

                if (assumedData !== '') {
                    assumedData += "§§";
                }
                assumedData += $('#table_merge_conflicts').dataTable().fnGetData(i)[5] + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[0] + '||' + patNrMerge + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[8] + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[7];

                if (notAssumedData !== '') {
                    notAssumedData += "§§";
                }
                notAssumedData += $('#table_merge_conflicts').dataTable().fnGetData(i)[5] + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[0] + '||' + patNrDelete + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[9] + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[7];

                if (notAssumedDataDeletedPatient !== '') {
                    notAssumedDataDeletedPatient += "§§";
                }
                notAssumedDataDeletedPatient += $('#table_merge_conflicts').dataTable().fnGetData(i)[5] + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[6] + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[2] + "||" + $('#table_merge_conflicts').dataTable().fnGetData(i)[4];

            } else if ($(val).find('.selected-cell').index() === 2) {

                //if (assumedData !== '') {
                //  assumedData += "§§";
                //}
                //assumedData += $('#table_merge_conflicts').dataTable().fnGetData(i)[5] + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[0] + '||' + patNrDelete + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[9] + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[7];

                if (notAssumedData !== '') {
                    notAssumedData += "§§";
                }
                notAssumedData += $('#table_merge_conflicts').dataTable().fnGetData(i)[5] + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[0] + '||' + patNrMerge + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[8] + '||' + $('#table_merge_conflicts').dataTable().fnGetData(i)[7];
            }
        });

        data += "&assumed_data=" + encodeURIComponent(assumedData) + "&not_assumed_data=" + encodeURIComponent(notAssumedData) + "&not_assumed_data_deleted_patient=" + encodeURIComponent(notAssumedDataDeletedPatient);
    }

    return data;
}

function addDataNews(data) {

    // Einträge der Tabelle manuell hinzufügen
    data = data + "&news_rights=";
    $.each($('#table_news_rights').dataTable().fnGetData(), function (i, val) {

        if (i > 0) {
            data = data + "|";
        }

        data = data + val[0] + "-" + val[3] + "-" + val[4];
    });

    // Nachricht manuell hinzufügen
    data = data + "&news_message=" + encodeURIComponent($('#news_message').summernote('code'));

    return data;
}

function addDataDocuments(data) {

    // Einträge der Tabelle manuell hinzufügen
    var data_rights = '';
    $.each($('#table_documents_rights').dataTable().fnGetData(), function (i, val) {

        if (i > 0) {
            data_rights = data_rights + "|";
        }

        data_rights = data_rights + val[0] + "-" + val[3] + "-" + val[4];
    });

    data.append('documents_rights', data_rights);
    return data;
}

function addDataMail(form) {

    var data = new FormData(form);

    data.append('mail_message', $('#mail_message').summernote('code'));
    data.append('plain_mail_message', $("#mail_message").summernote('code').replace(/<\/p>/gi, "\n").replace(/<br\/?>/gi, "\n").replace(/<\/?[^>]+(>|$)/g, ""));

    for (var i = 0, len = utils.GLOBALS.mailAttachments.length; i < len; i++) {
        data.append('files_' + i, utils.GLOBALS.mailAttachments[i]);
    }

    return data;
}


// Hinzugefügtes Element der Nestable Liste hinzufügen

function addDataViewNestableItem(element, form) {

    var current_id = '0';
    var current_type = '';
    var current_type_text = '';
    var current_element_selection = element.find('select[name="element"]').select2('data');
	if (!utils.isUndefined(current_element_selection)) {
		current_element_selection = current_element_selection[0];
    }

    if (!utils.isUndefined(current_element_selection) && current_element_selection.id !== '') {
        current_type = 'field';
        if (current_element_selection.id == 'view' || current_element_selection.id == 'overview' || current_element_selection.id == 'tab') {
            current_type = current_element_selection.id;
        }
        else if (current_element_selection.id === 'column' || current_element_selection.id === 'accordion' || current_element_selection.id === 'accordion_as_list' || current_element_selection.id === 'accordion_as_list_with_radio'
            || current_element_selection.id === 'group' || current_element_selection.id === 'group_with_radio' || current_element_selection.id === 'list' || current_element_selection.id === 'list_with_radio'
            || current_element_selection.id === 'column_with_radio' || current_element_selection.id === 'accordion_with_radio') {
            current_type = 'element';
        }
        current_type_text = current_element_selection.text;
    }
    var current_category = element.find('input[name="category"]').val();
    var current_name = element.find('input[name="viewname"]').val();
    var current_parent_id = element.find('input[name="parent_id"]').val();
    var current_position = element.find('input[name="position"]').val();
    var current_level = element.find('input[name="level"]').val();

    var current_existing_element_selection = element.find('[name="existing_element"]').select2('data');
	if (!utils.isUndefined(current_existing_element_selection)) {
		current_existing_element_selection = current_existing_element_selection[0];
	}
    if (!utils.isUndefined(current_existing_element_selection) && !utils.isUndefined(current_existing_element_selection.id) && current_existing_element_selection.id !== '') {
        current_type = 'field';
        current_type_text = trans('tripletrax.data_views_' + $(current_existing_element_selection.element).data().controlType);
        current_name = current_existing_element_selection.text;
    }

    var add_dd_List = false;
    var html = '';
    var item = $('.tt-content').find("[data-id='" + current_parent_id + "']").find('.dd-list');
    if (item.length) {
        item = item[0];
    } else {
        item = $('.tt-content').find("[data-id='" + current_parent_id + "']");
        html += '<ol class="dd-list">';
        add_dd_List = true;
    }


    html += '<li class="dd-item" data-id="0" data-view-id="' + current_id + '" data-type="' + current_type + '" data-category="' + current_category + '" data-position="' + current_position + '" data-level="' + current_level + '">' +
        '<div class="dd-handle">' + current_name + ' (' + current_type_text + ')';

    if (current_type !== 'field') {
        html += '<div class="air air-top-right padding-7 padding-top-5">';
        html += '<div class="btn-toolbar pull-right">';
        html += '<div class="btn-group">';
        html += '<button id="add_0_' + current_type + '" href="#table_data_views_create_dialog" data-toggle="modal" class="btn btn-xs btn-success tt-right-button-update tt-dialog-open tt-add-nestable tt-button-nestable hide dd-nodrag" rel="tooltip" data-placement="top" data-original-title="' + trans('tripletrax.add_tooltip') + '">';
        html += '<i class="fad fa-plus"></i>';
        html += '</button>';
        html += '<a action="admin/dataview" method="POST" id="delete_0_' + current_type + '" class="btn btn-xs btn-danger tt-right-button-update tt-delete tt-delete-nestable tt-button-nestable hide dd-nodrag" rel="tooltip" data-placement="top" data-original-title="' + trans('tripletrax.delete_tooltip') + '">';
        html += '<i class="fad fa-trash-alt"></i>';
        html += '</a>';
        html += '</div>';
        html += '</div>';
        html += '</div>';
    } else {
        html += '<div class="air air-top-right padding-7 padding-top-5">';
        html += '<div class="btn-toolbar pull-right">';
        html += '<div class="btn-group">';
        html += '<a action="admin/dataview" method="POST" id="delete_0_' + current_type + '" class="btn btn-xs btn-danger tt-right-button-update tt-delete tt-delete-nestable tt-button-nestable hide dd-nodrag" rel="tooltip" data-placement="top" data-original-title="' + trans('tripletrax.delete_tooltip') + '">';
        html += '<i class="fad fa-trash-alt"></i>';
        html += '</a>';
        html += '</div>';
        html += '</div>';
        html += '</div>';
    }

    html += '</div></li>';

    if (add_dd_List) {
        html += '</ol>';
    }

    $(html).appendTo(item);

    if (add_dd_List) {
        nestable.setNestableParent(item);
    }

    nestable.selectNestableElement($($('.tt-content').find("[data-id='0']").find('.dd-handle')[0]), true);
}


// Geladene Daten anzeigen

function showDetailData(data, element, form, validator, doInitializeElements, isNewItem) {

    if (/^FAILS/.test(data)) {
        if (form.id === "table_users_detail_form") {
            validator.showErrors({ 'username': data.substring(6) });
        } else if (form.id === "table_facilities_detail_form") {
            data = data.substring(6);
            var splitted_data = data.split("|");

            jQuery.each(splitted_data, function (i, val) {

                if (/^ID/.test(val)) {
                    validator.showErrors({ 'facilityid': val.substring(2) });
                } else if (/^Name/.test(val)) {
                    validator.showErrors({ 'facilityname': val.substring(4) });
                }
            });
        } else if (form.id === "table_roles_detail_form") {
            validator.showErrors({ 'rolename': data.substring(6) });
        } else if (form.id === "table_data_collection_types_detail_form") {
            data = data.substring(6);
            var splitted_data = data.split("|");

            jQuery.each(splitted_data, function (i, val) {

                if (/^Model/.test(val)) {
                    validator.showErrors({ 'model': val.substring(5) });
                } else if (/^Abbreviation/.test(val)) {
                    validator.showErrors({ 'abbreviation': val.substring(12) });
                }
            });
        } else if (form.id === "table_monitoring_detail_form") {
            validator.showErrors({ 'monitoring_description': data.substring(6) });
        } else if (form.id === "table_agreement_types_detail_form") {
            validator.showErrors({ 'agreement_description': data.substring(6) });
        }
    } else {
        if (utils.GLOBALS.elementToClickAfterSave === null) {
            $('#content').find('.tt-content-datatable').find('.tt-datatable-search').val("");
            if ($('#content').find('.tt-content-datatable').find('.tt-datatable').length) {
				$('#content').find('.tt-content-datatable').find('.tt-datatable').dataTable().fnFilterClear();
			}
            $('#content').find('.tt-content-datatable').find('.tt-delete,.tt-roles-overview').addClass('disabled');
            if (isNewItem) {
				$('#content').find('.tt-content-datatable').find('.tt-datatable').dataTable().fnStandingRedraw();
            }
        } else {
            $('#content').find('.tt-content-datatable').find('.tt-datatable').dataTable().fnStandingRedraw();
        }
        utils.setHtmlData($("#content-detail"), data, doInitializeElements);

		if (form.id === "table_aggregation_definition_detail_form") {
		    // Tabelle mit den bereits angelegten Aggregationsregeln neu laden
            var sourceModelId = '';
            var targetModelId = '';
			if ($('#table_aggregation_definition_form').find('[name="source_model"]').select2('data').length > 0 && $('#table_aggregation_definition_form').find('[name="source_model"]').select2('data')[0].id !== '') {
				sourceModelId = $('#table_aggregation_definition_form').find('[name="source_model"]').select2('data')[0].id;
			}
			if ($('#table_aggregation_definition_form').find('[name="target_model"]').select2('data').length > 0 && $('#table_aggregation_definition_form').find('[name="target_model"]').select2('data')[0].id !== '') {
				targetModelId = $('#table_aggregation_definition_form').find('[name="target_model"]').select2('data')[0].id;
			}

			reloadAggregationDefinitionList(sourceModelId, targetModelId, false);
		}

		if (isNewItem) {
			$(form).parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
        }
    }
}

function showNewDetailData(data, element, form, validator, doInitializeElements) {

    if (/^FAILS/.test(data)) {
        if (form.id === "table_users_create_form") {
            validator.showErrors({ 'username': data.substring(6) });
        } else if (form.id === "table_facilities_create_form") {
            data = data.substring(6);
            var splitted_data = data.split("|");

            jQuery.each(splitted_data, function (i, val) {

                if (/^ID/.test(val)) {
                    validator.showErrors({ 'facilityid': val.substring(2) });
                } else if (/^Name/.test(val)) {
                    validator.showErrors({ 'facilityname': val.substring(4) });
                }
            });
        } else if (form.id === "table_roles_create_form") {
            validator.showErrors({ 'rolename': data.substring(6) });
        } else if (form.id === "table_data_collection_types_create_form") {
            data = data.substring(6);
            var splitted_data = data.split("|");

            jQuery.each(splitted_data, function (i, val) {

                if (/^Model/.test(val)) {
                    validator.showErrors({ 'model': val.substring(5) });
                } else if (/^Abbreviation/.test(val)) {
                    validator.showErrors({ 'abbreviation': val.substring(12) });
                }
            });
        } else if (form.id === "table_monitoring_create_form") {
            validator.showErrors({ 'monitoring_description': data.substring(6) });
        } else if (form.id === "table_agreement_types_create_form") {
            validator.showErrors({ 'agreement_description': data.substring(6) });
        }
    } else {
        $('#content').find('.tt-content-datatable').find('.tt-delete').addClass('disabled');
        $('#content').find('.tt-content-datatable').find('.tt-datatable').dataTable().$('tr.selected-row').removeClass('selected-row');
        element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
        utils.setHtmlData($("#content-detail"), data, doInitializeElements);
        $("#content-detail").find('form').addClass('dirty');
    }
}

function showNewDataViewDetailData(data, element, form, doInitializeElements) {

    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
    utils.setHtmlData($("#content-detail"), data[0], doInitializeElements);
    utils.setHtmlData($("#content-detail-modal"), data[1], doInitializeElements);
    $('body').find('.modal-backdrop').remove();
    $("#content-detail").find('form').addClass('dirty');
}

function addAgreementTypeDocumentToList(data, element, form) {

    $("#table_agreement_type_documents").dataTable().fnAddData([
        '-1',
        element.find('.tt-document-description').val(),
        'documents/' + data]
    );

    $("#table_agreement_type_documents").dataTable().$('tr.selected-row').removeClass('selected-row');
    $("#content-detail").find('.tt-content-datatable').find('.tt-delete').addClass('disabled');
    if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
        $("#content-detail").find('.tt-datatable-changes').val("changed");
        $("#content-detail").find('form').trigger('checkform.areYouSure');
    }

    element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
}

function reloadAgreementTable(element) {

    return $.Deferred(function (defer) {

        $('#table_patient_agreement').parents('.tt-content-datatable').find('.tt-dialog-agreement-open').addClass('disabled');

        reloadPatientList(element, false).done(function (patientId) {

            if (patientId !== '') {
                patients.loadAgreementList($('.tt-nav-content-article').find('.tt-selected-id').val(), views.getPatientIsLocked()).done(function () {
                    defer.resolve();
                })
                //var url = $('#table_patient_agreement').dataTable().data().tableUrl.substring(0, $('#table_patient_agreement').dataTable().data().tableUrl.lastIndexOf('/')) + "/" + $('.tt-nav-content-article').find('.tt-selected-id').val() + "/datatable";
                //$('#table_patient_agreement').DataTable().ajax.url(url).load();
            } else {
                defer.resolve();
            }
        });
    }).promise();
}

function reloadPatientList(element, loadIdatData) {

    return $.Deferred(function(defer) {

        element.parents('.tt-content-dialog').find('.tt-dialog-cancel').click();

        patients.loadPatientlist(loadIdatData).done(function (patientData) {

            var patientId = $('.tt-nav-content-article').find('.tt-selected-id').val();
            var list_data = patients.getPatientlist(patientData);
            var foundPatient = false;
            for (var i = 0; i < list_data.length; i++) {
                if (list_data[i].id === parseInt(patientId)) {
                    foundPatient = true;
                    break;
                }
            }
            if (!foundPatient) {
                patientId = '';
            }
            $('#table_patientlist').dataTable().api().clear().rows.add(list_data).draw();

            if (patientId !== '' && parseInt(patientId) > 0) {
                $('#table_patientlist').DataTable().page.jumpToData(parseInt(patientId), 0);
                $('#table_patientlist').find('tr[id="' + patientId + '"]').addClass('selected-row');

                setDataCollectionTypesForPatient().done(function () {
                    setExaminationList(true);
                    defer.resolve(patientId);
                });
            } else {
                changes.cancelViews(true, true);
                defer.resolve(patientId);
            }
        });
    }).promise();
}

function reloadAggregationDefinitionList(sourceModelId, targetModelId, reinitializeTabSelection) {

    var aggregationTable = $('#table_aggregation_definition');
	var url = aggregationTable[0].getAttribute('data-table-url');
	url = url.substr(0, url.indexOf('/0/0')) + '/' + sourceModelId + '/' + targetModelId + '/datatable';

	aggregationTable.DataTable().clear().draw();
	aggregationTable.find('.dataTables_empty').text('').append('<h1><i class="fad fa-cog fa-spin"></i> ' + Lang.get('tripletrax.loading') + '...</h1>');
	ajax.ajaxCallDeferred(url, 'GET', null, false).done(function (data) {
		aggregationTable.dataTable().api().clear().rows.add(data[0]).draw();
		aggregationTable.parents('.tt-content-datatable').find('.tt-delete').addClass('disabled');

		if (reinitializeTabSelection) {
			var dataTabs = [{id: "", text: ""}];
			for (var key in data[1]) {
				dataTabs.push({id: key, text: data[1][key]});
			}
			var attributes = 'data-select2-placeholder="' + $('.tt-aggregation-tabs-restriction').attr('data-select2-placeholder') + '"';
			reinitializeSelect2($('.tt-aggregation-tabs-restriction').parent(), 'tt-select2 tt-aggregation-tabs-restriction', attributes, dataTabs, false);
		}
	});
}

function setDataCollectionTypesForPatient() {
    return $.Deferred(function(defer) {

        ajax.ajaxCallDeferred('doc/patient/patient/datacollectiontype/facility/' + views.getFacilityId() + '/patient/' + views.getPatientId(), 'GET', null, false)
            .done(function (data) {
                if (ajax.ajaxSucceeded(data)) {

                    var newData = [];
                    var foundModelId = false;
                    var modelId = views.getModelId();

                    // Wenn eine Untersuchung direkt ausgewählt werden soll, dann muss auch deren Datenerhebungsart gesetzt werden
                    var doChangeDataCollectionType = false;
                    if (!utils.isUndefined(utils.GLOBALS.modelToShow) && utils.GLOBALS.modelToShow !== '') {
                        if (modelId !== utils.GLOBALS.modelToShow) {
                            doChangeDataCollectionType = true;
                        }
                        modelId = utils.GLOBALS.modelToShow;
                        utils.updateGlobals('modelToShow', null);
                    }

                    jQuery.each(data, function (i, val) {

                        if (modelId == val.id) {
                            foundModelId = true;
                        }
                        newData.push({id: val.id, text: val.model, examinationdateFormat: val.examinationdate_format, helpExaminationdate: val.help_examinationdate_format, model: val.id, href: "doc/patient/patientlist/change/" + val.id, completenessNotification: val.completeness_notification, questionnaires: val.questionnaires});
                    });
                    var dataCollectionTypeSelectControls = $('#content-detail-patientlist').find('select.tt-data-collection-type');
                    if (utils.getMaster().find('.tt-data-collection-type').length) {
						$.merge(dataCollectionTypeSelectControls, utils.getMaster().find('select.tt-data-collection-type'));
                    }
					if (utils.getCourse().find('.tt-data-collection-type').length) {
						$.merge(dataCollectionTypeSelectControls, utils.getCourse().find('select.tt-data-collection-type'));
					}
					if (!utils.isUndefined(utils.getQuestionnaire()) && utils.getQuestionnaire().find('.tt-data-collection-type').length) {
						$.merge(dataCollectionTypeSelectControls, utils.getQuestionnaire().find('select.tt-data-collection-type'));
					}
                    $.each(dataCollectionTypeSelectControls, function(i, control) {
                    	if ($(control).parents('#content-detail-course,#content-detail-questionnaires,#content-detail-master').length) {
							reinitializeSelect2($(control).parent(), 'input-sm tt-select2 no-padding tt-data-collection-type tt-data-collection-type-additional select2-container', '', newData, false);
						} else {
							reinitializeSelect2($(control).parent(), 'input-sm tt-select2 no-padding tt-data-collection-type select2-container', '', newData, false);
						}
                    });

					dataCollectionTypeSelectControls = $('#content-detail-patientlist').find('.tt-data-collection-type');
					if (utils.getMaster().find('.tt-data-collection-type').length) {
						$.merge(dataCollectionTypeSelectControls, utils.getMaster().find('.tt-data-collection-type'));
					}
					if (utils.getCourse().find('.tt-data-collection-type').length) {
						$.merge(dataCollectionTypeSelectControls, utils.getCourse().find('.tt-data-collection-type'));
					}
					if (!utils.isUndefined(utils.getQuestionnaire()) && utils.getQuestionnaire().find('.tt-data-collection-type').length) {
						$.merge(dataCollectionTypeSelectControls, utils.getQuestionnaire().find('.tt-data-collection-type'));
					}

					$.each(dataCollectionTypeSelectControls, function(i, control) {
						$(control).data('data-collection', newData);
					});

                    if (foundModelId) {
						$.each(dataCollectionTypeSelectControls, function(i, control) {
							utils.updateGlobals('programmaticClick', true);
							$(control).val(modelId).trigger('change.select2');
							utils.updateGlobals('programmaticClick', false);
						});

                        if (doChangeDataCollectionType) {
                            changeDataCollectionType($(dataCollectionTypeSelectControls[0])).done(function() {
                                defer.resolve();
                            });
                        } else {
                            defer.resolve();
                        }
                    } else {
                        if (newData.length > 0) {
							dataCollectionTypeSelectControls.val(newData[0].id).trigger('change.select2');
                        }
                        changeDataCollectionType($(dataCollectionTypeSelectControls[0])).done(function() {
                            defer.resolve();
                        });
                    }
                } else {
                    defer.reject();
                }
            })
            .fail(function() {
                defer.reject();
            });
    }).promise();
}

function changeDataCollectionType(control) {
    return $.Deferred(function(defer) {

        var modelId = views.getModelId();
        var facilityId = views.getFacilityId();
        var patientId = views.getPatientId();
        var isActive = views.getPatientIsActive();
        var isLocked = views.getPatientIsLocked();

        var href = 'doc/patient/patientlist/change/0';
        if (!utils.isUndefined($(control).select2('val')) && $(control).select2('val') !== '') {
            href = 'doc/patient/patientlist/change/' + $(control).select2('val');
        }
		utils.getMaster().empty();
		utils.getCourse().empty();
		if (!utils.isUndefined(utils.getQuestionnaire())) {
			utils.getQuestionnaire().empty();
		}
        ajax.ajaxCallDeferred(href, 'GET', null, false)
            .done(function (data) {
                if (ajax.ajaxSucceeded(data)) {

                    // Navigation für Verlaufsdaten & Block mit Untersuchungen ausblenden, wenn ausgewählte Datenerhebungsart keine Verlaufsdaten zugeordnet hat
                    if (data.length <= 0) {
                        $('#doc_navigation_tab_course').addClass('hide');
                        $('#doc_navigation_tab_questionnaires').addClass('hide');
                        $('.tt-widget-examination').addClass('hide');
                    } else {
                        $('#doc_navigation_tab_course').removeClass('hide');
                        if (parseInt($('#doc_navigation_tab_questionnaires').data().countQuestionnaires) > 0) {
							$('#doc_navigation_tab_questionnaires').removeClass('hide');
						}
                        $('.tt-widget-examination').removeClass('hide');
                    }

                    $('#table_patient_examination').remove();
                    var html = '<table id="table_patient_examination" class="table-tripletrax table table-hover tt-datatable-data" data-table-selection-url="doc/patient/patient/examination" data-table-url="doc/patient/patientlist/examinations/facility/' + facilityId + '/model/' + modelId + '/patient/' + patientId + '/state/' + isActive + '/locked/' + isLocked + '" data-table-page-length="7" data-table-default-order-column="1" data-table-default-order-type="desc">' +
                        '   <thead>' +
                        '       <tr>' +
                        '           <th class="th-tripletrax" style="width: 0%">ID</th>' +
                        '           <th class="th-tripletrax" style="width: 5%">' + Lang.get('tripletrax.date') + '</th>';

                    var column_width = Math.floor(90 / data.length);

                    jQuery.each(data, function (i, tab) {
                        html += '           <th class="th-tripletrax tt-examination-column" style="width: ' + column_width + '%" data-column-name="' + tab.name + '">' + tab.desc + '</th>';
                    });

                    html +=
                        '       </tr>' +
                        '   </thead>' +
                        '</table>';

                    $('#table_patient_examination_wigdet').prepend(html);
                    ajax.initializeElements($('#table_patient_examination_wigdet'), true, false);

                    defer.resolve();
                } else {
                    defer.reject();
                }
            })
            .fail(function() {
                defer.reject();
            });
    }).promise();
}

function format (element) {
    if (!utils.isUndefined(element.element) && !utils.isUndefined($(element.element).data()) && !utils.isUndefined($(element.element).data().inactive) && $(element.element).data().inactive) {
        return $('<span class="tt-option-inactive">' + element.text + '</span>');
    } else if (!utils.isUndefined(element.element) && !utils.isUndefined($(element.element).data()) && !utils.isUndefined($(element.element).data().date) && $(element.element).data().date !== '') {
		return element.text + '  (' + utils.dateToLocaleLongTimeString($(element.element).data().date, true) + ')';
	} else if (!utils.isUndefined(element.element) && !utils.isUndefined($(element.element).data()) && !utils.isUndefined($(element.element).data().flag) && $(element.element).data().flag !== '') {
		return $('<span><img class="flag flag-' + $(element.element).data().flag + '"/> ' + element.text + '</span>');
    }
    return element.text;
}

function reinitializeSelect2(element, classString, attributeString, data, multiple, emptyPlaceholder) {

    var placeHolderString = Lang.get('tripletrax.no_selection');
    var noMoreDataString = Lang.get('tripletrax.no_more_data_existing');
    var noDataFoundString = Lang.get('tripletrax.no_data_found');
    var attribute = $(element.find('.tt-select2')[0]).attr('data-select2-placeholder');
    var allowClearAttribute = $(element.find('.tt-select2')[0]).attr('data-allow-clear');
    var name = $(element.find('.tt-select2')[0]).attr('name');
    var disabled = $(element.find('.tt-select2')[0]).attr('disabled');
    var style = $(element.find('.tt-select2')[0]).attr('style');
    var addOwnElement = /tt-multiple-select-own-entry/.test(classString);
    var upperCase = /tt-upper-case/.test(classString);
    var allowClear = true;

    if (!utils.isUndefined(attribute) && attribute !== '') {
        placeHolderString = Lang.get('tripletrax.' + attribute);
    }

	if (!utils.isUndefined(allowClearAttribute) && allowClearAttribute !== '') {
		allowClear = allowClearAttribute === 'true';
	}

    if (!utils.isUndefined(emptyPlaceholder) && emptyPlaceholder) {
        placeHolderString = '';
        noMoreDataString = '';
        noDataFoundString = '';
    }

	$(element).find('tt-select2').select2('destroy');
	element.empty();

	if ((!utils.isUndefined(emptyPlaceholder) && emptyPlaceholder) || multiple) {
		element.append('<select name="' + name + '" style="' + style + '" class="' + classString + '"' + attributeString + '></select>');
    } else {
		element.append('<select name="' + name + '" style="' + style + '" class="' + classString + '"' + attributeString + '><option></option></select>');
	}

    if (addOwnElement) {
        element.find('select').select2({
            placeholder: placeHolderString,
            allowClear: allowClear,
            tags: true,
            data: data,
            multiple: multiple,
            formatNoMatches: function (term) {
                if (term === '') {
                    return noMoreDataString;
                } else {
                    return noDataFoundString;
                }
            },
            createSearchChoice: function (term, data) {
                if (upperCase) {
					if ($(data).filter(function() {
					    return this.text.toUpperCase().localeCompare(term.toUpperCase())===0; }).length===0) {
						return {
							id: term.toUpperCase(),
							text: term.toUpperCase()
						}
					}
                } else {
					return {
						id: term,
						text: term
					}
				}
            },
            templateResult: function (element) {
				if (upperCase) {
					element.text.toUpperCase();
				} else {
				    return format(element);
                }
			},
			templateSelection: function (element) {
				if (upperCase) {
					element.text.toUpperCase();
				} else {
					return format(element);
				}
			}
        });
    } else {
        element.find('select').select2({
            placeholder: placeHolderString,
            allowClear: allowClear,
            data: data,
            multiple: multiple,
            formatNoMatches: function (term) {
                if (term === '') {
                    return noMoreDataString;
                } else {
                    return noDataFoundString;
                }
            },
            formatResult: format,
            formatSelection: format
        });
    }

    if (!utils.isUndefined(disabled)) {
        $(element.find('[name]')[0]).prop('disabled', disabled);
    }
}

function convertDateValue(value) {

    if (value === '')
    {
        return '';
    }

    var exportDateFormat = 'yyyy-mm-dd';

    if ($('[name="export_date_format"]').val() !== '') {
        exportDateFormat = $('[name="export_date_format"]').val();
    }

    var separator = exportDateFormat.replace('yyyy', '');
    separator = separator.replace('mm', '');
    separator = separator.replace('dd', '');
    separator = separator.substr(0, 1);

    var dateArray = value.split('-');
    if (dateArray.length != 3)
    {
        return '';
    }

    var year = dateArray[0];
    var month = dateArray[1];
    var day = dateArray[2];

    var dateFormatArray = exportDateFormat.split(separator);

    if (dateFormatArray[0] === 'yyyy')
    {
        if (dateFormatArray[1] === 'mm')
        {
            value = year + separator + month + separator + day;
        }
        else
        {
            value = year + separator + day + separator + month;
        }
    }
    else if (dateFormatArray[0] === 'mm')
    {
        if (dateFormatArray[1] === 'yyyy')
        {
            value = month + separator + year + separator + day;
        }
        else
        {
            value = month + separator + day + separator + year;
        }
    }
    else
    {
        if (dateFormatArray[1] === 'mm')
        {
            value = day + separator + month + separator + year;
        }
        else
        {
            value = day + separator + year + separator + month;
        }
    }

    return value;
}

function checkPatientAgreementExistingRecursive(model, models, existingModels, modelHierarchyArray) {

    if (model.depending_models === '' || model.depending_models === '-1') {
        if (jQuery.inArray(model.id, modelHierarchyArray) < 0) {
            modelHierarchyArray.push(model.id);
        }
        return true;
    }

    var agreementExisting = false;
    var dependingModels = model.depending_models.split('|');
    $.each(dependingModels, function (j, dependingModel) {
        if (jQuery.inArray(utils.stringToNumber(dependingModel), existingModels) >= 0) {
            if (jQuery.inArray(utils.stringToNumber(dependingModel), modelHierarchyArray) < 0) {
                modelHierarchyArray.push(utils.stringToNumber(dependingModel));
            }
            agreementExisting = true;
        }
    });

    if (agreementExisting) {
        return true;
    }

    return false;
}

function getDependingPatientAgreementExistingRecursive(model, models, modelHierarchyArray) {

    if (jQuery.inArray(model.id, modelHierarchyArray) < 0) {
        modelHierarchyArray.push(model.id);
    }
    $.each(models, function (i, modelToSearch) {
        if (modelToSearch.depending_models !== '' && modelToSearch.depending_models !== '-1') {
            var dependingModels = modelToSearch.depending_models.split('|');
            if (jQuery.inArray(String(model.id), dependingModels) >= 0) {
                getDependingPatientAgreementExistingRecursive(modelToSearch, models, modelHierarchyArray);
            }
        }
    });
}

function getExistingPatientAgreements(newEndDate) {
    var existingModels = [];
    $.each($('#table_patient_agreement').dataTable().fnGetData(), function (i, val) {
        // nur bestehende berücksichtigen, welche ja oder erneuerungspflichtig sind und kein Enddatum haben
        if ((val.agreement === 0 || val.agreement === 2) && (utils.isUndefined(val.end_date) || val.end_date === '' || (!utils.isUndefined(newEndDate) && utils.stringToDate(val.end_date) > utils.stringToDate(newEndDate)))) {
            var splittedModels = val.data_collection_types.split('|');
            $.each(splittedModels, function (j, model) {
                if (jQuery.inArray(model) < 0) {
                    existingModels.push(utils.stringToNumber(model));
                }
            });
        }
    });

    return existingModels;
}

module.exports.validatorMethods = validatorMethods;
module.exports.setValidationToForms = setValidationToForms;
module.exports.getRules = getRules;
module.exports.setDataCollectionTypesForPatient = setDataCollectionTypesForPatient;
module.exports.changeDataCollectionType = changeDataCollectionType;
module.exports.reinitializeSelect2 = reinitializeSelect2;
module.exports.format = format;
module.exports.setExaminationList = setExaminationList;
module.exports.setExaminationSelectionList = setExaminationSelectionList;
module.exports.setQuestionnaireSelectionList = setQuestionnaireSelectionList;
module.exports.setReportSelectionList = setReportSelectionList;
module.exports.setMasterContentVisible = setMasterContentVisible;
module.exports.setCourseContentVisible = setCourseContentVisible;
module.exports.setQuestionnaireContentVisible = setQuestionnaireContentVisible;
module.exports.setReportsContentVisible = setReportsContentVisible;
module.exports.setCompletenessContentVisible = setCompletenessContentVisible;
module.exports.showValidationMessage = showValidationMessage;
module.exports.doImport = doImport;
module.exports.doAggregation = doAggregation;
module.exports.doExport = doExport;
module.exports.goToControl = goToControl;
module.exports.triggerValidation = triggerValidation;
module.exports.checkPatientAgreementExistingRecursive = checkPatientAgreementExistingRecursive;
module.exports.getDependingPatientAgreementExistingRecursive = getDependingPatientAgreementExistingRecursive;
module.exports.getExistingPatientAgreements = getExistingPatientAgreements;
module.exports.openWindow = openWindow;
module.exports.saveExamination = saveExamination;
module.exports.checkForTransferDataViewFields = checkForTransferDataViewFields;
module.exports.reloadAggregationDefinitionList = reloadAggregationDefinitionList;
module.exports.addDynamicRules = addDynamicRules;
module.exports.addQuestionnairesRules = addQuestionnairesRules;
